const lokSabhaElectionData2024 = {
  "Jammu & Kashmir": [
    {
      id: 1,
      constituencyName: "Baramulla",
      primarySection: "Jammu & Kashmir",
      secondarySection: "Baramulla PC (Jammu & Kashmir)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-baramulla-constituency-result-3030179"
    },
    {
      id: 2,
      constituencyName: "Srinagar",
      primarySection: "Jammu & Kashmir",
      secondarySection: "Srinagar PC (Jammu & Kashmir)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-srinagar-constituency-result-3030180"
    },
    {
      id: 3,
      constituencyName: "Anantnag",
      primarySection: "Jammu & Kashmir",
      secondarySection: "Anantnag PC (Jammu & Kashmir)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-anantnag-constituency-result-3030181"
    },
    {
      id: 5,
      constituencyName: "Udhampur",
      primarySection: "Jammu & Kashmir",
      secondarySection: "Udhampur PC (Jammu & Kashmir)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-udhampur-constituency-result-3030183"
    },
    {
      id: 6,
      constituencyName: "Jammu",
      primarySection: "Jammu & Kashmir",
      secondarySection: "Jammu PC (Jammu & Kashmir)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jammu-constituency-result-3030184"
    }
  ],
  Ladakh: [
    {
      id: 4,
      constituencyName: "Ladakh",
      primarySection: "Ladakh",
      secondarySection: "Ladakh PC (Ladakh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ladakh-constituency-result-3030182"
    }
  ],
  "Himachal Pradesh": [
    {
      id: 7,
      constituencyName: "Kangra",
      primarySection: "Himachal Pradesh",
      secondarySection: "Kangra PC (Himachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kangra-constituency-result-3030185"
    },
    {
      id: 8,
      constituencyName: "Mandi",
      primarySection: "Himachal Pradesh",
      secondarySection: "Mandi PC (Himachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mandi-constituency-result-3030186"
    },
    {
      id: 9,
      constituencyName: "Hamirpur",
      primarySection: "Himachal Pradesh",
      secondarySection: "Hamirpur PC (Himachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hamirpur-constituency-result-3030187"
    },
    {
      id: 10,
      constituencyName: "Shimla",
      primarySection: "Himachal Pradesh",
      secondarySection: "Shimla PC (Himachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shimla-constituency-result-3030188"
    }
  ],
  Punjab: [
    {
      id: 11,
      constituencyName: "Gurdaspur",
      primarySection: "Punjab",
      secondarySection: "Gurdaspur PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gurdaspur-constituency-result-3030189"
    },
    {
      id: 12,
      constituencyName: "Amritsar",
      primarySection: "Punjab",
      secondarySection: "Amritsar PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amritsar-constituency-result-3030138"
    },
    {
      id: 13,
      constituencyName: "Khadoor Sahib",
      primarySection: "Punjab",
      secondarySection: "Khadoor Sahib PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khadoor-sahib-constituency-result-3030190"
    },
    {
      id: 14,
      constituencyName: "Jalandhar",
      primarySection: "Punjab",
      secondarySection: "Jalandhar PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalandhar-constituency-result-3030191"
    },
    {
      id: 15,
      constituencyName: "Hoshiarpur",
      primarySection: "Punjab",
      secondarySection: "Hoshiarpur PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hoshiarpur-constituency-result-3030192"
    },
    {
      id: 16,
      constituencyName: "Anandpur Sahib",
      primarySection: "Punjab",
      secondarySection: "Anandpur Sahib PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-anandpur-sahib-constituency-result-3030193"
    },
    {
      id: 17,
      constituencyName: "Ludhiana",
      primarySection: "Punjab",
      secondarySection: "Ludhiana PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ludhiana-constituency-result-3030194"
    },
    {
      id: 18,
      constituencyName: "Fatehgarh Sahib",
      primarySection: "Punjab",
      secondarySection: "Fatehgarh Sahib PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-fatehgarh-sahib-constituency-result-3030195"
    },
    {
      id: 19,
      constituencyName: "Faridkot",
      primarySection: "Punjab",
      secondarySection: "Faridkot PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-faridkot-constituency-result-3030196"
    },
    {
      id: 20,
      constituencyName: "Firozepur",
      primarySection: "Punjab",
      secondarySection: "Firozepur PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-firozepur-constituency-result-3030197"
    },
    {
      id: 21,
      constituencyName: "Bathinda",
      primarySection: "Punjab",
      secondarySection: "Bathinda PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bathinda-constituency-result-3030198"
    },
    {
      id: 22,
      constituencyName: "Sangrur",
      primarySection: "Punjab",
      secondarySection: "Sangrur PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sangrur-constituency-result-3030199"
    },
    {
      id: 23,
      constituencyName: "Patiala",
      primarySection: "Punjab",
      secondarySection: "Patiala PC (Punjab)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-patiala-constituency-result-3030200"
    }
  ],
  Chandigarh: [
    {
      id: 24,
      constituencyName: "Chandigarh",
      primarySection: "Chandigarh",
      secondarySection: "Chandigarh PC (Chandigarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chandigarh-constituency-result-3030201"
    }
  ],
  Uttarakhand: [
    {
      id: 25,
      constituencyName: "Tehri Garhwal",
      primarySection: "Uttarakhand",
      secondarySection: "Tehri Garhwal PC (Uttarakhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tehri-garhwal-constituency-result-3030202"
    },
    {
      id: 26,
      constituencyName: "Garhwal",
      primarySection: "Uttarakhand",
      secondarySection: "Garhwal PC (Uttarakhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-garhwal-constituency-result-3030203"
    },
    {
      id: 27,
      constituencyName: "Almora",
      primarySection: "Uttarakhand",
      secondarySection: "Almora PC (Uttarakhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-almora-constituency-result-3030204"
    },
    {
      id: 28,
      constituencyName: "Nainital-Udhamsingh Nagar",
      primarySection: "Uttarakhand",
      secondarySection: "Nainital-Udhamsingh Nagar PC (Uttarakhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nainital-udhamsingh-nagar-constituency-result-3030205"
    },
    {
      id: 29,
      constituencyName: "Haridwar",
      primarySection: "Uttarakhand",
      secondarySection: "Haridwar PC (Uttarakhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-haridwar-constituency-result-3030206"
    }
  ],
  Haryana: [
    {
      id: 30,
      constituencyName: "Ambala",
      primarySection: "Haryana",
      secondarySection: "Ambala PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ambala-constituency-result-3030207"
    },
    {
      id: 31,
      constituencyName: "Kurukshetra",
      primarySection: "Haryana",
      secondarySection: "Kurukshetra PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kurukshetra-constituency-result-3030208"
    },
    {
      id: 32,
      constituencyName: "Sirsa",
      primarySection: "Haryana",
      secondarySection: "Sirsa PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sirsa-constituency-result-3030209"
    },
    {
      id: 33,
      constituencyName: "Hisar",
      primarySection: "Haryana",
      secondarySection: "Hisar PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hisar-constituency-result-3030210"
    },
    {
      id: 34,
      constituencyName: "Karnal",
      primarySection: "Haryana",
      secondarySection: "Karnal PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karnal-constituency-result-3030211"
    },
    {
      id: 35,
      constituencyName: "Sonipat",
      primarySection: "Haryana",
      secondarySection: "Sonipat PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sonipat-constituency-result-3030212"
    },
    {
      id: 36,
      constituencyName: "Rohtak",
      primarySection: "Haryana",
      secondarySection: "Rohtak PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rohtak-constituency-result-3030213"
    },
    {
      id: 37,
      constituencyName: "Bhiwani-Mahendragarh",
      primarySection: "Haryana",
      secondarySection: "Bhiwani-Mahendragarh PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhiwani-mahendragarh-constituency-result-3030214"
    },
    {
      id: 38,
      constituencyName: "Gurgaon",
      primarySection: "Haryana",
      secondarySection: "Gurgaon PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gurgaon-constituency-result-3030215"
    },
    {
      id: 39,
      constituencyName: "Faridabad",
      primarySection: "Haryana",
      secondarySection: "Faridabad PC (Haryana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-faridabad-constituency-result-3030216"
    }
  ],
  Delhi: [
    {
      id: 40,
      constituencyName: "Chandni Chowk",
      primarySection: "Delhi",
      secondarySection: "Chandni Chowk PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chandni-chowk-constituency-result-3030217"
    },
    {
      id: 41,
      constituencyName: "North East Delhi",
      primarySection: "Delhi",
      secondarySection: "North East Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-north-east-delhi-constituency-result-3030218"
    },
    {
      id: 42,
      constituencyName: "East Delhi",
      primarySection: "Delhi",
      secondarySection: "East Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-east-delhi-constituency-result-3030219"
    },
    {
      id: 43,
      constituencyName: "New Delhi",
      primarySection: "Delhi",
      secondarySection: "New Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-new-delhi-constituency-result-3030220"
    },
    {
      id: 44,
      constituencyName: "North West Delhi",
      primarySection: "Delhi",
      secondarySection: "North West Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-north-west-delhi-constituency-result-3030221"
    },
    {
      id: 45,
      constituencyName: "West Delhi",
      primarySection: "Delhi",
      secondarySection: "West Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-west-delhi-constituency-result-3030222"
    },
    {
      id: 46,
      constituencyName: "South Delhi",
      primarySection: "Delhi",
      secondarySection: "South Delhi PC (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-south-delhi-constituency-result-3030223"
    }
  ],
  Rajasthan: [
    {
      id: 47,
      constituencyName: "Ganganagar",
      primarySection: "Rajasthan",
      secondarySection: "Ganganagar PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ganganagar-constituency-result-3030224"
    },
    {
      id: 48,
      constituencyName: "Bikaner",
      primarySection: "Rajasthan",
      secondarySection: "Bikaner PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bikaner-constituency-result-3030225"
    },
    {
      id: 49,
      constituencyName: "Churu",
      primarySection: "Rajasthan",
      secondarySection: "Churu PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-churu-constituency-result-3030226"
    },
    {
      id: 50,
      constituencyName: "Jhunjhunu",
      primarySection: "Rajasthan",
      secondarySection: "Jhunjhunu PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jhunjhunu-constituency-result-3030227"
    },
    {
      id: 51,
      constituencyName: "Sikar",
      primarySection: "Rajasthan",
      secondarySection: "Sikar PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sikar-constituency-result-3030228"
    },
    {
      id: 52,
      constituencyName: "Jaipur Rural",
      primarySection: "Rajasthan",
      secondarySection: "Jaipur Rural PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jaipur-rural-constituency-result-3030229"
    },
    {
      id: 53,
      constituencyName: "Jaipur",
      primarySection: "Rajasthan",
      secondarySection: "Jaipur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jaipur-constituency-result-3030230"
    },
    {
      id: 54,
      constituencyName: "Alwar",
      primarySection: "Rajasthan",
      secondarySection: "Alwar PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-alwar-constituency-result-3030231"
    },
    {
      id: 55,
      constituencyName: "Bharatpur",
      primarySection: "Rajasthan",
      secondarySection: "Bharatpur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bharatpur-constituency-result-3030232"
    },
    {
      id: 56,
      constituencyName: "Karauli-Dholpur",
      primarySection: "Rajasthan",
      secondarySection: "Karauli-Dholpur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karauli-dholpur-constituency-result-3030233"
    },
    {
      id: 57,
      constituencyName: "Dausa",
      primarySection: "Rajasthan",
      secondarySection: "Dausa PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dausa-constituency-result-3030234"
    },
    {
      id: 58,
      constituencyName: "Tonk-Sawai Madhopur",
      primarySection: "Rajasthan",
      secondarySection: "Tonk-Sawai Madhopur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tonk-sawai-madhopur-constituency-result-3030235"
    },
    {
      id: 59,
      constituencyName: "Ajmer",
      primarySection: "Rajasthan",
      secondarySection: "Ajmer PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ajmer-constituency-result-3030236"
    },
    {
      id: 60,
      constituencyName: "Nagaur",
      primarySection: "Rajasthan",
      secondarySection: "Nagaur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagaur-constituency-result-3030237"
    },
    {
      id: 61,
      constituencyName: "Pali",
      primarySection: "Rajasthan",
      secondarySection: "Pali PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pali-constituency-result-3030238"
    },
    {
      id: 62,
      constituencyName: "Jodhpur",
      primarySection: "Rajasthan",
      secondarySection: "Jodhpur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jodhpur-constituency-result-3030239"
    },
    {
      id: 63,
      constituencyName: "Barmer",
      primarySection: "Rajasthan",
      secondarySection: "Barmer PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-barmer-constituency-result-3030240"
    },
    {
      id: 64,
      constituencyName: "Jalore",
      primarySection: "Rajasthan",
      secondarySection: "Jalore PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalore-constituency-result-3030241"
    },
    {
      id: 65,
      constituencyName: "Udaipur",
      primarySection: "Rajasthan",
      secondarySection: "Udaipur PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-udaipur-constituency-result-3030242"
    },
    {
      id: 66,
      constituencyName: "Banswara",
      primarySection: "Rajasthan",
      secondarySection: "Banswara PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-banswara-constituency-result-3030243"
    },
    {
      id: 67,
      constituencyName: "Chittorgarh",
      primarySection: "Rajasthan",
      secondarySection: "Chittorgarh PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chittorgarh-constituency-result-3030244"
    },
    {
      id: 68,
      constituencyName: "Rajsamand",
      primarySection: "Rajasthan",
      secondarySection: "Rajsamand PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajsamand-constituency-result-3030245"
    },
    {
      id: 69,
      constituencyName: "Bhilwara",
      primarySection: "Rajasthan",
      secondarySection: "Bhilwara PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhilwara-constituency-result-3030246"
    },
    {
      id: 70,
      constituencyName: "Kota",
      primarySection: "Rajasthan",
      secondarySection: "Kota PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kota-constituency-result-3030247"
    },
    {
      id: 71,
      constituencyName: "Jhalawar-Baran",
      primarySection: "Rajasthan",
      secondarySection: "Jhalawar-Baran PC (Rajasthan)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jhalawar-baran-constituency-result-3030248"
    }
  ],
  "Uttar Pradesh": [
    {
      id: 72,
      constituencyName: "Saharanpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Saharanpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-saharanpur-constituency-result-3030249"
    },
    {
      id: 73,
      constituencyName: "Kairana",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kairana PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kairana-constituency-result-3030250"
    },
    {
      id: 74,
      constituencyName: "Muzaffarnagar",
      primarySection: "Uttar Pradesh",
      secondarySection: "Muzaffarnagar PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-muzaffarnagar-constituency-result-3030251"
    },
    {
      id: 75,
      constituencyName: "Bijnor",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bijnor PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bijnor-constituency-result-3030252"
    },
    {
      id: 76,
      constituencyName: "Nagina",
      primarySection: "Uttar Pradesh",
      secondarySection: "Nagina PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagina-constituency-result-3030253"
    },
    {
      id: 77,
      constituencyName: "Moradabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Moradabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-moradabad-constituency-result-3030254"
    },
    {
      id: 78,
      constituencyName: "Rampur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Rampur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rampur-constituency-result-3030255"
    },
    {
      id: 79,
      constituencyName: "Sambhal",
      primarySection: "Uttar Pradesh",
      secondarySection: "Sambhal PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sambhal-constituency-result-3030256"
    },
    {
      id: 80,
      constituencyName: "Amroha",
      primarySection: "Uttar Pradesh",
      secondarySection: "Amroha PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amroha-constituency-result-3030257"
    },
    {
      id: 81,
      constituencyName: "Meerut",
      primarySection: "Uttar Pradesh",
      secondarySection: "Meerut PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-meerut-constituency-result-3030258"
    },
    {
      id: 82,
      constituencyName: "Baghpat",
      primarySection: "Uttar Pradesh",
      secondarySection: "Baghpat PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-baghpat-constituency-result-3030259"
    },
    {
      id: 83,
      constituencyName: "Ghaziabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Ghaziabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ghaziabad-constituency-result-3030260"
    },
    {
      id: 84,
      constituencyName: "Gautam Buddha Nagar",
      primarySection: "Uttar Pradesh",
      secondarySection: "Gautam Buddha Nagar PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gautam-buddha-nagar-constituency-result-3030261"
    },
    {
      id: 85,
      constituencyName: "Bulandshahr",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bulandshahr PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bulandshahr-constituency-result-3030262"
    },
    {
      id: 86,
      constituencyName: "Aligarh",
      primarySection: "Uttar Pradesh",
      secondarySection: "Aligarh PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-aligarh-constituency-result-3030263"
    },
    {
      id: 87,
      constituencyName: "Hathras",
      primarySection: "Uttar Pradesh",
      secondarySection: "Hathras PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hathras-constituency-result-3030264"
    },
    {
      id: 88,
      constituencyName: "Mathura",
      primarySection: "Uttar Pradesh",
      secondarySection: "Mathura PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mathura-constituency-result-3030265"
    },
    {
      id: 89,
      constituencyName: "Agra",
      primarySection: "Uttar Pradesh",
      secondarySection: "Agra PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-agra-constituency-result-3030266"
    },
    {
      id: 90,
      constituencyName: "Fatehpur Sikri",
      primarySection: "Uttar Pradesh",
      secondarySection: "Fatehpur Sikri PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-fatehpur-sikri-constituency-result-3030267"
    },
    {
      id: 91,
      constituencyName: "Firozabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Firozabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-firozabad-constituency-result-3030268"
    },
    {
      id: 92,
      constituencyName: "Mainpuri",
      primarySection: "Uttar Pradesh",
      secondarySection: "Mainpuri PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mainpuri-constituency-result-3030269"
    },
    {
      id: 93,
      constituencyName: "Etah",
      primarySection: "Uttar Pradesh",
      secondarySection: "Etah PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-etah-constituency-result-3030270"
    },
    {
      id: 94,
      constituencyName: "Badaun",
      primarySection: "Uttar Pradesh",
      secondarySection: "Badaun PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-badaun-constituency-result-3030271"
    },
    {
      id: 95,
      constituencyName: "Aonla",
      primarySection: "Uttar Pradesh",
      secondarySection: "Aonla PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-aonla-constituency-result-3030272"
    },
    {
      id: 96,
      constituencyName: "Bareilly",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bareilly PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bareilly-constituency-result-3030273"
    },
    {
      id: 97,
      constituencyName: "Pilibhit",
      primarySection: "Uttar Pradesh",
      secondarySection: "Pilibhit PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pilibhit-constituency-result-3030274"
    },
    {
      id: 98,
      constituencyName: "Shahjahanpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Shahjahanpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shahjahanpur-constituency-result-3030275"
    },
    {
      id: 99,
      constituencyName: "Kheri",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kheri PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kheri-constituency-result-3030276"
    },
    {
      id: 100,
      constituencyName: "Dhaurahra",
      primarySection: "Uttar Pradesh",
      secondarySection: "Dhaurahra PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhaurahra-constituency-result-3030277"
    },
    {
      id: 101,
      constituencyName: "Sitapur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Sitapur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sitapur-constituency-result-3030278"
    },
    {
      id: 102,
      constituencyName: "Hardoi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Hardoi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hardoi-constituency-result-3030279"
    },
    {
      id: 103,
      constituencyName: "Misrikh",
      primarySection: "Uttar Pradesh",
      secondarySection: "Misrikh PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-misrikh-constituency-result-3030280"
    },
    {
      id: 104,
      constituencyName: "Unnao",
      primarySection: "Uttar Pradesh",
      secondarySection: "Unnao PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-unnao-constituency-result-3030281"
    },
    {
      id: 105,
      constituencyName: "Mohanlalganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Mohanlalganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mohanlalganj-constituency-result-3030282"
    },
    {
      id: 106,
      constituencyName: "Lucknow",
      primarySection: "Uttar Pradesh",
      secondarySection: "Lucknow PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-lucknow-constituency-result-3030283"
    },
    {
      id: 107,
      constituencyName: "Rae Bareli",
      primarySection: "Uttar Pradesh",
      secondarySection: "Rae Bareli PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rae-bareli-constituency-result-3030284"
    },
    {
      id: 108,
      constituencyName: "Amethi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Amethi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amethi-constituency-result-3030285"
    },
    {
      id: 109,
      constituencyName: "Sultanpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Sultanpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sultanpur-constituency-result-3030286"
    },
    {
      id: 110,
      constituencyName: "Pratapgarh",
      primarySection: "Uttar Pradesh",
      secondarySection: "Pratapgarh PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pratapgarh-constituency-result-3030287"
    },
    {
      id: 111,
      constituencyName: "Farrukhabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Farrukhabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-farrukhabad-constituency-result-3030288"
    },
    {
      id: 112,
      constituencyName: "Etawah",
      primarySection: "Uttar Pradesh",
      secondarySection: "Etawah PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-etawah-constituency-result-3030289"
    },
    {
      id: 113,
      constituencyName: "Kannauj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kannauj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kannauj-constituency-result-3030290"
    },
    {
      id: 114,
      constituencyName: "Kanpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kanpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kanpur-constituency-result-3030291"
    },
    {
      id: 115,
      constituencyName: "Akbarpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Akbarpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-akbarpur-constituency-result-3030292"
    },
    {
      id: 116,
      constituencyName: "Jalaun",
      primarySection: "Uttar Pradesh",
      secondarySection: "Jalaun PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalaun-constituency-result-3030293"
    },
    {
      id: 117,
      constituencyName: "Jhansi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Jhansi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jhansi-constituency-result-3030294"
    },
    {
      id: 118,
      constituencyName: "Hamirpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Hamirpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hamirpur-constituency-result-2-3030295"
    },
    {
      id: 119,
      constituencyName: "Banda",
      primarySection: "Uttar Pradesh",
      secondarySection: "Banda PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-banda-constituency-result-3030296"
    },
    {
      id: 120,
      constituencyName: "Fatehpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Fatehpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-fatehpur-constituency-result-3030297"
    },
    {
      id: 121,
      constituencyName: "Kaushambi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kaushambi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kaushambi-constituency-result-3030298"
    },
    {
      id: 122,
      constituencyName: "Phulpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Phulpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-phulpur-constituency-result-3030299"
    },
    {
      id: 123,
      constituencyName: "Allahabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Allahabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-allahabad-constituency-result-3030300"
    },
    {
      id: 124,
      constituencyName: "Barabanki",
      primarySection: "Uttar Pradesh",
      secondarySection: "Barabanki PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-barabanki-constituency-result-3030301"
    },
    {
      id: 125,
      constituencyName: "Faizabad",
      primarySection: "Uttar Pradesh",
      secondarySection: "Faizabad PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-faizabad-constituency-result-3030302"
    },
    {
      id: 126,
      constituencyName: "Ambedkar Nagar",
      primarySection: "Uttar Pradesh",
      secondarySection: "Ambedkar Nagar PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ambedkar-nagar-constituency-result-3030303"
    },
    {
      id: 127,
      constituencyName: "Bahraich",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bahraich PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bahraich-constituency-result-3030304"
    },
    {
      id: 128,
      constituencyName: "Kaiserganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kaiserganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kaiserganj-constituency-result-3030305"
    },
    {
      id: 129,
      constituencyName: "Shrawasti",
      primarySection: "Uttar Pradesh",
      secondarySection: "Shrawasti PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shrawasti-constituency-result-3030306"
    },
    {
      id: 130,
      constituencyName: "Gonda",
      primarySection: "Uttar Pradesh",
      secondarySection: "Gonda PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gonda-constituency-result-3030307"
    },
    {
      id: 131,
      constituencyName: "Domariyaganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Domariyaganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-domariyaganj-constituency-result-3030308"
    },
    {
      id: 132,
      constituencyName: "Basti",
      primarySection: "Uttar Pradesh",
      secondarySection: "Basti PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-basti-constituency-result-3030309"
    },
    {
      id: 133,
      constituencyName: "Sant Kabir Nagar",
      primarySection: "Uttar Pradesh",
      secondarySection: "Sant Kabir Nagar PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sant-kabir-nagar-constituency-result-3030310"
    },
    {
      id: 134,
      constituencyName: "Maharajganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Maharajganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-maharajganj-constituency-result-3030311"
    },
    {
      id: 135,
      constituencyName: "Gorakhpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Gorakhpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gorakhpur-constituency-result-3030312"
    },
    {
      id: 136,
      constituencyName: "Kushi Nagar",
      primarySection: "Uttar Pradesh",
      secondarySection: "Kushi Nagar PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kushi-nagar-constituency-result-3030313"
    },
    {
      id: 137,
      constituencyName: "Deoria",
      primarySection: "Uttar Pradesh",
      secondarySection: "Deoria PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-deoria-constituency-result-3030314"
    },
    {
      id: 138,
      constituencyName: "Bansgaon",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bansgaon PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bansgaon-constituency-result-3030315"
    },
    {
      id: 139,
      constituencyName: "Lalganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Lalganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-lalganj-constituency-result-3030316"
    },
    {
      id: 140,
      constituencyName: "Azamgarh",
      primarySection: "Uttar Pradesh",
      secondarySection: "Azamgarh PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-azamgarh-constituency-result-3030317"
    },
    {
      id: 141,
      constituencyName: "Ghosi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Ghosi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ghosi-constituency-result-3030318"
    },
    {
      id: 142,
      constituencyName: "Salempur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Salempur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-salempur-constituency-result-3030319"
    },
    {
      id: 143,
      constituencyName: "Ballia",
      primarySection: "Uttar Pradesh",
      secondarySection: "Ballia PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ballia-constituency-result-3030320"
    },
    {
      id: 144,
      constituencyName: "Jaunpur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Jaunpur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jaunpur-constituency-result-3030321"
    },
    {
      id: 145,
      constituencyName: "Machhlishahr",
      primarySection: "Uttar Pradesh",
      secondarySection: "Machhlishahr PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-machhlishahr-constituency-result-3030322"
    },
    {
      id: 146,
      constituencyName: "Ghazipur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Ghazipur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ghazipur-constituency-result-3030323"
    },
    {
      id: 147,
      constituencyName: "Chandauli",
      primarySection: "Uttar Pradesh",
      secondarySection: "Chandauli PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chandauli-constituency-result-3030324"
    },
    {
      id: 148,
      constituencyName: "Varanasi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Varanasi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-varanasi-constituency-result-3030325"
    },
    {
      id: 149,
      constituencyName: "Bhadohi",
      primarySection: "Uttar Pradesh",
      secondarySection: "Bhadohi PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhadohi-constituency-result-3030326"
    },
    {
      id: 150,
      constituencyName: "Mirzapur",
      primarySection: "Uttar Pradesh",
      secondarySection: "Mirzapur PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mirzapur-constituency-result-3030327"
    },
    {
      id: 151,
      constituencyName: "Robertsganj",
      primarySection: "Uttar Pradesh",
      secondarySection: "Robertsganj PC (Uttar Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-robertsganj-constituency-result-3030328"
    }
  ],
  Bihar: [
    {
      id: 152,
      constituencyName: "Valmiki Nagar",
      primarySection: "Bihar",
      secondarySection: "Valmiki Nagar PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-valmiki-nagar-constituency-result-3030329"
    },
    {
      id: 153,
      constituencyName: "Paschim Champaran",
      primarySection: "Bihar",
      secondarySection: "Paschim Champaran PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-paschim-champaran-constituency-result-3030330"
    },
    {
      id: 154,
      constituencyName: "Purvi Champaran",
      primarySection: "Bihar",
      secondarySection: "Purvi Champaran PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-purvi-champaran-constituency-result-3030331"
    },
    {
      id: 155,
      constituencyName: "Sheohar",
      primarySection: "Bihar",
      secondarySection: "Sheohar PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sheohar-constituency-result-3030332"
    },
    {
      id: 156,
      constituencyName: "Sitamarhi",
      primarySection: "Bihar",
      secondarySection: "Sitamarhi PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sitamarhi-constituency-result-3030333"
    },
    {
      id: 157,
      constituencyName: "Madhubani",
      primarySection: "Bihar",
      secondarySection: "Madhubani PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-madhubani-constituency-result-3030334"
    },
    {
      id: 158,
      constituencyName: "Jhanjharpur",
      primarySection: "Bihar",
      secondarySection: "Jhanjharpur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jhanjharpur-constituency-result-3030335"
    },
    {
      id: 159,
      constituencyName: "Supaul",
      primarySection: "Bihar",
      secondarySection: "Supaul PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-supaul-constituency-result-3030336"
    },
    {
      id: 160,
      constituencyName: "Araria",
      primarySection: "Bihar",
      secondarySection: "Araria PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-araria-constituency-result-3030337"
    },
    {
      id: 161,
      constituencyName: "Kishanganj",
      primarySection: "Bihar",
      secondarySection: "Kishanganj PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kishanganj-constituency-result-3030338"
    },
    {
      id: 162,
      constituencyName: "Katihar",
      primarySection: "Bihar",
      secondarySection: "Katihar PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-katihar-constituency-result-3030339"
    },
    {
      id: 163,
      constituencyName: "Purnia",
      primarySection: "Bihar",
      secondarySection: "Purnia PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-purnia-constituency-result-3030340"
    },
    {
      id: 164,
      constituencyName: "Madhepura",
      primarySection: "Bihar",
      secondarySection: "Madhepura PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-madhepura-constituency-result-3030341"
    },
    {
      id: 165,
      constituencyName: "Darbhanga",
      primarySection: "Bihar",
      secondarySection: "Darbhanga PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-darbhanga-constituency-result-3030342"
    },
    {
      id: 166,
      constituencyName: "Muzaffarpur",
      primarySection: "Bihar",
      secondarySection: "Muzaffarpur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-muzaffarpur-constituency-result-3030343"
    },
    {
      id: 167,
      constituencyName: "Vaishali",
      primarySection: "Bihar",
      secondarySection: "Vaishali PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vaishali-constituency-result-3030344"
    },
    {
      id: 168,
      constituencyName: "Gopalganj",
      primarySection: "Bihar",
      secondarySection: "Gopalganj PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gopalganj-constituency-result-3030345"
    },
    {
      id: 169,
      constituencyName: "Siwan",
      primarySection: "Bihar",
      secondarySection: "Siwan PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-siwan-constituency-result-3030346"
    },
    {
      id: 170,
      constituencyName: "Maharajganj",
      primarySection: "Bihar",
      secondarySection: "Maharajganj PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-maharajganj-constituency-result-2-3030347"
    },
    {
      id: 171,
      constituencyName: "Saran",
      primarySection: "Bihar",
      secondarySection: "Saran PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-saran-constituency-result-3030348"
    },
    {
      id: 172,
      constituencyName: "Hajipur",
      primarySection: "Bihar",
      secondarySection: "Hajipur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hajipur-constituency-result-3030349"
    },
    {
      id: 173,
      constituencyName: "Ujiarpur",
      primarySection: "Bihar",
      secondarySection: "Ujiarpur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ujiarpur-constituency-result-3030350"
    },
    {
      id: 174,
      constituencyName: "Samastipur",
      primarySection: "Bihar",
      secondarySection: "Samastipur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-samastipur-constituency-result-3030351"
    },
    {
      id: 175,
      constituencyName: "Begusarai",
      primarySection: "Bihar",
      secondarySection: "Begusarai PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-begusarai-constituency-result-3030352"
    },
    {
      id: 176,
      constituencyName: "Khagaria",
      primarySection: "Bihar",
      secondarySection: "Khagaria PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khagaria-constituency-result-3030353"
    },
    {
      id: 177,
      constituencyName: "Bhagalpur",
      primarySection: "Bihar",
      secondarySection: "Bhagalpur PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhagalpur-constituency-result-3030355"
    },
    {
      id: 178,
      constituencyName: "Banka",
      primarySection: "Bihar",
      secondarySection: "Banka PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-banka-constituency-result-3030358"
    },
    {
      id: 179,
      constituencyName: "Munger",
      primarySection: "Bihar",
      secondarySection: "Munger PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-munger-constituency-result-3030360"
    },
    {
      id: 180,
      constituencyName: "Nalanda",
      primarySection: "Bihar",
      secondarySection: "Nalanda PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nalanda-constituency-result-3030361"
    },
    {
      id: 181,
      constituencyName: "Patna Sahib",
      primarySection: "Bihar",
      secondarySection: "Patna Sahib PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-patna-sahib-constituency-result-3030362"
    },
    {
      id: 182,
      constituencyName: "Pataliputra",
      primarySection: "Bihar",
      secondarySection: "Pataliputra PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pataliputra-constituency-result-3030363"
    },
    {
      id: 183,
      constituencyName: "Arrah",
      primarySection: "Bihar",
      secondarySection: "Arrah PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arrah-constituency-result-3030364"
    },
    {
      id: 184,
      constituencyName: "Buxar",
      primarySection: "Bihar",
      secondarySection: "Buxar PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-buxar-constituency-result-3030365"
    },
    {
      id: 185,
      constituencyName: "Sasaram",
      primarySection: "Bihar",
      secondarySection: "Sasaram PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sasaram-constituency-result-3030366"
    },
    {
      id: 186,
      constituencyName: "Karakat",
      primarySection: "Bihar",
      secondarySection: "Karakat PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karakat-constituency-result-3030367"
    },
    {
      id: 187,
      constituencyName: "Jahanabad",
      primarySection: "Bihar",
      secondarySection: "Jahanabad PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jahanabad-constituency-result-3030368"
    },
    {
      id: 188,
      constituencyName: "Aurangabad",
      primarySection: "Bihar",
      secondarySection: "Aurangabad PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-aurangabad-constituency-result-3030369"
    },
    {
      id: 189,
      constituencyName: "Gaya",
      primarySection: "Bihar",
      secondarySection: "Gaya PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gaya-constituency-result-3030370"
    },
    {
      id: 190,
      constituencyName: "Nawada",
      primarySection: "Bihar",
      secondarySection: "Nawada PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nawada-constituency-result-3030371"
    },
    {
      id: 191,
      constituencyName: "Jamui",
      primarySection: "Bihar",
      secondarySection: "Jamui PC (Bihar)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jamui-constituency-result-3030372"
    }
  ],
  Sikkim: [
    {
      id: 192,
      constituencyName: "Sikkim",
      primarySection: "Sikkim",
      secondarySection: "Sikkim PC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sikkim-constituency-result-3030373"
    }
  ],
  "Arunachal Pradesh": [
    {
      id: 193,
      constituencyName: "Arunachal West",
      primarySection: "Arunachal Pradesh",
      secondarySection: "Arunachal West PC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arunachal-west-constituency-result-3030374"
    },
    {
      id: 194,
      constituencyName: "Arunachal East",
      primarySection: "Arunachal Pradesh",
      secondarySection: "Arunachal East PC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arunachal-east-constituency-result-3030375"
    }
  ],
  Nagaland: [
    {
      id: 195,
      constituencyName: "Nagaland",
      primarySection: "Nagaland",
      secondarySection: "Nagaland PC (Nagaland)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagaland-constituency-result-3030376"
    }
  ],
  Manipur: [
    {
      id: 196,
      constituencyName: "Inner Manipur",
      primarySection: "Manipur",
      secondarySection: "Inner Manipur PC (Manipur)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-inner-manipur-constituency-result-3030377"
    },
    {
      id: 197,
      constituencyName: "Outer Manipur",
      primarySection: "Manipur",
      secondarySection: "Outer Manipur PC (Manipur)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-outer-manipur-constituency-result-3030378"
    }
  ],
  Mizoram: [
    {
      id: 198,
      constituencyName: "Mizoram",
      primarySection: "Mizoram",
      secondarySection: "Mizoram PC (Mizoram)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mizoram-constituency-result-3030379"
    }
  ],
  Tripura: [
    {
      id: 199,
      constituencyName: "Tripura West",
      primarySection: "Tripura",
      secondarySection: "Tripura West PC (Tripura)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tripura-west-constituency-result-3030380"
    },
    {
      id: 200,
      constituencyName: "Tripura East",
      primarySection: "Tripura",
      secondarySection: "Tripura East PC (Tripura)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tripura-east-constituency-result-3030381"
    }
  ],
  Meghalaya: [
    {
      id: 201,
      constituencyName: "Shillong",
      primarySection: "Meghalaya",
      secondarySection: "Shillong PC (Meghalaya)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shillong-constituency-result-3030382"
    },
    {
      id: 202,
      constituencyName: "Tura",
      primarySection: "Meghalaya",
      secondarySection: "Tura PC (Meghalaya)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tura-constituency-result-3030383"
    }
  ],
  Assam: [
    {
      id: 203,
      constituencyName: "Karimganj",
      primarySection: "Assam",
      secondarySection: "Karimganj PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karimganj-constituency-result-3030384"
    },
    {
      id: 204,
      constituencyName: "Silchar",
      primarySection: "Assam",
      secondarySection: "Silchar PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-silchar-constituency-result-3030385"
    },
    {
      id: 205,
      constituencyName: "Autonomous District",
      primarySection: "Assam",
      secondarySection: "Autonomous District PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-autonomous-district-constituency-result-3030386"
    },
    {
      id: 206,
      constituencyName: "Dhubri",
      primarySection: "Assam",
      secondarySection: "Dhubri PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhubri-constituency-result-3030387"
    },
    {
      id: 207,
      constituencyName: "Kokrajhar",
      primarySection: "Assam",
      secondarySection: "Kokrajhar PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kokrajhar-constituency-result-3030388"
    },
    {
      id: 208,
      constituencyName: "Barpeta",
      primarySection: "Assam",
      secondarySection: "Barpeta PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-barpeta-constituency-result-3030389"
    },
    {
      id: 209,
      constituencyName: "Gauhati",
      primarySection: "Assam",
      secondarySection: "Gauhati PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gauhati-constituency-result-3030390"
    },
    {
      id: 210,
      constituencyName: "Mangaldoi",
      primarySection: "Assam",
      secondarySection: "Mangaldoi PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mangaldoi-constituency-result-3030391"
    },
    {
      id: 211,
      constituencyName: "Tezpur",
      primarySection: "Assam",
      secondarySection: "Tezpur PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tezpur-constituency-result-3030392"
    },
    {
      id: 212,
      constituencyName: "Nowgong",
      primarySection: "Assam",
      secondarySection: "Nowgong PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nowgong-constituency-result-3030393"
    },
    {
      id: 213,
      constituencyName: "Kaliabor",
      primarySection: "Assam",
      secondarySection: "Kaliabor PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kaliabor-constituency-result-3030394"
    },
    {
      id: 214,
      constituencyName: "Jorhat",
      primarySection: "Assam",
      secondarySection: "Jorhat PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jorhat-constituency-result-3030395"
    },
    {
      id: 215,
      constituencyName: "Dibrugarh",
      primarySection: "Assam",
      secondarySection: "Dibrugarh PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dibrugarh-constituency-result-3030396"
    },
    {
      id: 216,
      constituencyName: "Lakhimpur",
      primarySection: "Assam",
      secondarySection: "Lakhimpur PC (Assam)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-lakhimpur-constituency-result-3030397"
    }
  ],
  "West Bengal": [
    {
      id: 217,
      constituencyName: "Cooch Behar",
      primarySection: "West Bengal",
      secondarySection: "Cooch Behar PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-cooch-behar-constituency-result-3030398"
    },
    {
      id: 218,
      constituencyName: "Alipurduars",
      primarySection: "West Bengal",
      secondarySection: "Alipurduars PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-alipurduars-constituency-result-3030399"
    },
    {
      id: 219,
      constituencyName: "Jalpaiguri",
      primarySection: "West Bengal",
      secondarySection: "Jalpaiguri PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalpaiguri-constituency-result-3030400"
    },
    {
      id: 220,
      constituencyName: "Darjeeling",
      primarySection: "West Bengal",
      secondarySection: "Darjeeling PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-darjeeling-constituency-result-3030401"
    },
    {
      id: 221,
      constituencyName: "Raiganj",
      primarySection: "West Bengal",
      secondarySection: "Raiganj PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raiganj-constituency-result-3030402"
    },
    {
      id: 222,
      constituencyName: "Balurghat",
      primarySection: "West Bengal",
      secondarySection: "Balurghat PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-balurghat-constituency-result-3030403"
    },
    {
      id: 223,
      constituencyName: "Maldaha Uttar",
      primarySection: "West Bengal",
      secondarySection: "Maldaha Uttar PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-maldaha-uttar-constituency-result-3030404"
    },
    {
      id: 224,
      constituencyName: "Maldaha Dakshin",
      primarySection: "West Bengal",
      secondarySection: "Maldaha Dakshin PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-maldaha-dakshin-constituency-result-3030405"
    },
    {
      id: 225,
      constituencyName: "Jangipur",
      primarySection: "West Bengal",
      secondarySection: "Jangipur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jangipur-constituency-result-3030406"
    },
    {
      id: 226,
      constituencyName: "Baharampur",
      primarySection: "West Bengal",
      secondarySection: "Baharampur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-baharampur-constituency-result-3030407"
    },
    {
      id: 227,
      constituencyName: "Murshidabad",
      primarySection: "West Bengal",
      secondarySection: "Murshidabad PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-murshidabad-constituency-result-3030408"
    },
    {
      id: 228,
      constituencyName: "Krishnanagar",
      primarySection: "West Bengal",
      secondarySection: "Krishnanagar PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-krishnanagar-constituency-result-3030409"
    },
    {
      id: 229,
      constituencyName: "Ranaghat",
      primarySection: "West Bengal",
      secondarySection: "Ranaghat PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ranaghat-constituency-result-3030410"
    },
    {
      id: 230,
      constituencyName: "Bangaon",
      primarySection: "West Bengal",
      secondarySection: "Bangaon PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bangaon-constituency-result-3030411"
    },
    {
      id: 231,
      constituencyName: "Barrackpore",
      primarySection: "West Bengal",
      secondarySection: "Barrackpore PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-barrackpore-constituency-result-3030412"
    },
    {
      id: 232,
      constituencyName: "Dum Dum",
      primarySection: "West Bengal",
      secondarySection: "Dum Dum PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dum-dum-constituency-result-3030413"
    },
    {
      id: 233,
      constituencyName: "Barasat",
      primarySection: "West Bengal",
      secondarySection: "Barasat PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-barasat-constituency-result-3030414"
    },
    {
      id: 234,
      constituencyName: "Basirhat",
      primarySection: "West Bengal",
      secondarySection: "Basirhat PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-basirhat-constituency-result-3030415"
    },
    {
      id: 235,
      constituencyName: "Jaynagar",
      primarySection: "West Bengal",
      secondarySection: "Jaynagar PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jaynagar-constituency-result-3030416"
    },
    {
      id: 236,
      constituencyName: "Mathurapur",
      primarySection: "West Bengal",
      secondarySection: "Mathurapur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mathurapur-constituency-result-3030417"
    },
    {
      id: 237,
      constituencyName: "Diamond Harbour",
      primarySection: "West Bengal",
      secondarySection: "Diamond Harbour PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-diamond-harbour-constituency-result-3030418"
    },
    {
      id: 238,
      constituencyName: "Jadavpur",
      primarySection: "West Bengal",
      secondarySection: "Jadavpur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jadavpur-constituency-result-3030419"
    },
    {
      id: 239,
      constituencyName: "Kolkata Dakshin",
      primarySection: "West Bengal",
      secondarySection: "Kolkata Dakshin PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kolkata-dakshin-constituency-result-3030420"
    },
    {
      id: 240,
      constituencyName: "Kolkata Uttar",
      primarySection: "West Bengal",
      secondarySection: "Kolkata Uttar PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kolkata-uttar-constituency-result-3030421"
    },
    {
      id: 241,
      constituencyName: "Howrah",
      primarySection: "West Bengal",
      secondarySection: "Howrah PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-howrah-constituency-result-3030422"
    },
    {
      id: 242,
      constituencyName: "Uluberia",
      primarySection: "West Bengal",
      secondarySection: "Uluberia PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-uluberia-constituency-result-3030423"
    },
    {
      id: 243,
      constituencyName: "Sreerampur",
      primarySection: "West Bengal",
      secondarySection: "Sreerampur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sreerampur-constituency-result-3030424"
    },
    {
      id: 244,
      constituencyName: "Hooghly",
      primarySection: "West Bengal",
      secondarySection: "Hooghly PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hooghly-constituency-result-3030425"
    },
    {
      id: 245,
      constituencyName: "Arambagh",
      primarySection: "West Bengal",
      secondarySection: "Arambagh PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arambagh-constituency-result-3030426"
    },
    {
      id: 246,
      constituencyName: "Tamluk",
      primarySection: "West Bengal",
      secondarySection: "Tamluk PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tamluk-constituency-result-3030427"
    },
    {
      id: 247,
      constituencyName: "Kanthi",
      primarySection: "West Bengal",
      secondarySection: "Kanthi PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kanthi-constituency-result-3030428"
    },
    {
      id: 248,
      constituencyName: "Ghatal",
      primarySection: "West Bengal",
      secondarySection: "Ghatal PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ghatal-constituency-result-3030429"
    },
    {
      id: 249,
      constituencyName: "Jhargram",
      primarySection: "West Bengal",
      secondarySection: "Jhargram PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jhargram-constituency-result-3030430"
    },
    {
      id: 250,
      constituencyName: "Medinipur",
      primarySection: "West Bengal",
      secondarySection: "Medinipur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-medinipur-constituency-result-3030431"
    },
    {
      id: 251,
      constituencyName: "Purulia",
      primarySection: "West Bengal",
      secondarySection: "Purulia PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-purulia-constituency-result-3030432"
    },
    {
      id: 252,
      constituencyName: "Bankura",
      primarySection: "West Bengal",
      secondarySection: "Bankura PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bankura-constituency-result-3030433"
    },
    {
      id: 253,
      constituencyName: "Bishnupur",
      primarySection: "West Bengal",
      secondarySection: "Bishnupur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bishnupur-constituency-result-3030434"
    },
    {
      id: 254,
      constituencyName: "Bardhaman Purba",
      primarySection: "West Bengal",
      secondarySection: "Bardhaman Purba PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bardhaman-purba-constituency-result-3030435"
    },
    {
      id: 255,
      constituencyName: "Bardhaman-Durgapur",
      primarySection: "West Bengal",
      secondarySection: "Bardhaman-Durgapur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bardhaman-durgapur-constituency-result-3030436"
    },
    {
      id: 256,
      constituencyName: "Asansol",
      primarySection: "West Bengal",
      secondarySection: "Asansol PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-asansol-constituency-result-3030437"
    },
    {
      id: 257,
      constituencyName: "Bolpur",
      primarySection: "West Bengal",
      secondarySection: "Bolpur PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bolpur-constituency-result-3030438"
    },
    {
      id: 258,
      constituencyName: "Birbhum",
      primarySection: "West Bengal",
      secondarySection: "Birbhum PC (West Bengal)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-birbhum-constituency-result-3030439"
    }
  ],
  Jharkhand: [
    {
      id: 259,
      constituencyName: "Rajmahal",
      primarySection: "Jharkhand",
      secondarySection: "Rajmahal PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajmahal-constituency-result-3030440"
    },
    {
      id: 260,
      constituencyName: "Dumka",
      primarySection: "Jharkhand",
      secondarySection: "Dumka PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dumka-constituency-result-3030441"
    },
    {
      id: 261,
      constituencyName: "Godda",
      primarySection: "Jharkhand",
      secondarySection: "Godda PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-godda-constituency-result-3030442"
    },
    {
      id: 262,
      constituencyName: "Chatra",
      primarySection: "Jharkhand",
      secondarySection: "Chatra PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chatra-constituency-result-3030443"
    },
    {
      id: 263,
      constituencyName: "Kodarma",
      primarySection: "Jharkhand",
      secondarySection: "Kodarma PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kodarma-constituency-result-3030444"
    },
    {
      id: 264,
      constituencyName: "Giridih",
      primarySection: "Jharkhand",
      secondarySection: "Giridih PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-giridih-constituency-result-3030445"
    },
    {
      id: 265,
      constituencyName: "Dhanbad",
      primarySection: "Jharkhand",
      secondarySection: "Dhanbad PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhanbad-constituency-result-3030446"
    },
    {
      id: 266,
      constituencyName: "Ranchi",
      primarySection: "Jharkhand",
      secondarySection: "Ranchi PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ranchi-constituency-result-3030447"
    },
    {
      id: 267,
      constituencyName: "Jamshedpur",
      primarySection: "Jharkhand",
      secondarySection: "Jamshedpur PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jamshedpur-constituency-result-3030448"
    },
    {
      id: 268,
      constituencyName: "Singhbhum",
      primarySection: "Jharkhand",
      secondarySection: "Singhbhum PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-singhbhum-constituency-result-3030449"
    },
    {
      id: 269,
      constituencyName: "Khunti",
      primarySection: "Jharkhand",
      secondarySection: "Khunti PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khunti-constituency-result-3030450"
    },
    {
      id: 270,
      constituencyName: "Lohardaga",
      primarySection: "Jharkhand",
      secondarySection: "Lohardaga PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-lohardaga-constituency-result-3030451"
    },
    {
      id: 271,
      constituencyName: "Palamu",
      primarySection: "Jharkhand",
      secondarySection: "Palamu PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-palamu-constituency-result-3030452"
    },
    {
      id: 272,
      constituencyName: "Hazaribagh",
      primarySection: "Jharkhand",
      secondarySection: "Hazaribagh PC (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hazaribagh-constituency-result-3030453"
    }
  ],
  Odisha: [
    {
      id: 273,
      constituencyName: "Bargarh",
      primarySection: "Odisha",
      secondarySection: "Bargarh PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bargarh-constituency-result-3030454"
    },
    {
      id: 274,
      constituencyName: "Sundargarh",
      primarySection: "Odisha",
      secondarySection: "Sundargarh PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sundargarh-constituency-result-3030455"
    },
    {
      id: 275,
      constituencyName: "Sambalpur",
      primarySection: "Odisha",
      secondarySection: "Sambalpur PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sambalpur-constituency-result-3030456"
    },
    {
      id: 276,
      constituencyName: "Keonjhar",
      primarySection: "Odisha",
      secondarySection: "Keonjhar PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-keonjhar-constituency-result-3030457"
    },
    {
      id: 277,
      constituencyName: "Mayurbhanj",
      primarySection: "Odisha",
      secondarySection: "Mayurbhanj PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mayurbhanj-constituency-result-3030458"
    },
    {
      id: 278,
      constituencyName: "Balasore",
      primarySection: "Odisha",
      secondarySection: "Balasore PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-balasore-constituency-result-3030459"
    },
    {
      id: 279,
      constituencyName: "Bhadrak",
      primarySection: "Odisha",
      secondarySection: "Bhadrak PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhadrak-constituency-result-3030460"
    },
    {
      id: 280,
      constituencyName: "Jajpur",
      primarySection: "Odisha",
      secondarySection: "Jajpur PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jajpur-constituency-result-3030461"
    },
    {
      id: 281,
      constituencyName: "Dhenkanal",
      primarySection: "Odisha",
      secondarySection: "Dhenkanal PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhenkanal-constituency-result-3030462"
    },
    {
      id: 282,
      constituencyName: "Bolangir",
      primarySection: "Odisha",
      secondarySection: "Bolangir PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bolangir-constituency-result-3030463"
    },
    {
      id: 283,
      constituencyName: "Kalahandi",
      primarySection: "Odisha",
      secondarySection: "Kalahandi PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kalahandi-constituency-result-3030464"
    },
    {
      id: 284,
      constituencyName: "Nabarangpur",
      primarySection: "Odisha",
      secondarySection: "Nabarangpur PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nabarangpur-constituency-result-3030465"
    },
    {
      id: 285,
      constituencyName: "Kandhamal",
      primarySection: "Odisha",
      secondarySection: "Kandhamal PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kandhamal-constituency-result-3030466"
    },
    {
      id: 286,
      constituencyName: "Cuttack",
      primarySection: "Odisha",
      secondarySection: "Cuttack PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-cuttack-constituency-result-3030467"
    },
    {
      id: 287,
      constituencyName: "Kendrapara",
      primarySection: "Odisha",
      secondarySection: "Kendrapara PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kendrapara-constituency-result-3030468"
    },
    {
      id: 288,
      constituencyName: "Jagatsinghpur",
      primarySection: "Odisha",
      secondarySection: "Jagatsinghpur PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jagatsinghpur-constituency-result-3030469"
    },
    {
      id: 289,
      constituencyName: "Puri",
      primarySection: "Odisha",
      secondarySection: "Puri PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-puri-constituency-result-3030471"
    },
    {
      id: 290,
      constituencyName: "Bhubaneswar",
      primarySection: "Odisha",
      secondarySection: "Bhubaneswar PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhubaneswar-constituency-result-3030472"
    },
    {
      id: 291,
      constituencyName: "Aska",
      primarySection: "Odisha",
      secondarySection: "Aska PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-aska-constituency-result-3030473"
    },
    {
      id: 292,
      constituencyName: "Berhampur",
      primarySection: "Odisha",
      secondarySection: "Berhampur PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-berhampur-constituency-result-3030474"
    },
    {
      id: 293,
      constituencyName: "Koraput",
      primarySection: "Odisha",
      secondarySection: "Koraput PC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-koraput-constituency-result-3030475"
    }
  ],
  Chhattisgarh: [
    {
      id: 294,
      constituencyName: "Surguja",
      primarySection: "Chhattisgarh",
      secondarySection: "Surguja PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-surguja-constituency-result-3030476"
    },
    {
      id: 295,
      constituencyName: "Raigarh",
      primarySection: "Chhattisgarh",
      secondarySection: "Raigarh PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raigarh-constituency-result-3030477"
    },
    {
      id: 296,
      constituencyName: "Janjgir",
      primarySection: "Chhattisgarh",
      secondarySection: "Janjgir PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-janjgir-constituency-result-3030478"
    },
    {
      id: 297,
      constituencyName: "Korba",
      primarySection: "Chhattisgarh",
      secondarySection: "Korba PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-korba-constituency-result-3030479"
    },
    {
      id: 298,
      constituencyName: "Bilaspur",
      primarySection: "Chhattisgarh",
      secondarySection: "Bilaspur PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bilaspur-constituency-result-3030480"
    },
    {
      id: 299,
      constituencyName: "Rajnandgaon",
      primarySection: "Chhattisgarh",
      secondarySection: "Rajnandgaon PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajnandgaon-constituency-result-3030481"
    },
    {
      id: 300,
      constituencyName: "Durg",
      primarySection: "Chhattisgarh",
      secondarySection: "Durg PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-durg-constituency-result-3030482"
    },
    {
      id: 301,
      constituencyName: "Raipur",
      primarySection: "Chhattisgarh",
      secondarySection: "Raipur PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raipur-constituency-result-3030483"
    },
    {
      id: 302,
      constituencyName: "Mahasamund",
      primarySection: "Chhattisgarh",
      secondarySection: "Mahasamund PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mahasamund-constituency-result-3030484"
    },
    {
      id: 303,
      constituencyName: "Bastar",
      primarySection: "Chhattisgarh",
      secondarySection: "Bastar PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bastar-constituency-result-3030485"
    },
    {
      id: 304,
      constituencyName: "Kanker",
      primarySection: "Chhattisgarh",
      secondarySection: "Kanker PC (Chhattisgarh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kanker-constituency-result-3030486"
    }
  ],
  "Madhya Pradesh": [
    {
      id: 305,
      constituencyName: "Morena",
      primarySection: "Madhya Pradesh",
      secondarySection: "Morena PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-morena-constituency-result-3030487"
    },
    {
      id: 306,
      constituencyName: "Bhind",
      primarySection: "Madhya Pradesh",
      secondarySection: "Bhind PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhind-constituency-result-3030488"
    },
    {
      id: 307,
      constituencyName: "Gwalior",
      primarySection: "Madhya Pradesh",
      secondarySection: "Gwalior PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gwalior-constituency-result-3030489"
    },
    {
      id: 308,
      constituencyName: "Guna",
      primarySection: "Madhya Pradesh",
      secondarySection: "Guna PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-guna-constituency-result-3030490"
    },
    {
      id: 309,
      constituencyName: "Sagar",
      primarySection: "Madhya Pradesh",
      secondarySection: "Sagar PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sagar-constituency-result-3030491"
    },
    {
      id: 310,
      constituencyName: "Tikamgarh",
      primarySection: "Madhya Pradesh",
      secondarySection: "Tikamgarh PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tikamgarh-constituency-result-3030492"
    },
    {
      id: 311,
      constituencyName: "Damoh",
      primarySection: "Madhya Pradesh",
      secondarySection: "Damoh PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-damoh-constituency-result-3030493"
    },
    {
      id: 312,
      constituencyName: "Khajuraho",
      primarySection: "Madhya Pradesh",
      secondarySection: "Khajuraho PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khajuraho-constituency-result-3030494"
    },
    {
      id: 313,
      constituencyName: "Satna",
      primarySection: "Madhya Pradesh",
      secondarySection: "Satna PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-satna-constituency-result-3030495"
    },
    {
      id: 314,
      constituencyName: "Rewa",
      primarySection: "Madhya Pradesh",
      secondarySection: "Rewa PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rewa-constituency-result-3030496"
    },
    {
      id: 315,
      constituencyName: "Sidhi",
      primarySection: "Madhya Pradesh",
      secondarySection: "Sidhi PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sidhi-constituency-result-3030497"
    },
    {
      id: 316,
      constituencyName: "Shahdol",
      primarySection: "Madhya Pradesh",
      secondarySection: "Shahdol PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shahdol-constituency-result-3030498"
    },
    {
      id: 317,
      constituencyName: "Jabalpur",
      primarySection: "Madhya Pradesh",
      secondarySection: "Jabalpur PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jabalpur-constituency-result-3030499"
    },
    {
      id: 318,
      constituencyName: "Mandla",
      primarySection: "Madhya Pradesh",
      secondarySection: "Mandla PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mandla-constituency-result-3030500"
    },
    {
      id: 319,
      constituencyName: "Balaghat",
      primarySection: "Madhya Pradesh",
      secondarySection: "Balaghat PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-balaghat-constituency-result-3030501"
    },
    {
      id: 320,
      constituencyName: "Chhindwara",
      primarySection: "Madhya Pradesh",
      secondarySection: "Chhindwara PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chhindwara-constituency-result-3030502"
    },
    {
      id: 321,
      constituencyName: "Hoshangabad",
      primarySection: "Madhya Pradesh",
      secondarySection: "Hoshangabad PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hoshangabad-constituency-result-3030503"
    },
    {
      id: 322,
      constituencyName: "Vidisha",
      primarySection: "Madhya Pradesh",
      secondarySection: "Vidisha PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vidisha-constituency-result-3030504"
    },
    {
      id: 323,
      constituencyName: "Bhopal",
      primarySection: "Madhya Pradesh",
      secondarySection: "Bhopal PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhopal-constituency-result-3030505"
    },
    {
      id: 324,
      constituencyName: "Rajgarh",
      primarySection: "Madhya Pradesh",
      secondarySection: "Rajgarh PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajgarh-constituency-result-3030506"
    },
    {
      id: 325,
      constituencyName: "Dewas",
      primarySection: "Madhya Pradesh",
      secondarySection: "Dewas PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dewas-constituency-result-3030507"
    },
    {
      id: 326,
      constituencyName: "Ujjain",
      primarySection: "Madhya Pradesh",
      secondarySection: "Ujjain PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ujjain-constituency-result-3030508"
    },
    {
      id: 327,
      constituencyName: "Mandsaur",
      primarySection: "Madhya Pradesh",
      secondarySection: "Mandsaur PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mandsaur-constituency-result-3030509"
    },
    {
      id: 328,
      constituencyName: "Ratlam",
      primarySection: "Madhya Pradesh",
      secondarySection: "Ratlam PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ratlam-constituency-result-3030510"
    },
    {
      id: 329,
      constituencyName: "Dhar",
      primarySection: "Madhya Pradesh",
      secondarySection: "Dhar PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhar-constituency-result-3030511"
    },
    {
      id: 330,
      constituencyName: "Indore",
      primarySection: "Madhya Pradesh",
      secondarySection: "Indore PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-indore-constituency-result-3030512"
    },
    {
      id: 331,
      constituencyName: "Khargone",
      primarySection: "Madhya Pradesh",
      secondarySection: "Khargone PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khargone-constituency-result-3030513"
    },
    {
      id: 332,
      constituencyName: "Khandwa",
      primarySection: "Madhya Pradesh",
      secondarySection: "Khandwa PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khandwa-constituency-result-3030514"
    },
    {
      id: 333,
      constituencyName: "Betul",
      primarySection: "Madhya Pradesh",
      secondarySection: "Betul PC (Madhya Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-betul-constituency-result-3030515"
    }
  ],
  Gujarat: [
    {
      id: 334,
      constituencyName: "Kachchh",
      primarySection: "Gujarat",
      secondarySection: "Kachchh PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kachchh-constituency-result-3030516"
    },
    {
      id: 335,
      constituencyName: "Banaskantha",
      primarySection: "Gujarat",
      secondarySection: "Banaskantha PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-banaskantha-constituency-result-3030517"
    },
    {
      id: 336,
      constituencyName: "Patan",
      primarySection: "Gujarat",
      secondarySection: "Patan PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-patan-constituency-result-3030518"
    },
    {
      id: 337,
      constituencyName: "Mahesana",
      primarySection: "Gujarat",
      secondarySection: "Mahesana PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mahesana-constituency-result-3030519"
    },
    {
      id: 338,
      constituencyName: "Sabarkantha",
      primarySection: "Gujarat",
      secondarySection: "Sabarkantha PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sabarkantha-constituency-result-3030520"
    },
    {
      id: 339,
      constituencyName: "Gandhinagar",
      primarySection: "Gujarat",
      secondarySection: "Gandhinagar PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gandhinagar-constituency-result-3030521"
    },
    {
      id: 340,
      constituencyName: "Ahmedabad East",
      primarySection: "Gujarat",
      secondarySection: "Ahmedabad East PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ahmedabad-east-constituency-result-3030522"
    },
    {
      id: 341,
      constituencyName: "Ahmedabad West",
      primarySection: "Gujarat",
      secondarySection: "Ahmedabad West PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ahmedabad-west-constituency-result-3030523"
    },
    {
      id: 342,
      constituencyName: "Surendranagar",
      primarySection: "Gujarat",
      secondarySection: "Surendranagar PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-surendranagar-constituency-result-3030524"
    },
    {
      id: 343,
      constituencyName: "Rajkot",
      primarySection: "Gujarat",
      secondarySection: "Rajkot PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajkot-constituency-result-3030525"
    },
    {
      id: 344,
      constituencyName: "Porbandar",
      primarySection: "Gujarat",
      secondarySection: "Porbandar PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-porbandar-constituency-result-3030526"
    },
    {
      id: 345,
      constituencyName: "Jamnagar",
      primarySection: "Gujarat",
      secondarySection: "Jamnagar PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jamnagar-constituency-result-3030527"
    },
    {
      id: 346,
      constituencyName: "Junagadh",
      primarySection: "Gujarat",
      secondarySection: "Junagadh PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-junagadh-constituency-result-3030528"
    },
    {
      id: 347,
      constituencyName: "Amreli",
      primarySection: "Gujarat",
      secondarySection: "Amreli PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amreli-constituency-result-3030529"
    },
    {
      id: 348,
      constituencyName: "Bhavnagar",
      primarySection: "Gujarat",
      secondarySection: "Bhavnagar PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhavnagar-constituency-result-3030530"
    },
    {
      id: 349,
      constituencyName: "Anand",
      primarySection: "Gujarat",
      secondarySection: "Anand PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-anand-constituency-result-3030531"
    },
    {
      id: 350,
      constituencyName: "Kheda",
      primarySection: "Gujarat",
      secondarySection: "Kheda PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kheda-constituency-result-3030532"
    },
    {
      id: 351,
      constituencyName: "Panchmahal",
      primarySection: "Gujarat",
      secondarySection: "Panchmahal PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-panchmahal-constituency-result-3030533"
    },
    {
      id: 352,
      constituencyName: "Dahod",
      primarySection: "Gujarat",
      secondarySection: "Dahod PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dahod-constituency-result-3030534"
    },
    {
      id: 353,
      constituencyName: "Vadodara",
      primarySection: "Gujarat",
      secondarySection: "Vadodara PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vadodara-constituency-result-3030535"
    },
    {
      id: 354,
      constituencyName: "Chhota Udaipur",
      primarySection: "Gujarat",
      secondarySection: "Chhota Udaipur PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chhota-udaipur-constituency-result-3030536"
    },
    {
      id: 355,
      constituencyName: "Bharuch",
      primarySection: "Gujarat",
      secondarySection: "Bharuch PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bharuch-constituency-result-3030537"
    },
    {
      id: 356,
      constituencyName: "Bardoli",
      primarySection: "Gujarat",
      secondarySection: "Bardoli PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bardoli-constituency-result-3030538"
    },
    {
      id: 357,
      constituencyName: "Surat",
      primarySection: "Gujarat",
      secondarySection: "Surat PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-surat-constituency-result-3030539"
    },
    {
      id: 358,
      constituencyName: "Navsari",
      primarySection: "Gujarat",
      secondarySection: "Navsari PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-navsari-constituency-result-3030540"
    },
    {
      id: 359,
      constituencyName: "Valsad",
      primarySection: "Gujarat",
      secondarySection: "Valsad PC (Gujarat)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-valsad-constituency-result-3030541"
    }
  ],
  "Dadra & Nagar Haveli and Daman & Diu": [
    {
      id: 360,
      constituencyName: "Daman And Diu",
      primarySection: "Dadra & Nagar Haveli and Daman & Diu",
      secondarySection: "Daman And Diu PC (Daman & Diu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-daman-and-diu-constituency-result-3030542"
    },
    {
      id: 361,
      constituencyName: "Dadra And Nagar Haveli",
      primarySection: "Dadra & Nagar Haveli and Daman & Diu",
      secondarySection: "Dadra And Nagar Haveli PC (Dadra & Nagar Haveli)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dadra-and-nagar-haveli-constituency-result-3030543"
    }
  ],
  Maharashtra: [
    {
      id: 362,
      constituencyName: "Nandurbar",
      primarySection: "Maharashtra",
      secondarySection: "Nandurbar PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nandurbar-constituency-result-3030544"
    },
    {
      id: 363,
      constituencyName: "Dhule",
      primarySection: "Maharashtra",
      secondarySection: "Dhule PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dhule-constituency-result-3030545"
    },
    {
      id: 364,
      constituencyName: "Jalgaon",
      primarySection: "Maharashtra",
      secondarySection: "Jalgaon PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalgaon-constituency-result-3030546"
    },
    {
      id: 365,
      constituencyName: "Raver",
      primarySection: "Maharashtra",
      secondarySection: "Raver PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raver-constituency-result-3030547"
    },
    {
      id: 366,
      constituencyName: "Buldhana",
      primarySection: "Maharashtra",
      secondarySection: "Buldhana PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-buldhana-constituency-result-3030548"
    },
    {
      id: 367,
      constituencyName: "Akola",
      primarySection: "Maharashtra",
      secondarySection: "Akola PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-akola-constituency-result-3030549"
    },
    {
      id: 368,
      constituencyName: "Amravati",
      primarySection: "Maharashtra",
      secondarySection: "Amravati PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amravati-constituency-result-3030550"
    },
    {
      id: 369,
      constituencyName: "Wardha",
      primarySection: "Maharashtra",
      secondarySection: "Wardha PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-wardha-constituency-result-3030551"
    },
    {
      id: 370,
      constituencyName: "Ramtek",
      primarySection: "Maharashtra",
      secondarySection: "Ramtek PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ramtek-constituency-result-3030552"
    },
    {
      id: 371,
      constituencyName: "Nagpur",
      primarySection: "Maharashtra",
      secondarySection: "Nagpur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagpur-constituency-result-3030553"
    },
    {
      id: 372,
      constituencyName: "Bhandara-Gondiya",
      primarySection: "Maharashtra",
      secondarySection: "Bhandara-Gondiya PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhandara-gondiya-constituency-result-3030554"
    },
    {
      id: 373,
      constituencyName: "Gadchiroli-Chimur",
      primarySection: "Maharashtra",
      secondarySection: "Gadchiroli-Chimur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gadchiroli-chimur-constituency-result-3030555"
    },
    {
      id: 374,
      constituencyName: "Chandrapur",
      primarySection: "Maharashtra",
      secondarySection: "Chandrapur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chandrapur-constituency-result-3030556"
    },
    {
      id: 375,
      constituencyName: "Yavatmal-Washim",
      primarySection: "Maharashtra",
      secondarySection: "Yavatmal-Washim PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-yavatmal-washim-constituency-result-3030557"
    },
    {
      id: 376,
      constituencyName: "Hingoli",
      primarySection: "Maharashtra",
      secondarySection: "Hingoli PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hingoli-constituency-result-3030558"
    },
    {
      id: 377,
      constituencyName: "Nanded",
      primarySection: "Maharashtra",
      secondarySection: "Nanded PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nanded-constituency-result-3030560"
    },
    {
      id: 378,
      constituencyName: "Parbhani",
      primarySection: "Maharashtra",
      secondarySection: "Parbhani PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-parbhani-constituency-result-3030562"
    },
    {
      id: 379,
      constituencyName: "Jalna",
      primarySection: "Maharashtra",
      secondarySection: "Jalna PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-jalna-constituency-result-3030563"
    },
    {
      id: 380,
      constituencyName: "Aurangabad",
      primarySection: "Maharashtra",
      secondarySection: "Aurangabad PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-aurangabad-constituency-result-2-3030564"
    },
    {
      id: 381,
      constituencyName: "Dindori",
      primarySection: "Maharashtra",
      secondarySection: "Dindori PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dindori-constituency-result-3030565"
    },
    {
      id: 382,
      constituencyName: "Nashik",
      primarySection: "Maharashtra",
      secondarySection: "Nashik PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nashik-constituency-result-3030566"
    },
    {
      id: 383,
      constituencyName: "Palghar",
      primarySection: "Maharashtra",
      secondarySection: "Palghar PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-palghar-constituency-result-3030567"
    },
    {
      id: 384,
      constituencyName: "Bhiwandi",
      primarySection: "Maharashtra",
      secondarySection: "Bhiwandi PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhiwandi-constituency-result-3030568"
    },
    {
      id: 385,
      constituencyName: "Kalyan",
      primarySection: "Maharashtra",
      secondarySection: "Kalyan PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kalyan-constituency-result-3030569"
    },
    {
      id: 386,
      constituencyName: "Thane",
      primarySection: "Maharashtra",
      secondarySection: "Thane PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thane-constituency-result-3030570"
    },
    {
      id: 387,
      constituencyName: "Mumbai North",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai North PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-north-constituency-result-3030571"
    },
    {
      id: 388,
      constituencyName: "Mumbai North West",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai North West PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-north-west-constituency-result-3030572"
    },
    {
      id: 389,
      constituencyName: "Mumbai North East",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai North East PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-north-east-constituency-result-3030573"
    },
    {
      id: 390,
      constituencyName: "Mumbai North Central",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai North Central PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-north-central-constituency-result-3030574"
    },
    {
      id: 391,
      constituencyName: "Mumbai South",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai South PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-south-constituency-result-3030575"
    },
    {
      id: 392,
      constituencyName: "Mumbai South",
      primarySection: "Maharashtra",
      secondarySection: "Mumbai South PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mumbai-south-constituency-result-2-3030576"
    },
    {
      id: 393,
      constituencyName: "Raigad",
      primarySection: "Maharashtra",
      secondarySection: "Raigad PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raigad-constituency-result-3030577"
    },
    {
      id: 394,
      constituencyName: "Maval",
      primarySection: "Maharashtra",
      secondarySection: "Maval PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-maval-constituency-result-3030578"
    },
    {
      id: 395,
      constituencyName: "Pune",
      primarySection: "Maharashtra",
      secondarySection: "Pune PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pune-constituency-result-3030579"
    },
    {
      id: 396,
      constituencyName: "Baramati",
      primarySection: "Maharashtra",
      secondarySection: "Baramati PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-baramati-constituency-result-3030580"
    },
    {
      id: 397,
      constituencyName: "Shirur",
      primarySection: "Maharashtra",
      secondarySection: "Shirur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shirur-constituency-result-3030581"
    },
    {
      id: 398,
      constituencyName: "Ahmednagar",
      primarySection: "Maharashtra",
      secondarySection: "Ahmednagar PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ahmednagar-constituency-result-3030582"
    },
    {
      id: 399,
      constituencyName: "Shirdi",
      primarySection: "Maharashtra",
      secondarySection: "Shirdi PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shirdi-constituency-result-3030583"
    },
    {
      id: 400,
      constituencyName: "Beed",
      primarySection: "Maharashtra",
      secondarySection: "Beed PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-beed-constituency-result-3030584"
    },
    {
      id: 401,
      constituencyName: "Osmanabad",
      primarySection: "Maharashtra",
      secondarySection: "Osmanabad PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-osmanabad-constituency-result-3030585"
    },
    {
      id: 402,
      constituencyName: "Latur",
      primarySection: "Maharashtra",
      secondarySection: "Latur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-latur-constituency-result-3030586"
    },
    {
      id: 403,
      constituencyName: "Solapur",
      primarySection: "Maharashtra",
      secondarySection: "Solapur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-solapur-constituency-result-3030587"
    },
    {
      id: 404,
      constituencyName: "Madha",
      primarySection: "Maharashtra",
      secondarySection: "Madha PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-madha-constituency-result-3030588"
    },
    {
      id: 405,
      constituencyName: "Sangli",
      primarySection: "Maharashtra",
      secondarySection: "Sangli PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sangli-constituency-result-3030589"
    },
    {
      id: 406,
      constituencyName: "Satara",
      primarySection: "Maharashtra",
      secondarySection: "Satara PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-satara-constituency-result-3030590"
    },
    {
      id: 407,
      constituencyName: "Ratnagiri-Sindhudurg",
      primarySection: "Maharashtra",
      secondarySection: "Ratnagiri-Sindhudurg PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ratnagiri-sindhudurg-constituency-result-3030591"
    },
    {
      id: 408,
      constituencyName: "Kolhapur",
      primarySection: "Maharashtra",
      secondarySection: "Kolhapur PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kolhapur-constituency-result-3030592"
    },
    {
      id: 409,
      constituencyName: "Hatkanangle",
      primarySection: "Maharashtra",
      secondarySection: "Hatkanangle PC (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hatkanangle-constituency-result-3030593"
    }
  ],
  Telangana: [
    {
      id: 410,
      constituencyName: "Adilabad",
      primarySection: "Telangana",
      secondarySection: "Adilabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-adilabad-constituency-result-3030594"
    },
    {
      id: 411,
      constituencyName: "Peddapalli",
      primarySection: "Telangana",
      secondarySection: "Peddapalli PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-peddapalli-constituency-result-3030595"
    },
    {
      id: 412,
      constituencyName: "Karimnagar",
      primarySection: "Telangana",
      secondarySection: "Karimnagar PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karimnagar-constituency-result-3030596"
    },
    {
      id: 413,
      constituencyName: "Nizamabad",
      primarySection: "Telangana",
      secondarySection: "Nizamabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nizamabad-constituency-result-3030597"
    },
    {
      id: 414,
      constituencyName: "Zahirabad",
      primarySection: "Telangana",
      secondarySection: "Zahirabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-zahirabad-constituency-result-3030598"
    },
    {
      id: 415,
      constituencyName: "Medak",
      primarySection: "Telangana",
      secondarySection: "Medak PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-medak-constituency-result-3030599"
    },
    {
      id: 416,
      constituencyName: "Malkajgiri",
      primarySection: "Telangana",
      secondarySection: "Malkajgiri PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-malkajgiri-constituency-result-3030600"
    },
    {
      id: 417,
      constituencyName: "Secunderabad",
      primarySection: "Telangana",
      secondarySection: "Secunderabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-secunderabad-constituency-result-3030601"
    },
    {
      id: 418,
      constituencyName: "Hyderabad",
      primarySection: "Telangana",
      secondarySection: "Hyderabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hyderabad-constituency-result-3030602"
    },
    {
      id: 419,
      constituencyName: "Chevella",
      primarySection: "Telangana",
      secondarySection: "Chevella PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chevella-constituency-result-3030603"
    },
    {
      id: 420,
      constituencyName: "Mahabubnagar",
      primarySection: "Telangana",
      secondarySection: "Mahabubnagar PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mahabubnagar-constituency-result-3030604"
    },
    {
      id: 421,
      constituencyName: "Nagarkurnool",
      primarySection: "Telangana",
      secondarySection: "Nagarkurnool PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagarkurnool-constituency-result-3030605"
    },
    {
      id: 422,
      constituencyName: "Nalgonda",
      primarySection: "Telangana",
      secondarySection: "Nalgonda PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nalgonda-constituency-result-3030606"
    },
    {
      id: 423,
      constituencyName: "Bhuvanagiri",
      primarySection: "Telangana",
      secondarySection: "Bhuvanagiri PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bhuvanagiri-constituency-result-3030607"
    },
    {
      id: 424,
      constituencyName: "Warangal",
      primarySection: "Telangana",
      secondarySection: "Warangal PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-warangal-constituency-result-3030608"
    },
    {
      id: 425,
      constituencyName: "Mahabubabad",
      primarySection: "Telangana",
      secondarySection: "Mahabubabad PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mahabubabad-constituency-result-3030609"
    },
    {
      id: 426,
      constituencyName: "Khammam",
      primarySection: "Telangana",
      secondarySection: "Khammam PC (Telangana)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-khammam-constituency-result-3030610"
    }
  ],
  "Andhra Pradesh": [
    {
      id: 427,
      constituencyName: "Araku",
      primarySection: "Andhra Pradesh",
      secondarySection: "Araku PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-araku-constituency-result-3030611"
    },
    {
      id: 428,
      constituencyName: "Srikakulam",
      primarySection: "Andhra Pradesh",
      secondarySection: "Srikakulam PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-srikakulam-constituency-result-3030612"
    },
    {
      id: 429,
      constituencyName: "Vizianagaram",
      primarySection: "Andhra Pradesh",
      secondarySection: "Vizianagaram PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vizianagaram-constituency-result-3030613"
    },
    {
      id: 430,
      constituencyName: "Visakhapatnam",
      primarySection: "Andhra Pradesh",
      secondarySection: "Visakhapatnam PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-visakhapatnam-constituency-result-3030614"
    },
    {
      id: 431,
      constituencyName: "Anakapalli",
      primarySection: "Andhra Pradesh",
      secondarySection: "Anakapalli PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-anakapalli-constituency-result-3030615"
    },
    {
      id: 432,
      constituencyName: "Kakinada",
      primarySection: "Andhra Pradesh",
      secondarySection: "Kakinada PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kakinada-constituency-result-3030616"
    },
    {
      id: 433,
      constituencyName: "Amalapuram",
      primarySection: "Andhra Pradesh",
      secondarySection: "Amalapuram PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-amalapuram-constituency-result-3030617"
    },
    {
      id: 434,
      constituencyName: "Rajahmundry",
      primarySection: "Andhra Pradesh",
      secondarySection: "Rajahmundry PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajahmundry-constituency-result-3030618"
    },
    {
      id: 435,
      constituencyName: "Narsapuram",
      primarySection: "Andhra Pradesh",
      secondarySection: "Narsapuram PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-narsapuram-constituency-result-3030619"
    },
    {
      id: 436,
      constituencyName: "Eluru",
      primarySection: "Andhra Pradesh",
      secondarySection: "Eluru PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-eluru-constituency-result-3030620"
    },
    {
      id: 437,
      constituencyName: "Machilipatnam",
      primarySection: "Andhra Pradesh",
      secondarySection: "Machilipatnam PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-machilipatnam-constituency-result-3030621"
    },
    {
      id: 438,
      constituencyName: "Vijayawada",
      primarySection: "Andhra Pradesh",
      secondarySection: "Vijayawada PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vijayawada-constituency-result-3030622"
    },
    {
      id: 439,
      constituencyName: "Guntur",
      primarySection: "Andhra Pradesh",
      secondarySection: "Guntur PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-guntur-constituency-result-3030623"
    },
    {
      id: 440,
      constituencyName: "Narasaraopet",
      primarySection: "Andhra Pradesh",
      secondarySection: "Narasaraopet PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-narasaraopet-constituency-result-3030624"
    },
    {
      id: 441,
      constituencyName: "Bapatla",
      primarySection: "Andhra Pradesh",
      secondarySection: "Bapatla PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bapatla-constituency-result-3030625"
    },
    {
      id: 442,
      constituencyName: "Ongole",
      primarySection: "Andhra Pradesh",
      secondarySection: "Ongole PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ongole-constituency-result-3030626"
    },
    {
      id: 443,
      constituencyName: "Nandyal",
      primarySection: "Andhra Pradesh",
      secondarySection: "Nandyal PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nandyal-constituency-result-3030629"
    },
    {
      id: 444,
      constituencyName: "Kurnool",
      primarySection: "Andhra Pradesh",
      secondarySection: "Kurnool PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kurnool-constituency-result-3030630"
    },
    {
      id: 445,
      constituencyName: "Anantapuramu",
      primarySection: "Andhra Pradesh",
      secondarySection: "Anantapuramu PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-anantapuramu-constituency-result-3030632"
    },
    {
      id: 446,
      constituencyName: "Hindupur",
      primarySection: "Andhra Pradesh",
      secondarySection: "Hindupur PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-hindupur-constituency-result-3030633"
    },
    {
      id: 447,
      constituencyName: "Kadapa",
      primarySection: "Andhra Pradesh",
      secondarySection: "Kadapa PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kadapa-constituency-result-3030634"
    },
    {
      id: 448,
      constituencyName: "Nellore",
      primarySection: "Andhra Pradesh",
      secondarySection: "Nellore PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nellore-constituency-result-3030635"
    },
    {
      id: 449,
      constituencyName: "Tirupati",
      primarySection: "Andhra Pradesh",
      secondarySection: "Tirupati PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tirupati-constituency-result-3030636"
    },
    {
      id: 450,
      constituencyName: "Rajampet",
      primarySection: "Andhra Pradesh",
      secondarySection: "Rajampet PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-rajampet-constituency-result-3030637"
    },
    {
      id: 451,
      constituencyName: "Chittoor",
      primarySection: "Andhra Pradesh",
      secondarySection: "Chittoor PC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chittoor-constituency-result-3030638"
    }
  ],
  Karnataka: [
    {
      id: 452,
      constituencyName: "Chikodi",
      primarySection: "Karnataka",
      secondarySection: "Chikodi PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chikodi-constituency-result-3030639"
    },
    {
      id: 453,
      constituencyName: "Belagavi",
      primarySection: "Karnataka",
      secondarySection: "Belagavi PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-belagavi-constituency-result-3030640"
    },
    {
      id: 454,
      constituencyName: "Bagalkot",
      primarySection: "Karnataka",
      secondarySection: "Bagalkot PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bagalkot-constituency-result-3030641"
    },
    {
      id: 455,
      constituencyName: "Bijapur",
      primarySection: "Karnataka",
      secondarySection: "Bijapur PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bijapur-constituency-result-3030642"
    },
    {
      id: 456,
      constituencyName: "Gulbarga",
      primarySection: "Karnataka",
      secondarySection: "Gulbarga PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-gulbarga-constituency-result-3030643"
    },
    {
      id: 457,
      constituencyName: "Raichur",
      primarySection: "Karnataka",
      secondarySection: "Raichur PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-raichur-constituency-result-3030644"
    },
    {
      id: 458,
      constituencyName: "Bidar",
      primarySection: "Karnataka",
      secondarySection: "Bidar PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bidar-constituency-result-3030645"
    },
    {
      id: 459,
      constituencyName: "Koppal",
      primarySection: "Karnataka",
      secondarySection: "Koppal PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-koppal-constituency-result-3030646"
    },
    {
      id: 460,
      constituencyName: "Bellary",
      primarySection: "Karnataka",
      secondarySection: "Bellary PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bellary-constituency-result-3030647"
    },
    {
      id: 461,
      constituencyName: "Haveri",
      primarySection: "Karnataka",
      secondarySection: "Haveri PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-haveri-constituency-result-3030648"
    },
    {
      id: 462,
      constituencyName: "Dharwad",
      primarySection: "Karnataka",
      secondarySection: "Dharwad PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dharwad-constituency-result-3030649"
    },
    {
      id: 463,
      constituencyName: "Uttara Kannada",
      primarySection: "Karnataka",
      secondarySection: "Uttara Kannada PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-uttara-kannada-constituency-result-3030650"
    },
    {
      id: 464,
      constituencyName: "Davangere",
      primarySection: "Karnataka",
      secondarySection: "Davangere PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-davangere-constituency-result-3030651"
    },
    {
      id: 465,
      constituencyName: "Shimoga",
      primarySection: "Karnataka",
      secondarySection: "Shimoga PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-shimoga-constituency-result-3030652"
    },
    {
      id: 466,
      constituencyName: "Udupi Chikmagalur",
      primarySection: "Karnataka",
      secondarySection: "Udupi Chikmagalur PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-udupi-chikmagalur-constituency-result-3030653"
    },
    {
      id: 467,
      constituencyName: "Haasan",
      primarySection: "Karnataka",
      secondarySection: "Haasan PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-haasan-constituency-result-3030654"
    },
    {
      id: 468,
      constituencyName: "Dakshina Kannada",
      primarySection: "Karnataka",
      secondarySection: "Dakshina Kannada PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dakshina-kannada-constituency-result-3030655"
    },
    {
      id: 469,
      constituencyName: "Chitradurga",
      primarySection: "Karnataka",
      secondarySection: "Chitradurga PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chitradurga-constituency-result-3030656"
    },
    {
      id: 470,
      constituencyName: "Tumkur",
      primarySection: "Karnataka",
      secondarySection: "Tumkur PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tumkur-constituency-result-3030657"
    },
    {
      id: 471,
      constituencyName: "Mandya",
      primarySection: "Karnataka",
      secondarySection: "Mandya PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mandya-constituency-result-3030658"
    },
    {
      id: 472,
      constituencyName: "Mysore",
      primarySection: "Karnataka",
      secondarySection: "Mysore PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mysore-constituency-result-3030659"
    },
    {
      id: 473,
      constituencyName: "Chamarajanagar",
      primarySection: "Karnataka",
      secondarySection: "Chamarajanagar PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chamarajanagar-constituency-result-3030660"
    },
    {
      id: 474,
      constituencyName: "Bangalore Rural",
      primarySection: "Karnataka",
      secondarySection: "Bangalore Rural PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bangalore-rural-constituency-result-3030661"
    },
    {
      id: 475,
      constituencyName: "Bangalore North",
      primarySection: "Karnataka",
      secondarySection: "Bangalore North PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bangalore-north-constituency-result-3030662"
    },
    {
      id: 476,
      constituencyName: "Bangalore Central",
      primarySection: "Karnataka",
      secondarySection: "Bangalore Central PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bangalore-central-constituency-result-3030663"
    },
    {
      id: 477,
      constituencyName: "Bangalore South",
      primarySection: "Karnataka",
      secondarySection: "Bangalore South PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-bangalore-south-constituency-result-3030664"
    },
    {
      id: 478,
      constituencyName: "Chikballapur",
      primarySection: "Karnataka",
      secondarySection: "Chikballapur PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chikballapur-constituency-result-3030742"
    },
    {
      id: 479,
      constituencyName: "Kolar",
      primarySection: "Karnataka",
      secondarySection: "Kolar PC (Karnataka)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kolar-constituency-result-3030666"
    }
  ],
  Goa: [
    {
      id: 480,
      constituencyName: "North Goa",
      primarySection: "Goa",
      secondarySection: "North Goa PC (Goa)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-north-goa-constituency-result-3030667"
    },
    {
      id: 481,
      constituencyName: "South Goa",
      primarySection: "Goa",
      secondarySection: "South Goa PC (Goa)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-south-goa-constituency-result-3030668"
    }
  ],
  Lakshadweep: [
    {
      id: 482,
      constituencyName: "Lakshadweep",
      primarySection: "Lakshadweep",
      secondarySection: "Lakshadweep PC (Lakshadweep)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-lakshadweep-constituency-result-3030669"
    }
  ],
  Kerala: [
    {
      id: 483,
      constituencyName: "Kasaragod",
      primarySection: "Kerala",
      secondarySection: "Kasaragod PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kasaragod-constituency-result-3030670"
    },
    {
      id: 484,
      constituencyName: "Kannur",
      primarySection: "Kerala",
      secondarySection: "Kannur PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kannur-constituency-result-3030671"
    },
    {
      id: 485,
      constituencyName: "Vadakara",
      primarySection: "Kerala",
      secondarySection: "Vadakara PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vadakara-constituency-result-3030672"
    },
    {
      id: 486,
      constituencyName: "Wayanad",
      primarySection: "Kerala",
      secondarySection: "Wayanad PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-wayanad-constituency-result-3030673"
    },
    {
      id: 487,
      constituencyName: "Kozhikode",
      primarySection: "Kerala",
      secondarySection: "Kozhikode PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kozhikode-constituency-result-3030674"
    },
    {
      id: 488,
      constituencyName: "Malappuram",
      primarySection: "Kerala",
      secondarySection: "Malappuram PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-malappuram-constituency-result-3030675"
    },
    {
      id: 489,
      constituencyName: "Ponnani",
      primarySection: "Kerala",
      secondarySection: "Ponnani PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ponnani-constituency-result-3030676"
    },
    {
      id: 490,
      constituencyName: "Palakkad",
      primarySection: "Kerala",
      secondarySection: "Palakkad PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-palakkad-constituency-result-3030677"
    },
    {
      id: 491,
      constituencyName: "Alathur",
      primarySection: "Kerala",
      secondarySection: "Alathur PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-alathur-constituency-result-3030678"
    },
    {
      id: 492,
      constituencyName: "Thrissur",
      primarySection: "Kerala",
      secondarySection: "Thrissur PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thrissur-constituency-result-3030679"
    },
    {
      id: 493,
      constituencyName: "Chalakudy",
      primarySection: "Kerala",
      secondarySection: "Chalakudy PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chalakudy-constituency-result-3030680"
    },
    {
      id: 494,
      constituencyName: "Ernakulam",
      primarySection: "Kerala",
      secondarySection: "Ernakulam PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ernakulam-constituency-result-3030681"
    },
    {
      id: 495,
      constituencyName: "Idukki",
      primarySection: "Kerala",
      secondarySection: "Idukki PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-idukki-constituency-result-3030682"
    },
    {
      id: 496,
      constituencyName: "Kottayam",
      primarySection: "Kerala",
      secondarySection: "Kottayam PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kottayam-constituency-result-3030683"
    },
    {
      id: 497,
      constituencyName: "Alappuzha",
      primarySection: "Kerala",
      secondarySection: "Alappuzha PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-alappuzha-constituency-result-3030684"
    },
    {
      id: 498,
      constituencyName: "Mavelikara",
      primarySection: "Kerala",
      secondarySection: "Mavelikara PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mavelikara-constituency-result-3030685"
    },
    {
      id: 499,
      constituencyName: "Pathanamthitta",
      primarySection: "Kerala",
      secondarySection: "Pathanamthitta PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pathanamthitta-constituency-result-3030686"
    },
    {
      id: 500,
      constituencyName: "Kollam",
      primarySection: "Kerala",
      secondarySection: "Kollam PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kollam-constituency-result-3030687"
    },
    {
      id: 501,
      constituencyName: "Attingal",
      primarySection: "Kerala",
      secondarySection: "Attingal PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-attingal-constituency-result-3030688"
    },
    {
      id: 502,
      constituencyName: "Thiruvananthapuram",
      primarySection: "Kerala",
      secondarySection: "Thiruvananthapuram PC (Kerala)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thiruvananthapuram-constituency-result-3030689"
    }
  ],
  "Tamil Nadu": [
    {
      id: 503,
      constituencyName: "Thiruvallur",
      primarySection: "Tamil Nadu",
      secondarySection: "Thiruvallur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thiruvallur-constituency-result-3030690"
    },
    {
      id: 504,
      constituencyName: "Chennai North",
      primarySection: "Tamil Nadu",
      secondarySection: "Chennai North PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chennai-north-constituency-result-3030691"
    },
    {
      id: 505,
      constituencyName: "Chennai South",
      primarySection: "Tamil Nadu",
      secondarySection: "Chennai South PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chennai-south-constituency-result-3030692"
    },
    {
      id: 506,
      constituencyName: "Chennai Central",
      primarySection: "Tamil Nadu",
      secondarySection: "Chennai Central PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chennai-central-constituency-result-3030693"
    },
    {
      id: 507,
      constituencyName: "Sriperumbudur",
      primarySection: "Tamil Nadu",
      secondarySection: "Sriperumbudur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sriperumbudur-constituency-result-3030694"
    },
    {
      id: 508,
      constituencyName: "Kancheepuram",
      primarySection: "Tamil Nadu",
      secondarySection: "Kancheepuram PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kancheepuram-constituency-result-3030695"
    },
    {
      id: 509,
      constituencyName: "Arakkonam",
      primarySection: "Tamil Nadu",
      secondarySection: "Arakkonam PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arakkonam-constituency-result-3030696"
    },
    {
      id: 510,
      constituencyName: "Vellore",
      primarySection: "Tamil Nadu",
      secondarySection: "Vellore PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-vellore-constituency-result-3030697"
    },
    {
      id: 511,
      constituencyName: "Krishnagiri",
      primarySection: "Tamil Nadu",
      secondarySection: "Krishnagiri PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-krishnagiri-constituency-result-3030698"
    },
    {
      id: 512,
      constituencyName: "Dharmapuri",
      primarySection: "Tamil Nadu",
      secondarySection: "Dharmapuri PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dharmapuri-constituency-result-3030699"
    },
    {
      id: 513,
      constituencyName: "Tiruvannamalai",
      primarySection: "Tamil Nadu",
      secondarySection: "Tiruvannamalai PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tiruvannamalai-constituency-result-3030700"
    },
    {
      id: 514,
      constituencyName: "Arani",
      primarySection: "Tamil Nadu",
      secondarySection: "Arani PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-arani-constituency-result-3030701"
    },
    {
      id: 515,
      constituencyName: "Viluppuram",
      primarySection: "Tamil Nadu",
      secondarySection: "Viluppuram PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-viluppuram-constituency-result-3030702"
    },
    {
      id: 516,
      constituencyName: "Kallakurichi",
      primarySection: "Tamil Nadu",
      secondarySection: "Kallakurichi PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kallakurichi-constituency-result-3030703"
    },
    {
      id: 517,
      constituencyName: "Salem",
      primarySection: "Tamil Nadu",
      secondarySection: "Salem PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-salem-constituency-result-3030704"
    },
    {
      id: 518,
      constituencyName: "Namakkal",
      primarySection: "Tamil Nadu",
      secondarySection: "Namakkal PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-namakkal-constituency-result-3030705"
    },
    {
      id: 519,
      constituencyName: "Erode",
      primarySection: "Tamil Nadu",
      secondarySection: "Erode PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-erode-constituency-result-3030706"
    },
    {
      id: 520,
      constituencyName: "Tiruppur",
      primarySection: "Tamil Nadu",
      secondarySection: "Tiruppur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tiruppur-constituency-result-3030707"
    },
    {
      id: 521,
      constituencyName: "Nilgiris",
      primarySection: "Tamil Nadu",
      secondarySection: "Nilgiris PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nilgiris-constituency-result-3030708"
    },
    {
      id: 522,
      constituencyName: "Coimbatore",
      primarySection: "Tamil Nadu",
      secondarySection: "Coimbatore PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-coimbatore-constituency-result-3030709"
    },
    {
      id: 523,
      constituencyName: "Pollachi",
      primarySection: "Tamil Nadu",
      secondarySection: "Pollachi PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-pollachi-constituency-result-3030710"
    },
    {
      id: 524,
      constituencyName: "Dindigul",
      primarySection: "Tamil Nadu",
      secondarySection: "Dindigul PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-dindigul-constituency-result-3030711"
    },
    {
      id: 525,
      constituencyName: "Karur",
      primarySection: "Tamil Nadu",
      secondarySection: "Karur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-karur-constituency-result-3030712"
    },
    {
      id: 526,
      constituencyName: "Tiruchirappalli",
      primarySection: "Tamil Nadu",
      secondarySection: "Tiruchirappalli PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tiruchirappalli-constituency-result-3030713"
    },
    {
      id: 527,
      constituencyName: "Perambalur",
      primarySection: "Tamil Nadu",
      secondarySection: "Perambalur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-perambalur-constituency-result-3030714"
    },
    {
      id: 528,
      constituencyName: "Cuddalore",
      primarySection: "Tamil Nadu",
      secondarySection: "Cuddalore PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-cuddalore-constituency-result-3030715"
    },
    {
      id: 529,
      constituencyName: "Chidambaram",
      primarySection: "Tamil Nadu",
      secondarySection: "Chidambaram PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-chidambaram-constituency-result-3030716"
    },
    {
      id: 530,
      constituencyName: "Mayiladuturai",
      primarySection: "Tamil Nadu",
      secondarySection: "Mayiladuturai PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-mayiladuturai-constituency-result-3030717"
    },
    {
      id: 531,
      constituencyName: "Nagapattinam",
      primarySection: "Tamil Nadu",
      secondarySection: "Nagapattinam PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-nagapattinam-constituency-result-3030718"
    },
    {
      id: 532,
      constituencyName: "Thanjavur",
      primarySection: "Tamil Nadu",
      secondarySection: "Thanjavur PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thanjavur-constituency-result-3030719"
    },
    {
      id: 533,
      constituencyName: "Sivaganga",
      primarySection: "Tamil Nadu",
      secondarySection: "Sivaganga PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-sivaganga-constituency-result-3030720"
    },
    {
      id: 534,
      constituencyName: "Madurai",
      primarySection: "Tamil Nadu",
      secondarySection: "Madurai PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-madurai-constituency-result-3030721"
    },
    {
      id: 535,
      constituencyName: "Theni",
      primarySection: "Tamil Nadu",
      secondarySection: "Theni PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-theni-constituency-result-3030722"
    },
    {
      id: 536,
      constituencyName: "Virudhunagar",
      primarySection: "Tamil Nadu",
      secondarySection: "Virudhunagar PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-virudhunagar-constituency-result-3030723"
    },
    {
      id: 537,
      constituencyName: "Ramanathapuram",
      primarySection: "Tamil Nadu",
      secondarySection: "Ramanathapuram PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-ramanathapuram-constituency-result-3030724"
    },
    {
      id: 538,
      constituencyName: "Thoothukudi",
      primarySection: "Tamil Nadu",
      secondarySection: "Thoothukudi PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-thoothukudi-constituency-result-3030725"
    },
    {
      id: 539,
      constituencyName: "Tenkasi",
      primarySection: "Tamil Nadu",
      secondarySection: "Tenkasi PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tenkasi-constituency-result-3030726"
    },
    {
      id: 540,
      constituencyName: "Tirunelveli",
      primarySection: "Tamil Nadu",
      secondarySection: "Tirunelveli PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-tirunelveli-constituency-result-3030727"
    },
    {
      id: 541,
      constituencyName: "Kanyakumari",
      primarySection: "Tamil Nadu",
      secondarySection: "Kanyakumari PC (Tamil Nadu)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-kanyakumari-constituency-result-3030728"
    }
  ],
  Puducherry: [
    {
      id: 542,
      constituencyName: "Puducherry",
      primarySection: "Puducherry",
      secondarySection: "Puducherry PC (Puducherry)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-puducherry-constituency-result-3030729"
    }
  ],
  "Andaman & Nicobar Islands": [
    {
      id: 543,
      constituencyName: "Andaman & Nicobar Islands",
      primarySection: "Andaman & Nicobar Islands",
      secondarySection: "Andaman & Nicobar Islands PC (Andaman & Nicobar Islands)",
      publishedUrl:
        "https://www.deccanherald.com/elections/india/lok-sabha-elections-2024-andaman-and-nicobar-islands-constituency-result-3030730"
    }
  ]
};

const lokSabhaElectionData2024AllRecords = [];

Object.keys(lokSabhaElectionData2024).forEach((item) => {
  lokSabhaElectionData2024AllRecords.push(...lokSabhaElectionData2024[item]);
});

const lokSabhaElectionData2024StateSlugData = [
  {
    State: "Andhra Pradesh",
    redirectionUrl: "lok-sabha-elections-2024-andhra-pradesh"
  },
  {
    State: "Arunachal Pradesh",
    redirectionUrl: "lok-sabha-elections-2024-arunachal-pradesh"
  },
  {
    State: "Assam",
    redirectionUrl: "lok-sabha-elections-2024-assam"
  },
  {
    State: "Bihar",
    redirectionUrl: "lok-sabha-elections-2024-bihar"
  },
  {
    State: "Chhattisgarh",
    redirectionUrl: "lok-sabha-elections-2024-chhattisgarh"
  },
  {
    State: "Goa",
    redirectionUrl: "lok-sabha-elections-2024-goa"
  },
  {
    State: "Gujarat",
    redirectionUrl: "lok-sabha-elections-2024-gujarat"
  },
  {
    State: "Haryana",
    redirectionUrl: "lok-sabha-elections-2024-haryana"
  },
  {
    State: "Himachal Pradesh",
    redirectionUrl: "lok-sabha-elections-2024-himachal-pradesh"
  },
  {
    State: "Jharkhand",
    redirectionUrl: "lok-sabha-elections-2024-jharkhand"
  },
  {
    State: "Karnataka",
    redirectionUrl: "lok-sabha-elections-2024-karnataka"
  },
  {
    State: "Kerala",
    redirectionUrl: "lok-sabha-elections-2024-kerala"
  },
  {
    State: "Madhya Pradesh",
    redirectionUrl: "lok-sabha-elections-2024-madhya-pradesh"
  },
  {
    State: "Maharashtra",
    redirectionUrl: "lok-sabha-elections-2024-maharashtra"
  },
  {
    State: "Manipur",
    redirectionUrl: "lok-sabha-elections-2024-manipur"
  },
  {
    State: "Meghalaya",
    redirectionUrl: "lok-sabha-elections-2024-meghalaya"
  },
  {
    State: "Mizoram",
    redirectionUrl: "lok-sabha-elections-2024-mizoram"
  },
  {
    State: "Nagaland",
    redirectionUrl: "lok-sabha-elections-2024-nagaland"
  },
  {
    State: "Odisha",
    redirectionUrl: "lok-sabha-elections-2024-odisha"
  },
  {
    State: "Punjab",
    redirectionUrl: "lok-sabha-elections-2024-punjab"
  },
  {
    State: "Rajasthan",
    redirectionUrl: "lok-sabha-elections-2024-rajasthan"
  },
  {
    State: "Sikkim",
    redirectionUrl: "lok-sabha-elections-2024-sikkim"
  },
  {
    State: "Tamil Nadu",
    redirectionUrl: "lok-sabha-elections-2024-tamil-nadu"
  },
  {
    State: "Telangana",
    redirectionUrl: "lok-sabha-elections-2024-telangana"
  },
  {
    State: "Tripura",
    redirectionUrl: "lok-sabha-elections-2024-tripura"
  },
  {
    State: "Uttar Pradesh",
    redirectionUrl: "lok-sabha-elections-2024-uttar-pradesh"
  },
  {
    State: "Uttarakhand",
    redirectionUrl: "lok-sabha-elections-2024-uttarakhand"
  },
  {
    State: "West Bengal",
    redirectionUrl: "lok-sabha-elections-2024-west-bengal"
  },
  {
    State: "Andaman & Nicobar Islands",
    redirectionUrl: "lok-sabha-elections-2024-andaman-and-nicobar-islands"
  },
  {
    State: "Chandigarh",
    redirectionUrl: "lok-sabha-elections-2024-chandigarh"
  },
  {
    State: "Dadra & Nagar Haveli and Daman & Diu",
    redirectionUrl: "lok-sabha-elections-2024-dadra-and-nagar-haveli-and-daman-and-diu"
  },
  {
    State: "Delhi",
    redirectionUrl: "lok-sabha-elections-2024-delhi"
  },
  {
    State: "Jammu & Kashmir",
    redirectionUrl: "lok-sabha-elections-2024-jammu-and-kashmir"
  },
  {
    State: "Ladakh",
    redirectionUrl: "lok-sabha-elections-2024-ladakh"
  },
  {
    State: "Lakshadweep",
    redirectionUrl: "lok-sabha-elections-2024-lakshadweep"
  },
  {
    State: "Puducherry",
    redirectionUrl: "lok-sabha-elections-2024-puducherry"
  }
];

const stateElections2024SlugData = [
  {
    state: "ANDHRA PRADESH",
    slug: "andhra-pradesh-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "ODISHA",
    slug: "odisha-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "ARUNACHAL PRADESH",
    slug: "arunachal-pradesh-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "SIKKIM",
    slug: "sikkim-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "ANDHRA PRADESH",
    slug: "assembly-elections-2024",
    showStateTabs: true
  }
];

const stateElections2024ConstituencyData = {
  "ANDHRA PRADESH": [
    {
      id: 1,
      constituencyName: "Ichchapuram",
      secondarySection: "Ichchapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-ichchapuram-constituency-result-3009366"
    },
    {
      id: 2,
      constituencyName: "Palasa",
      secondarySection: "Palasa AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-palasa-constituency-result-3009393"
    },
    {
      id: 3,
      constituencyName: "Tekkali",
      secondarySection: "Tekkali AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tekkali-constituency-result-3009394"
    },
    {
      id: 4,
      constituencyName: "Pathapatnam",
      secondarySection: "Pathapatnam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pathapatnam-constituency-result-3009395"
    },
    {
      id: 5,
      constituencyName: "Srikakulam",
      secondarySection: "Srikakulam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-srikakulam-constituency-result-3009396"
    },
    {
      id: 6,
      constituencyName: "Amadalavalasa",
      secondarySection: "Amadalavalasa AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-amadalavalasa-constituency-result-3009397"
    },
    {
      id: 7,
      constituencyName: "Etcherla",
      secondarySection: "Etcherla AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-etcherla-constituency-result-3009398"
    },
    {
      id: 8,
      constituencyName: "Narasannapeta",
      secondarySection: "Narasannapeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-narasannapeta-constituency-result-3009399"
    },
    {
      id: 9,
      constituencyName: "Rajam ",
      secondarySection: "Rajam  AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rajam-sc-constituency-result-3009400"
    },
    {
      id: 10,
      constituencyName: "Palakonda  ",
      secondarySection: "Palakonda   AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-palakonda-st-constituency-result-3009401"
    },
    {
      id: 11,
      constituencyName: "Kurupam",
      secondarySection: "Kurupam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kurupam-constituency-result-3009402"
    },
    {
      id: 12,
      constituencyName: "Parvathipuram",
      secondarySection: "Parvathipuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-parvathipuram-constituency-result-3009403"
    },
    {
      id: 13,
      constituencyName: "Salur",
      secondarySection: "Salur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-salur-constituency-result-3009404"
    },
    {
      id: 14,
      constituencyName: "Bobbili",
      secondarySection: "Bobbili AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-bobbili-constituency-result-3009405"
    },
    {
      id: 15,
      constituencyName: "Cheepurupalli",
      secondarySection: "Cheepurupalli AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-cheepurupalli-constituency-result-3009406"
    },
    {
      id: 16,
      constituencyName: "Gajapathinagaram",
      secondarySection: "Gajapathinagaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gajapathinagaram-constituency-result-3009407"
    },
    {
      id: 17,
      constituencyName: "Nellimarla",
      secondarySection: "Nellimarla AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nellimarla-constituency-result-3009408"
    },
    {
      id: 18,
      constituencyName: "Vizianagaram",
      secondarySection: "Vizianagaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vizianagaram-constituency-result-3009409"
    },
    {
      id: 19,
      constituencyName: "Srungavarapukota",
      secondarySection: "Srungavarapukota AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-srungavarapukota-constituency-result-3009410"
    },
    {
      id: 20,
      constituencyName: "Bhimli",
      secondarySection: "Bhimli AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-bhimli-constituency-result-3009411"
    },
    {
      id: 21,
      constituencyName: "Visakhapatnam East",
      secondarySection: "Visakhapatnam East AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-visakhapatnam-east-constituency-result-3009412"
    },
    {
      id: 22,
      constituencyName: "Visakhapatnam South",
      secondarySection: "Visakhapatnam South AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-visakhapatnam-south-constituency-result-3009413"
    },
    {
      id: 23,
      constituencyName: "Visakhapatnam  North",
      secondarySection: "Visakhapatnam  North AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-visakhapatnam-north-constituency-result-3009414"
    },
    {
      id: 24,
      constituencyName: "Visakhapatnam  West",
      secondarySection: "Visakhapatnam  West AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-visakhapatnam-west-constituency-result-3009415"
    },
    {
      id: 25,
      constituencyName: "Gajuwaka",
      secondarySection: "Gajuwaka AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gajuwaka-constituency-result-3009416"
    },
    {
      id: 26,
      constituencyName: "Chodavaram",
      secondarySection: "Chodavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chodavaram-constituency-result-3009417"
    },
    {
      id: 27,
      constituencyName: "Madugula",
      secondarySection: "Madugula AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-madugula-constituency-result-3009418"
    },
    {
      id: 28,
      constituencyName: "Araku Valley",
      secondarySection: "Araku Valley AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-araku-valley-constituency-result-3009419"
    },
    {
      id: 29,
      constituencyName: "Paderu",
      secondarySection: "Paderu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-paderu-constituency-result-3009420"
    },
    {
      id: 30,
      constituencyName: "Anakapalli",
      secondarySection: "Anakapalli AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-anakapalli-constituency-result-3009421"
    },
    {
      id: 31,
      constituencyName: "Pendurthi",
      secondarySection: "Pendurthi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pendurthi-constituency-result-3009422"
    },
    {
      id: 32,
      constituencyName: "Elamanchili",
      secondarySection: "Elamanchili AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-elamanchili-constituency-result-3009423"
    },
    {
      id: 33,
      constituencyName: "Payakaraopeta",
      secondarySection: "Payakaraopeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-payakaraopeta-constituency-result-3009424"
    },
    {
      id: 34,
      constituencyName: "Narsipatnam",
      secondarySection: "Narsipatnam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-narsipatnam-constituency-result-3009425"
    },
    {
      id: 35,
      constituencyName: "Tuni",
      secondarySection: "Tuni AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tuni-constituency-result-3009426"
    },
    {
      id: 36,
      constituencyName: "Prathipadu",
      secondarySection: "Prathipadu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-prathipadu-constituency-result-3009427"
    },
    {
      id: 37,
      constituencyName: "Pithapuram",
      secondarySection: "Pithapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pithapuram-constituency-result-3009428"
    },
    {
      id: 38,
      constituencyName: "Kakinada Rural",
      secondarySection: "Kakinada Rural AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kakinada-rural-constituency-result-3009429"
    },
    {
      id: 39,
      constituencyName: "Peddapuram",
      secondarySection: "Peddapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-peddapuram-constituency-result-3009430"
    },
    {
      id: 40,
      constituencyName: "Anaparthy",
      secondarySection: "Anaparthy AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-anaparthy-constituency-result-3009431"
    },
    {
      id: 41,
      constituencyName: "Kakinada City",
      secondarySection: "Kakinada City AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kakinada-city-constituency-result-3009432"
    },
    {
      id: 42,
      constituencyName: "Ramachandrapuram",
      secondarySection: "Ramachandrapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-ramachandrapuram-constituency-result-3009433"
    },
    {
      id: 43,
      constituencyName: "Mummidivaram",
      secondarySection: "Mummidivaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mummidivaram-constituency-result-3009434"
    },
    {
      id: 44,
      constituencyName: "Amalapuram",
      secondarySection: "Amalapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-amalapuram-constituency-result-3009435"
    },
    {
      id: 45,
      constituencyName: "Razole",
      secondarySection: "Razole AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-razole-constituency-result-3009436"
    },
    {
      id: 46,
      constituencyName: "Gannavaram",
      secondarySection: "Gannavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gannavaram-constituency-result-3009437"
    },
    {
      id: 47,
      constituencyName: "Kothapeta",
      secondarySection: "Kothapeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kothapeta-constituency-result-3009438"
    },
    {
      id: 48,
      constituencyName: "Mandapeta",
      secondarySection: "Mandapeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mandapeta-constituency-result-3009439"
    },
    {
      id: 49,
      constituencyName: "Rajanagaram",
      secondarySection: "Rajanagaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rajanagaram-constituency-result-3009440"
    },
    {
      id: 50,
      constituencyName: "Rajahmundry City",
      secondarySection: "Rajahmundry City AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rajahmundry-city-constituency-result-3009441"
    },
    {
      id: 51,
      constituencyName: "Rajamundry Rural",
      secondarySection: "Rajamundry Rural AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rajamundry-rural-constituency-result-3009442"
    },
    {
      id: 52,
      constituencyName: "Jaggampeta",
      secondarySection: "Jaggampeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-jaggampeta-constituency-result-3009443"
    },
    {
      id: 53,
      constituencyName: "Rampachodavaram",
      secondarySection: "Rampachodavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rampachodavaram-constituency-result-3009444"
    },
    {
      id: 54,
      constituencyName: "Kovvur",
      secondarySection: "Kovvur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kovvur-constituency-result-3009445"
    },
    {
      id: 55,
      constituencyName: "Nidadavole",
      secondarySection: "Nidadavole AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nidadavole-constituency-result-3009446"
    },
    {
      id: 56,
      constituencyName: "Achanta",
      secondarySection: "Achanta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-achanta-constituency-result-3009447"
    },
    {
      id: 57,
      constituencyName: "Palacole",
      secondarySection: "Palacole AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-palacole-constituency-result-3009448"
    },
    {
      id: 58,
      constituencyName: "Narasapuram",
      secondarySection: "Narasapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-narasapuram-constituency-result-3009449"
    },
    {
      id: 59,
      constituencyName: "Bhimavaram",
      secondarySection: "Bhimavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-bhimavaram-constituency-result-3009450"
    },
    {
      id: 60,
      constituencyName: "Undi",
      secondarySection: "Undi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-undi-constituency-result-3009451"
    },
    {
      id: 61,
      constituencyName: "Tanuku",
      secondarySection: "Tanuku AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tanuku-constituency-result-3009452"
    },
    {
      id: 62,
      constituencyName: "Tadepalligudem",
      secondarySection: "Tadepalligudem AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tadepalligudem-constituency-result-3009453"
    },
    {
      id: 63,
      constituencyName: "Unguturu",
      secondarySection: "Unguturu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-unguturu-constituency-result-3009454"
    },
    {
      id: 64,
      constituencyName: "Denduluru",
      secondarySection: "Denduluru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-denduluru-constituency-result-3009455"
    },
    {
      id: 65,
      constituencyName: "Eluru",
      secondarySection: "Eluru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-eluru-constituency-result-3009456"
    },
    {
      id: 66,
      constituencyName: "Gopalapuram",
      secondarySection: "Gopalapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gopalapuram-constituency-result-3009457"
    },
    {
      id: 67,
      constituencyName: "Polavaram",
      secondarySection: "Polavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-polavaram-constituency-result-3009458"
    },
    {
      id: 68,
      constituencyName: "Chintalapudi",
      secondarySection: "Chintalapudi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chintalapudi-constituency-result-3009459"
    },
    {
      id: 69,
      constituencyName: "Tiruvuru",
      secondarySection: "Tiruvuru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tiruvuru-constituency-result-3009460"
    },
    {
      id: 70,
      constituencyName: "Nuzvid",
      secondarySection: "Nuzvid AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nuzvid-constituency-result-3009461"
    },
    {
      id: 71,
      constituencyName: "Gannavaram",
      secondarySection: "Gannavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gannavaram-constituency-result-2-3009462"
    },
    {
      id: 72,
      constituencyName: "Gudivada",
      secondarySection: "Gudivada AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gudivada-constituency-result-3009463"
    },
    {
      id: 73,
      constituencyName: "Kaikalur",
      secondarySection: "Kaikalur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kaikalur-constituency-result-3009464"
    },
    {
      id: 74,
      constituencyName: "Pedana",
      secondarySection: "Pedana AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pedana-constituency-result-3009465"
    },
    {
      id: 75,
      constituencyName: "Machilipatnam",
      secondarySection: "Machilipatnam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-machilipatnam-constituency-result-3009466"
    },
    {
      id: 76,
      constituencyName: "Avanigadda",
      secondarySection: "Avanigadda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-avanigadda-constituency-result-3009467"
    },
    {
      id: 77,
      constituencyName: "Pamarru",
      secondarySection: "Pamarru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pamarru-constituency-result-3009468"
    },
    {
      id: 78,
      constituencyName: "Penamaluru",
      secondarySection: "Penamaluru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-penamaluru-constituency-result-3009469"
    },
    {
      id: 79,
      constituencyName: "Vijaywada West",
      secondarySection: "Vijaywada West AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vijaywada-west-constituency-result-3009470"
    },
    {
      id: 80,
      constituencyName: "Vijayawada Central",
      secondarySection: "Vijayawada Central AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vijayawada-central-constituency-result-3009471"
    },
    {
      id: 81,
      constituencyName: "Vijayawada East",
      secondarySection: "Vijayawada East AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vijayawada-east-constituency-result-3009472"
    },
    {
      id: 82,
      constituencyName: "Mylavaram",
      secondarySection: "Mylavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mylavaram-constituency-result-3009473"
    },
    {
      id: 83,
      constituencyName: "Nandigama",
      secondarySection: "Nandigama AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nandigama-constituency-result-3009474"
    },
    {
      id: 84,
      constituencyName: "Jaggayyapeta",
      secondarySection: "Jaggayyapeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-jaggayyapeta-constituency-result-3009475"
    },
    {
      id: 85,
      constituencyName: "Pedakurapadu",
      secondarySection: "Pedakurapadu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pedakurapadu-constituency-result-3009476"
    },
    {
      id: 86,
      constituencyName: "Tadikonda (SC)",
      secondarySection: "Tadikonda (SC) AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tadikonda-sc-constituency-result-3009477"
    },
    {
      id: 87,
      constituencyName: "Mangalagiri",
      secondarySection: "Mangalagiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mangalagiri-constituency-result-3009478"
    },
    {
      id: 88,
      constituencyName: "Ponnur",
      secondarySection: "Ponnur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-ponnur-constituency-result-3009479"
    },
    {
      id: 89,
      constituencyName: "Vemuru (SC)",
      secondarySection: "Vemuru (SC) AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vemuru-sc-constituency-result-3009480"
    },
    {
      id: 90,
      constituencyName: "Repalle",
      secondarySection: "Repalle AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-repalle-constituency-result-3009481"
    },
    {
      id: 91,
      constituencyName: "Tenali",
      secondarySection: "Tenali AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tenali-constituency-result-3009482"
    },
    {
      id: 92,
      constituencyName: "Bapatla",
      secondarySection: "Bapatla AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-bapatla-constituency-result-3009483"
    },
    {
      id: 93,
      constituencyName: "Prathipadu (SC)",
      secondarySection: "Prathipadu (SC) AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-prathipadu-sc-constituency-result-3009484"
    },
    {
      id: 94,
      constituencyName: "Guntur West",
      secondarySection: "Guntur West AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-guntur-west-constituency-result-3009485"
    },
    {
      id: 95,
      constituencyName: "Guntur East",
      secondarySection: "Guntur East AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-guntur-east-constituency-result-3009486"
    },
    {
      id: 96,
      constituencyName: "Chilakaluripet",
      secondarySection: "Chilakaluripet AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chilakaluripet-constituency-result-3009487"
    },
    {
      id: 97,
      constituencyName: "Narasaraopet",
      secondarySection: "Narasaraopet AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-narasaraopet-constituency-result-3009488"
    },
    {
      id: 98,
      constituencyName: "Sattenapalli",
      secondarySection: "Sattenapalli AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-sattenapalli-constituency-result-3009489"
    },
    {
      id: 99,
      constituencyName: "Vinukonda",
      secondarySection: "Vinukonda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-vinukonda-constituency-result-3009490"
    },
    {
      id: 100,
      constituencyName: "Gurazala",
      secondarySection: "Gurazala AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gurazala-constituency-result-3009491"
    },
    {
      id: 101,
      constituencyName: "Macherla",
      secondarySection: "Macherla AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-macherla-constituency-result-3009492"
    },
    {
      id: 102,
      constituencyName: "Yerragondapalem",
      secondarySection: "Yerragondapalem AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-yerragondapalem-constituency-result-3009493"
    },
    {
      id: 103,
      constituencyName: "Darsi",
      secondarySection: "Darsi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-darsi-constituency-result-3009494"
    },
    {
      id: 104,
      constituencyName: "Parchur",
      secondarySection: "Parchur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-parchur-constituency-result-3009495"
    },
    {
      id: 105,
      constituencyName: "Addanki",
      secondarySection: "Addanki AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-addanki-constituency-result-3009496"
    },
    {
      id: 106,
      constituencyName: "Chirala",
      secondarySection: "Chirala AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chirala-constituency-result-3009497"
    },
    {
      id: 107,
      constituencyName: "Santhanuthalapadu",
      secondarySection: "Santhanuthalapadu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-santhanuthalapadu-constituency-result-3009498"
    },
    {
      id: 108,
      constituencyName: "Ongole",
      secondarySection: "Ongole AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-ongole-constituency-result-3009499"
    },
    {
      id: 109,
      constituencyName: "Kandukur",
      secondarySection: "Kandukur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kandukur-constituency-result-3009500"
    },
    {
      id: 110,
      constituencyName: "Kondapi",
      secondarySection: "Kondapi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kondapi-constituency-result-3009501"
    },
    {
      id: 111,
      constituencyName: "Markapuram",
      secondarySection: "Markapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-markapuram-constituency-result-3009502"
    },
    {
      id: 112,
      constituencyName: "Giddalur",
      secondarySection: "Giddalur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-giddalur-constituency-result-3009503"
    },
    {
      id: 113,
      constituencyName: "Kanigiri",
      secondarySection: "Kanigiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kanigiri-constituency-result-3009504"
    },
    {
      id: 114,
      constituencyName: "Kavali",
      secondarySection: "Kavali AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kavali-constituency-result-3009505"
    },
    {
      id: 115,
      constituencyName: "Atmakur",
      secondarySection: "Atmakur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-atmakur-constituency-result-3009506"
    },
    {
      id: 116,
      constituencyName: "Kovur",
      secondarySection: "Kovur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kovur-constituency-result-3009507"
    },
    {
      id: 117,
      constituencyName: "Nellore City",
      secondarySection: "Nellore City AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nellore-city-constituency-result-3009508"
    },
    {
      id: 118,
      constituencyName: "Nellore Rural",
      secondarySection: "Nellore Rural AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nellore-rural-constituency-result-3009509"
    },
    {
      id: 119,
      constituencyName: "Sarvepalli",
      secondarySection: "Sarvepalli AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-sarvepalli-constituency-result-3009510"
    },
    {
      id: 120,
      constituencyName: "Gudur",
      secondarySection: "Gudur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gudur-constituency-result-3009511"
    },
    {
      id: 121,
      constituencyName: "Sullurpeta",
      secondarySection: "Sullurpeta AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-sullurpeta-constituency-result-3009512"
    },
    {
      id: 122,
      constituencyName: "Venkatagiri",
      secondarySection: "Venkatagiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-venkatagiri-constituency-result-3009513"
    },
    {
      id: 123,
      constituencyName: "Udayagiri",
      secondarySection: "Udayagiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-udayagiri-constituency-result-3009514"
    },
    {
      id: 124,
      constituencyName: "Badvel",
      secondarySection: "Badvel AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-badvel-constituency-result-3009515"
    },
    {
      id: 125,
      constituencyName: "Rajampet",
      secondarySection: "Rajampet AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rajampet-constituency-result-3009516"
    },
    {
      id: 126,
      constituencyName: "Kadapa",
      secondarySection: "Kadapa AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kadapa-constituency-result-3009517"
    },
    {
      id: 127,
      constituencyName: "Kodur",
      secondarySection: "Kodur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kodur-constituency-result-3009518"
    },
    {
      id: 128,
      constituencyName: "Rayachoti",
      secondarySection: "Rayachoti AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rayachoti-constituency-result-3009519"
    },
    {
      id: 129,
      constituencyName: "Pulivendla",
      secondarySection: "Pulivendla AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pulivendla-constituency-result-3009520"
    },
    {
      id: 130,
      constituencyName: "Kamalapuram",
      secondarySection: "Kamalapuram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kamalapuram-constituency-result-3009521"
    },
    {
      id: 131,
      constituencyName: "Jammalamadugu",
      secondarySection: "Jammalamadugu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-jammalamadugu-constituency-result-3009522"
    },
    {
      id: 132,
      constituencyName: "Proddatur",
      secondarySection: "Proddatur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-proddatur-constituency-result-3009523"
    },
    {
      id: 133,
      constituencyName: "Mydukur",
      secondarySection: "Mydukur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mydukur-constituency-result-3009524"
    },
    {
      id: 134,
      constituencyName: "Allagadda",
      secondarySection: "Allagadda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-allagadda-constituency-result-3009525"
    },
    {
      id: 135,
      constituencyName: "Srisailam",
      secondarySection: "Srisailam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-srisailam-constituency-result-3009526"
    },
    {
      id: 136,
      constituencyName: "Nandikotkur",
      secondarySection: "Nandikotkur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nandikotkur-constituency-result-3009527"
    },
    {
      id: 137,
      constituencyName: "Kurnool",
      secondarySection: "Kurnool AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kurnool-constituency-result-3009528"
    },
    {
      id: 138,
      constituencyName: "Panyam",
      secondarySection: "Panyam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-panyam-constituency-result-3009529"
    },
    {
      id: 139,
      constituencyName: "Nandyal",
      secondarySection: "Nandyal AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nandyal-constituency-result-3009530"
    },
    {
      id: 140,
      constituencyName: "Banaganapalle",
      secondarySection: "Banaganapalle AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-banaganapalle-constituency-result-3009531"
    },
    {
      id: 141,
      constituencyName: "Dhone",
      secondarySection: "Dhone AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-dhone-constituency-result-3009532"
    },
    {
      id: 142,
      constituencyName: "Pattikonda",
      secondarySection: "Pattikonda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pattikonda-constituency-result-3009533"
    },
    {
      id: 143,
      constituencyName: "Kodumur",
      secondarySection: "Kodumur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kodumur-constituency-result-3009534"
    },
    {
      id: 144,
      constituencyName: "Yemmiganur",
      secondarySection: "Yemmiganur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-yemmiganur-constituency-result-3009535"
    },
    {
      id: 145,
      constituencyName: "Mantralayam",
      secondarySection: "Mantralayam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-mantralayam-constituency-result-3009536"
    },
    {
      id: 146,
      constituencyName: "Adoni",
      secondarySection: "Adoni AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-adoni-constituency-result-3009537"
    },
    {
      id: 147,
      constituencyName: "Alur",
      secondarySection: "Alur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-alur-constituency-result-3009538"
    },
    {
      id: 148,
      constituencyName: "Rayadurg",
      secondarySection: "Rayadurg AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-rayadurg-constituency-result-3009539"
    },
    {
      id: 149,
      constituencyName: "Uravakonda",
      secondarySection: "Uravakonda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-uravakonda-constituency-result-3009540"
    },
    {
      id: 150,
      constituencyName: "Guntakal",
      secondarySection: "Guntakal AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-guntakal-constituency-result-3009541"
    },
    {
      id: 151,
      constituencyName: "Tadipatri",
      secondarySection: "Tadipatri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tadipatri-constituency-result-3009542"
    },
    {
      id: 152,
      constituencyName: "Singanamala",
      secondarySection: "Singanamala AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-singanamala-constituency-result-3009543"
    },
    {
      id: 153,
      constituencyName: "Anantapur Urban",
      secondarySection: "Anantapur Urban AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-anantapur-urban-constituency-result-3009544"
    },
    {
      id: 154,
      constituencyName: "Kalyandurg",
      secondarySection: "Kalyandurg AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kalyandurg-constituency-result-3009545"
    },
    {
      id: 155,
      constituencyName: "Raptadu",
      secondarySection: "Raptadu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-raptadu-constituency-result-3009546"
    },
    {
      id: 156,
      constituencyName: "Madakasira",
      secondarySection: "Madakasira AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-madakasira-constituency-result-3009547"
    },
    {
      id: 157,
      constituencyName: "Hindupur",
      secondarySection: "Hindupur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-hindupur-constituency-result-3009548"
    },
    {
      id: 158,
      constituencyName: "Penukonda",
      secondarySection: "Penukonda AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-penukonda-constituency-result-3009549"
    },
    {
      id: 159,
      constituencyName: "Puttaparthi",
      secondarySection: "Puttaparthi AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-puttaparthi-constituency-result-3009550"
    },
    {
      id: 160,
      constituencyName: "Dharmavaram",
      secondarySection: "Dharmavaram AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-dharmavaram-constituency-result-3009551"
    },
    {
      id: 161,
      constituencyName: "Kadiri",
      secondarySection: "Kadiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kadiri-constituency-result-3009552"
    },
    {
      id: 162,
      constituencyName: "Thamballapalle",
      secondarySection: "Thamballapalle AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-thamballapalle-constituency-result-3009553"
    },
    {
      id: 163,
      constituencyName: "Pileru",
      secondarySection: "Pileru AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-pileru-constituency-result-3009554"
    },
    {
      id: 164,
      constituencyName: "Madanapalle",
      secondarySection: "Madanapalle AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-madanapalle-constituency-result-3009555"
    },
    {
      id: 165,
      constituencyName: "Punganur",
      secondarySection: "Punganur AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-punganur-constituency-result-3009556"
    },
    {
      id: 166,
      constituencyName: "Chandragiri",
      secondarySection: "Chandragiri AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chandragiri-constituency-result-3009557"
    },
    {
      id: 167,
      constituencyName: "Tirupati",
      secondarySection: "Tirupati AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-tirupati-constituency-result-3009558"
    },
    {
      id: 168,
      constituencyName: "Srikalahasti",
      secondarySection: "Srikalahasti AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-srikalahasti-constituency-result-3009559"
    },
    {
      id: 169,
      constituencyName: "Satyavedu",
      secondarySection: "Satyavedu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-satyavedu-constituency-result-3009560"
    },
    {
      id: 170,
      constituencyName: "Nagari",
      secondarySection: "Nagari AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-nagari-constituency-result-3009561"
    },
    {
      id: 171,
      constituencyName: "Gangadhara Nellore",
      secondarySection: "Gangadhara Nellore AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-gangadhara-nellore-constituency-result-3009562"
    },
    {
      id: 172,
      constituencyName: "Chittoor",
      secondarySection: "Chittoor AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-chittoor-constituency-result-3009563"
    },
    {
      id: 173,
      constituencyName: "Puthalapattu",
      secondarySection: "Puthalapattu AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-puthalapattu-constituency-result-3009564"
    },
    {
      id: 174,
      constituencyName: "Palamaner",
      secondarySection: "Palamaner AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-palamaner-constituency-result-3009565"
    },
    {
      id: 175,
      constituencyName: "Kuppam",
      secondarySection: "Kuppam AC (Andhra Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/andhra-pradesh/andhra-pradesh-assembly-elections-2024-kuppam-constituency-result-3009566"
    }
  ],
  "ARUNACHAL PRADESH": [
    {
      id: 1,
      constituencyName: "Lumla",
      secondarySection: "Lumla AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-lumla-constituency-result-3009367"
    },
    {
      id: 2,
      constituencyName: "Tawang",
      secondarySection: "Tawang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-tawang-constituency-result-3009567"
    },
    {
      id: 3,
      constituencyName: "Mukto",
      secondarySection: "Mukto AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-mukto-constituency-result-3009568"
    },
    {
      id: 4,
      constituencyName: "Dirang",
      secondarySection: "Dirang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-dirang-constituency-result-3009569"
    },
    {
      id: 5,
      constituencyName: "Kalaktang",
      secondarySection: "Kalaktang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-kalaktang-constituency-result-3009570"
    },
    {
      id: 6,
      constituencyName: "Thrizino-Buragaon",
      secondarySection: "Thrizino-Buragaon AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-thrizino-buragaon-constituency-result-3009571"
    },
    {
      id: 7,
      constituencyName: "Bomdila",
      secondarySection: "Bomdila AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-bomdila-constituency-result-3009572"
    },
    {
      id: 8,
      constituencyName: "Bameng",
      secondarySection: "Bameng AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-bameng-constituency-result-3009573"
    },
    {
      id: 9,
      constituencyName: "Chayang Tajo",
      secondarySection: "Chayang Tajo AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-chayang-tajo-constituency-result-3009574"
    },
    {
      id: 10,
      constituencyName: "Seppa East",
      secondarySection: "Seppa East AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-seppa-east-constituency-result-3009575"
    },
    {
      id: 11,
      constituencyName: "Seppa West",
      secondarySection: "Seppa West AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-seppa-west-constituency-result-3009576"
    },
    {
      id: 12,
      constituencyName: "Pakke Kessang",
      secondarySection: "Pakke Kessang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-pakke-kessang-constituency-result-3009577"
    },
    {
      id: 13,
      constituencyName: "Itanagar",
      secondarySection: "Itanagar AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-itanagar-constituency-result-3009578"
    },
    {
      id: 14,
      constituencyName: "Doimukh",
      secondarySection: "Doimukh AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-doimukh-constituency-result-3009579"
    },
    {
      id: 15,
      constituencyName: "Sagalee",
      secondarySection: "Sagalee AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-sagalee-constituency-result-3009580"
    },
    {
      id: 16,
      constituencyName: "Yachuli",
      secondarySection: "Yachuli AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-yachuli-constituency-result-3009581"
    },
    {
      id: 17,
      constituencyName: "Ziro Hapoli",
      secondarySection: "Ziro Hapoli AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-ziro-hapoli-constituency-result-3009582"
    },
    {
      id: 18,
      constituencyName: "Palin",
      secondarySection: "Palin AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-palin-constituency-result-3009583"
    },
    {
      id: 19,
      constituencyName: "Nyapin",
      secondarySection: "Nyapin AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-nyapin-constituency-result-3009584"
    },
    {
      id: 20,
      constituencyName: "Tali",
      secondarySection: "Tali AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-tali-constituency-result-3009585"
    },
    {
      id: 21,
      constituencyName: "Koloriang",
      secondarySection: "Koloriang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-koloriang-constituency-result-3009586"
    },
    {
      id: 22,
      constituencyName: "Nacho",
      secondarySection: "Nacho AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-nacho-constituency-result-3009587"
    },
    {
      id: 23,
      constituencyName: "Taliha",
      secondarySection: "Taliha AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-taliha-constituency-result-3009588"
    },
    {
      id: 24,
      constituencyName: "Daporijo",
      secondarySection: "Daporijo AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-daporijo-constituency-result-3009589"
    },
    {
      id: 25,
      constituencyName: "Raga",
      secondarySection: "Raga AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-raga-constituency-result-3009590"
    },
    {
      id: 26,
      constituencyName: "Dumporijo",
      secondarySection: "Dumporijo AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-dumporijo-constituency-result-3009591"
    },
    {
      id: 27,
      constituencyName: "Liromoba",
      secondarySection: "Liromoba AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-liromoba-constituency-result-3009592"
    },
    {
      id: 28,
      constituencyName: "Likabali",
      secondarySection: "Likabali AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-likabali-constituency-result-3009593"
    },
    {
      id: 29,
      constituencyName: "Basar",
      secondarySection: "Basar AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-basar-constituency-result-3009594"
    },
    {
      id: 30,
      constituencyName: "Along West",
      secondarySection: "Along West AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-along-west-constituency-result-3009595"
    },
    {
      id: 31,
      constituencyName: "Along East",
      secondarySection: "Along East AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-along-east-constituency-result-3009596"
    },
    {
      id: 32,
      constituencyName: "Rumgong",
      secondarySection: "Rumgong AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-rumgong-constituency-result-3009597"
    },
    {
      id: 33,
      constituencyName: "Mechuka",
      secondarySection: "Mechuka AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-mechuka-constituency-result-3009598"
    },
    {
      id: 34,
      constituencyName: "Tuting Yingkiong",
      secondarySection: "Tuting Yingkiong AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-tuting-yingkiong-constituency-result-3009599"
    },
    {
      id: 35,
      constituencyName: "Pangin",
      secondarySection: "Pangin AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-pangin-constituency-result-3009600"
    },
    {
      id: 36,
      constituencyName: "Nari-Koyu",
      secondarySection: "Nari-Koyu AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-nari-koyu-constituency-result-3009601"
    },
    {
      id: 37,
      constituencyName: "Pasighat West",
      secondarySection: "Pasighat West AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-pasighat-west-constituency-result-3009602"
    },
    {
      id: 38,
      constituencyName: "Pasighat East",
      secondarySection: "Pasighat East AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-pasighat-east-constituency-result-3009603"
    },
    {
      id: 39,
      constituencyName: "Mebo",
      secondarySection: "Mebo AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-mebo-constituency-result-3009604"
    },
    {
      id: 40,
      constituencyName: "Mariyang-Geku",
      secondarySection: "Mariyang-Geku AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-mariyang-geku-constituency-result-3009605"
    },
    {
      id: 41,
      constituencyName: "Anini",
      secondarySection: "Anini AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-anini-constituency-result-3009606"
    },
    {
      id: 42,
      constituencyName: "Dambuk",
      secondarySection: "Dambuk AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-dambuk-constituency-result-3009607"
    },
    {
      id: 43,
      constituencyName: "Roing",
      secondarySection: "Roing AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-roing-constituency-result-3009608"
    },
    {
      id: 44,
      constituencyName: "Tezu",
      secondarySection: "Tezu AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-tezu-constituency-result-3009609"
    },
    {
      id: 45,
      constituencyName: "Hayuliang",
      secondarySection: "Hayuliang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-hayuliang-constituency-result-3009610"
    },
    {
      id: 46,
      constituencyName: "Chowkham",
      secondarySection: "Chowkham AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-chowkham-constituency-result-3009611"
    },
    {
      id: 47,
      constituencyName: "Namsai",
      secondarySection: "Namsai AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-namsai-constituency-result-3009612"
    },
    {
      id: 48,
      constituencyName: "Lekang",
      secondarySection: "Lekang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-lekang-constituency-result-3009613"
    },
    {
      id: 49,
      constituencyName: "Bordumsa - Diyun",
      secondarySection: "Bordumsa - Diyun AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-bordumsa-diyun-constituency-result-3009614"
    },
    {
      id: 50,
      constituencyName: "Miao",
      secondarySection: "Miao AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-miao-constituency-result-3009615"
    },
    {
      id: 51,
      constituencyName: "Nampong",
      secondarySection: "Nampong AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-nampong-constituency-result-3009616"
    },
    {
      id: 52,
      constituencyName: "Changlang South",
      secondarySection: "Changlang South AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-changlang-south-constituency-result-3009617"
    },
    {
      id: 53,
      constituencyName: "Changlang North",
      secondarySection: "Changlang North AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-changlang-north-constituency-result-3009618"
    },
    {
      id: 54,
      constituencyName: "Namsang",
      secondarySection: "Namsang AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-namsang-constituency-result-3009619"
    },
    {
      id: 55,
      constituencyName: "Khonsa East",
      secondarySection: "Khonsa East AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-khonsa-east-constituency-result-3009620"
    },
    {
      id: 56,
      constituencyName: "Khonsa West",
      secondarySection: "Khonsa West AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-khonsa-west-constituency-result-3009621"
    },
    {
      id: 57,
      constituencyName: "Borduria Bogapani",
      secondarySection: "Borduria Bogapani AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-borduria-bogapani-constituency-result-3009622"
    },
    {
      id: 58,
      constituencyName: "Kanubari",
      secondarySection: "Kanubari AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-kanubari-constituency-result-3009623"
    },
    {
      id: 59,
      constituencyName: "Longding Pumao",
      secondarySection: "Longding Pumao AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-longding-pumao-constituency-result-3009624"
    },
    {
      id: 60,
      constituencyName: "Pongchau Wakka",
      secondarySection: "Pongchau Wakka AC (Arunachal Pradesh)",
      publishedUrl:
        "https://www.deccanherald.com/elections/arunachal-pradesh/arunachal-pradesh-assembly-elections-2024-pongchau-wakka-constituency-result-3009625"
    }
  ],
  ODISHA: [
    {
      id: 1,
      constituencyName: "Padampur",
      secondarySection: "Padampur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-padampur-constituency-result-3009368"
    },
    {
      id: 2,
      constituencyName: "Bijepur",
      secondarySection: "Bijepur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bijepur-constituency-result-3009626"
    },
    {
      id: 3,
      constituencyName: "Bargarh",
      secondarySection: "Bargarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bargarh-constituency-result-3009627"
    },
    {
      id: 4,
      constituencyName: "Attabira",
      secondarySection: "Attabira AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-attabira-constituency-result-3009628"
    },
    {
      id: 5,
      constituencyName: "Bhatli",
      secondarySection: "Bhatli AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhatli-constituency-result-3009629"
    },
    {
      id: 6,
      constituencyName: "Brajarajnagar",
      secondarySection: "Brajarajnagar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-brajarajnagar-constituency-result-3009630"
    },
    {
      id: 7,
      constituencyName: "Jharsuguda",
      secondarySection: "Jharsuguda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jharsuguda-constituency-result-3009631"
    },
    {
      id: 8,
      constituencyName: "Talsara",
      secondarySection: "Talsara AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-talsara-constituency-result-3009632"
    },
    {
      id: 9,
      constituencyName: "Sundargarh",
      secondarySection: "Sundargarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-sundargarh-constituency-result-3009633"
    },
    {
      id: 10,
      constituencyName: "Biramitrapur",
      secondarySection: "Biramitrapur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-biramitrapur-constituency-result-3009634"
    },
    {
      id: 11,
      constituencyName: "Raghunathpali",
      secondarySection: "Raghunathpali AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-raghunathpali-constituency-result-3009635"
    },
    {
      id: 12,
      constituencyName: "Rourkela",
      secondarySection: "Rourkela AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rourkela-constituency-result-3009636"
    },
    {
      id: 13,
      constituencyName: "Rajgangapur",
      secondarySection: "Rajgangapur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rajgangapur-constituency-result-3009637"
    },
    {
      id: 14,
      constituencyName: "Bonai",
      secondarySection: "Bonai AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bonai-constituency-result-3009638"
    },
    {
      id: 15,
      constituencyName: "Kuchinda",
      secondarySection: "Kuchinda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kuchinda-constituency-result-3009639"
    },
    {
      id: 16,
      constituencyName: "Rengali",
      secondarySection: "Rengali AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rengali-constituency-result-3009640"
    },
    {
      id: 17,
      constituencyName: "Sambalpur",
      secondarySection: "Sambalpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-sambalpur-constituency-result-3009641"
    },
    {
      id: 18,
      constituencyName: "Rairakhol",
      secondarySection: "Rairakhol AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rairakhol-constituency-result-3009642"
    },
    {
      id: 19,
      constituencyName: "Deogarh",
      secondarySection: "Deogarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-deogarh-constituency-result-3009643"
    },
    {
      id: 20,
      constituencyName: "Telkoi",
      secondarySection: "Telkoi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-telkoi-constituency-result-3009644"
    },
    {
      id: 21,
      constituencyName: "Ghasipura",
      secondarySection: "Ghasipura AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-ghasipura-constituency-result-3009645"
    },
    {
      id: 22,
      constituencyName: "Anandapur",
      secondarySection: "Anandapur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-anandapur-constituency-result-3009646"
    },
    {
      id: 23,
      constituencyName: "Patna",
      secondarySection: "Patna AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-patna-constituency-result-3009647"
    },
    {
      id: 24,
      constituencyName: "Keonjhar",
      secondarySection: "Keonjhar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-keonjhar-constituency-result-3009648"
    },
    {
      id: 25,
      constituencyName: "Champua",
      secondarySection: "Champua AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-champua-constituency-result-3009649"
    },
    {
      id: 26,
      constituencyName: "Jashipur",
      secondarySection: "Jashipur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jashipur-constituency-result-3009650"
    },
    {
      id: 27,
      constituencyName: "Saraskana",
      secondarySection: "Saraskana AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-saraskana-constituency-result-3009651"
    },
    {
      id: 28,
      constituencyName: "Rairangpur",
      secondarySection: "Rairangpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rairangpur-constituency-result-3009652"
    },
    {
      id: 29,
      constituencyName: "Bangriposi",
      secondarySection: "Bangriposi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bangriposi-constituency-result-3009653"
    },
    {
      id: 30,
      constituencyName: "Karanjia",
      secondarySection: "Karanjia AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-karanjia-constituency-result-3009654"
    },
    {
      id: 31,
      constituencyName: "Udala",
      secondarySection: "Udala AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-udala-constituency-result-3009655"
    },
    {
      id: 32,
      constituencyName: "Badasahi",
      secondarySection: "Badasahi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-badasahi-constituency-result-3009656"
    },
    {
      id: 33,
      constituencyName: "Baripada",
      secondarySection: "Baripada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-baripada-constituency-result-3009657"
    },
    {
      id: 34,
      constituencyName: "Morada",
      secondarySection: "Morada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-morada-constituency-result-3009658"
    },
    {
      id: 35,
      constituencyName: "Jaleswar",
      secondarySection: "Jaleswar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jaleswar-constituency-result-3009659"
    },
    {
      id: 36,
      constituencyName: "Bhograi",
      secondarySection: "Bhograi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhograi-constituency-result-3009660"
    },
    {
      id: 37,
      constituencyName: "Basta",
      secondarySection: "Basta AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-basta-constituency-result-3009661"
    },
    {
      id: 38,
      constituencyName: "Balasore",
      secondarySection: "Balasore AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-balasore-constituency-result-3009662"
    },
    {
      id: 39,
      constituencyName: "Remuna",
      secondarySection: "Remuna AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-remuna-constituency-result-3009663"
    },
    {
      id: 40,
      constituencyName: "Nilgiri",
      secondarySection: "Nilgiri AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-nilgiri-constituency-result-3009664"
    },
    {
      id: 41,
      constituencyName: "Soro",
      secondarySection: "Soro AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-soro-constituency-result-3009665"
    },
    {
      id: 42,
      constituencyName: "Simulia",
      secondarySection: "Simulia AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-simulia-constituency-result-3009666"
    },
    {
      id: 43,
      constituencyName: "Bhandaripokhari",
      secondarySection: "Bhandaripokhari AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhandaripokhari-constituency-result-3009667"
    },
    {
      id: 44,
      constituencyName: "Bhadrak",
      secondarySection: "Bhadrak AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhadrak-constituency-result-3009668"
    },
    {
      id: 45,
      constituencyName: "Basudevpur",
      secondarySection: "Basudevpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-basudevpur-constituency-result-3009669"
    },
    {
      id: 46,
      constituencyName: "Dhamnagar",
      secondarySection: "Dhamnagar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-dhamnagar-constituency-result-3009670"
    },
    {
      id: 47,
      constituencyName: "Chandabali",
      secondarySection: "Chandabali AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chandabali-constituency-result-3009671"
    },
    {
      id: 48,
      constituencyName: "Binjharpur",
      secondarySection: "Binjharpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-binjharpur-constituency-result-3009672"
    },
    {
      id: 49,
      constituencyName: "Bari",
      secondarySection: "Bari AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bari-constituency-result-3009673"
    },
    {
      id: 50,
      constituencyName: "Barchana",
      secondarySection: "Barchana AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-barchana-constituency-result-3009674"
    },
    {
      id: 51,
      constituencyName: "Dharmasala",
      secondarySection: "Dharmasala AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-dharmasala-constituency-result-3009675"
    },
    {
      id: 52,
      constituencyName: "Jajpur",
      secondarySection: "Jajpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jajpur-constituency-result-3009676"
    },
    {
      id: 53,
      constituencyName: "Korei",
      secondarySection: "Korei AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-korei-constituency-result-3009677"
    },
    {
      id: 54,
      constituencyName: "Sukinda",
      secondarySection: "Sukinda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-sukinda-constituency-result-3009678"
    },
    {
      id: 55,
      constituencyName: "Dhenkanal",
      secondarySection: "Dhenkanal AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-dhenkanal-constituency-result-3009679"
    },
    {
      id: 56,
      constituencyName: "Hindol",
      secondarySection: "Hindol AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-hindol-constituency-result-3009680"
    },
    {
      id: 57,
      constituencyName: "Kamakhyanagar",
      secondarySection: "Kamakhyanagar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kamakhyanagar-constituency-result-3009681"
    },
    {
      id: 58,
      constituencyName: "Parjanga",
      secondarySection: "Parjanga AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-parjanga-constituency-result-3009682"
    },
    {
      id: 59,
      constituencyName: "Pallahara",
      secondarySection: "Pallahara AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-pallahara-constituency-result-3009683"
    },
    {
      id: 60,
      constituencyName: "Talcher",
      secondarySection: "Talcher AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-talcher-constituency-result-3009684"
    },
    {
      id: 61,
      constituencyName: "Angul",
      secondarySection: "Angul AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-angul-constituency-result-3009685"
    },
    {
      id: 62,
      constituencyName: "Chhendipada",
      secondarySection: "Chhendipada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chhendipada-constituency-result-3009686"
    },
    {
      id: 63,
      constituencyName: "Athamallik",
      secondarySection: "Athamallik AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-athamallik-constituency-result-3009687"
    },
    {
      id: 64,
      constituencyName: "Birmaharajpur",
      secondarySection: "Birmaharajpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-birmaharajpur-constituency-result-3009688"
    },
    {
      id: 65,
      constituencyName: "Sonepur",
      secondarySection: "Sonepur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-sonepur-constituency-result-3009689"
    },
    {
      id: 66,
      constituencyName: "Loisingha",
      secondarySection: "Loisingha AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-loisingha-constituency-result-3009690"
    },
    {
      id: 67,
      constituencyName: "Patnagarh",
      secondarySection: "Patnagarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-patnagarh-constituency-result-3009691"
    },
    {
      id: 68,
      constituencyName: "Bolangir",
      secondarySection: "Bolangir AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bolangir-constituency-result-3009692"
    },
    {
      id: 69,
      constituencyName: "Titlagarh",
      secondarySection: "Titlagarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-titlagarh-constituency-result-3009693"
    },
    {
      id: 70,
      constituencyName: "Kantabanji",
      secondarySection: "Kantabanji AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kantabanji-constituency-result-3009694"
    },
    {
      id: 71,
      constituencyName: "Nuapada",
      secondarySection: "Nuapada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-nuapada-constituency-result-3009695"
    },
    {
      id: 72,
      constituencyName: "Khariar",
      secondarySection: "Khariar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-khariar-constituency-result-3009696"
    },
    {
      id: 73,
      constituencyName: "Umarkote",
      secondarySection: "Umarkote AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-umarkote-constituency-result-3009697"
    },
    {
      id: 74,
      constituencyName: "Jharigam",
      secondarySection: "Jharigam AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jharigam-constituency-result-3009698"
    },
    {
      id: 75,
      constituencyName: "Nabarangpur",
      secondarySection: "Nabarangpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-nabarangpur-constituency-result-3009699"
    },
    {
      id: 76,
      constituencyName: "Dabugam",
      secondarySection: "Dabugam AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-dabugam-constituency-result-3009700"
    },
    {
      id: 77,
      constituencyName: "Lanjigarh",
      secondarySection: "Lanjigarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-lanjigarh-constituency-result-3009701"
    },
    {
      id: 78,
      constituencyName: "Junagarh",
      secondarySection: "Junagarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-junagarh-constituency-result-3009702"
    },
    {
      id: 79,
      constituencyName: "Dharmgarh",
      secondarySection: "Dharmgarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-dharmgarh-constituency-result-3009703"
    },
    {
      id: 80,
      constituencyName: "Bhawanipatna",
      secondarySection: "Bhawanipatna AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhawanipatna-constituency-result-3009704"
    },
    {
      id: 81,
      constituencyName: "Narla",
      secondarySection: "Narla AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-narla-constituency-result-3009705"
    },
    {
      id: 82,
      constituencyName: "Baliguda",
      secondarySection: "Baliguda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-baliguda-constituency-result-3009706"
    },
    {
      id: 83,
      constituencyName: "G. Udayagiri",
      secondarySection: "G. Udayagiri AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-g-udayagiri-constituency-result-3009707"
    },
    {
      id: 84,
      constituencyName: "Phulbani",
      secondarySection: "Phulbani AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-phulbani-constituency-result-3009708"
    },
    {
      id: 85,
      constituencyName: "Kantamal",
      secondarySection: "Kantamal AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kantamal-constituency-result-3009709"
    },
    {
      id: 86,
      constituencyName: "Boudh",
      secondarySection: "Boudh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-boudh-constituency-result-3009710"
    },
    {
      id: 87,
      constituencyName: "Baramba",
      secondarySection: "Baramba AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-baramba-constituency-result-3009711"
    },
    {
      id: 88,
      constituencyName: "Banki",
      secondarySection: "Banki AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-banki-constituency-result-3009712"
    },
    {
      id: 89,
      constituencyName: "Athagarh",
      secondarySection: "Athagarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-athagarh-constituency-result-3009713"
    },
    {
      id: 90,
      constituencyName: "Barabati-Cuttack",
      secondarySection: "Barabati-Cuttack AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-barabati-cuttack-constituency-result-3009714"
    },
    {
      id: 91,
      constituencyName: "Choudwar-Cuttack",
      secondarySection: "Choudwar-Cuttack AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-choudwar-cuttack-constituency-result-3009715"
    },
    {
      id: 92,
      constituencyName: "Niali",
      secondarySection: "Niali AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-niali-constituency-result-3009716"
    },
    {
      id: 93,
      constituencyName: "Cuttack Sadar",
      secondarySection: "Cuttack Sadar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-cuttack-sadar-constituency-result-3009717"
    },
    {
      id: 94,
      constituencyName: "Salipur",
      secondarySection: "Salipur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-salipur-constituency-result-3009718"
    },
    {
      id: 95,
      constituencyName: "Mahanga",
      secondarySection: "Mahanga AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-mahanga-constituency-result-3009719"
    },
    {
      id: 96,
      constituencyName: "Patkura*",
      secondarySection: "Patkura* AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-patkura-constituency-result-3009720"
    },
    {
      id: 97,
      constituencyName: "Kendrapara",
      secondarySection: "Kendrapara AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kendrapara-constituency-result-3009721"
    },
    {
      id: 98,
      constituencyName: "Aul",
      secondarySection: "Aul AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-aul-constituency-result-3009722"
    },
    {
      id: 99,
      constituencyName: "Rajanagar",
      secondarySection: "Rajanagar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rajanagar-constituency-result-3009723"
    },
    {
      id: 100,
      constituencyName: "Mahakalapada",
      secondarySection: "Mahakalapada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-mahakalapada-constituency-result-3009724"
    },
    {
      id: 101,
      constituencyName: "Paradeep",
      secondarySection: "Paradeep AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-paradeep-constituency-result-3009725"
    },
    {
      id: 102,
      constituencyName: "Tirtol",
      secondarySection: "Tirtol AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-tirtol-constituency-result-3009726"
    },
    {
      id: 103,
      constituencyName: "Balikuda-Ersama",
      secondarySection: "Balikuda-Ersama AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-balikuda-ersama-constituency-result-3009727"
    },
    {
      id: 104,
      constituencyName: "Jagatsinghpur",
      secondarySection: "Jagatsinghpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jagatsinghpur-constituency-result-3009728"
    },
    {
      id: 105,
      constituencyName: "Kakatpur",
      secondarySection: "Kakatpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kakatpur-constituency-result-3009729"
    },
    {
      id: 106,
      constituencyName: "Nimapara",
      secondarySection: "Nimapara AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-nimapara-constituency-result-3009730"
    },
    {
      id: 107,
      constituencyName: "Puri",
      secondarySection: "Puri AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-puri-constituency-result-3009731"
    },
    {
      id: 108,
      constituencyName: "Bramhagiri",
      secondarySection: "Bramhagiri AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bramhagiri-constituency-result-3009732"
    },
    {
      id: 109,
      constituencyName: "Satyabadi",
      secondarySection: "Satyabadi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-satyabadi-constituency-result-3009733"
    },
    {
      id: 110,
      constituencyName: "Pipili",
      secondarySection: "Pipili AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-pipili-constituency-result-3009734"
    },
    {
      id: 111,
      constituencyName: "Jayadev",
      secondarySection: "Jayadev AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jayadev-constituency-result-3009735"
    },
    {
      id: 112,
      constituencyName: "Bhubaneswar Central (Madhya)",
      secondarySection: "Bhubaneswar Central (Madhya) AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhubaneswar-central-madhya-constituency-result-3009736"
    },
    {
      id: 113,
      constituencyName: "Bhubaneswar North (Uttar)",
      secondarySection: "Bhubaneswar North (Uttar) AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhubaneswar-north-uttar-constituency-result-3009737"
    },
    {
      id: 114,
      constituencyName: "Ekamra-Bhubaneswar",
      secondarySection: "Ekamra-Bhubaneswar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-ekamra-bhubaneswar-constituency-result-3009738"
    },
    {
      id: 115,
      constituencyName: "Jatani",
      secondarySection: "Jatani AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jatani-constituency-result-3009739"
    },
    {
      id: 116,
      constituencyName: "Begunia",
      secondarySection: "Begunia AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-begunia-constituency-result-3009740"
    },
    {
      id: 117,
      constituencyName: "Khurda",
      secondarySection: "Khurda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-khurda-constituency-result-3009741"
    },
    {
      id: 118,
      constituencyName: "Chilika",
      secondarySection: "Chilika AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chilika-constituency-result-3009742"
    },
    {
      id: 119,
      constituencyName: "Ranpur",
      secondarySection: "Ranpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-ranpur-constituency-result-3009743"
    },
    {
      id: 120,
      constituencyName: "Khandapada",
      secondarySection: "Khandapada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-khandapada-constituency-result-3009744"
    },
    {
      id: 121,
      constituencyName: "Daspalla",
      secondarySection: "Daspalla AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-daspalla-constituency-result-3009745"
    },
    {
      id: 122,
      constituencyName: "Nayagarh",
      secondarySection: "Nayagarh AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-nayagarh-constituency-result-3009746"
    },
    {
      id: 123,
      constituencyName: "Bhanjanagar",
      secondarySection: "Bhanjanagar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bhanjanagar-constituency-result-3009747"
    },
    {
      id: 124,
      constituencyName: "Polasara",
      secondarySection: "Polasara AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-polasara-constituency-result-3009748"
    },
    {
      id: 125,
      constituencyName: "Kabisuryangar",
      secondarySection: "Kabisuryangar AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kabisuryangar-constituency-result-3009749"
    },
    {
      id: 126,
      constituencyName: "Khalikote",
      secondarySection: "Khalikote AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-khalikote-constituency-result-3009750"
    },
    {
      id: 127,
      constituencyName: "Chhatrapur",
      secondarySection: "Chhatrapur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chhatrapur-constituency-result-3009751"
    },
    {
      id: 128,
      constituencyName: "Aska",
      secondarySection: "Aska AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-aska-constituency-result-3009752"
    },
    {
      id: 129,
      constituencyName: "Surada",
      secondarySection: "Surada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-surada-constituency-result-3009753"
    },
    {
      id: 130,
      constituencyName: "Sanakhemundi",
      secondarySection: "Sanakhemundi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-sanakhemundi-constituency-result-3009754"
    },
    {
      id: 131,
      constituencyName: "Hinjili",
      secondarySection: "Hinjili AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-hinjili-constituency-result-3009755"
    },
    {
      id: 132,
      constituencyName: "Gopalpur",
      secondarySection: "Gopalpur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-gopalpur-constituency-result-3009756"
    },
    {
      id: 133,
      constituencyName: "Berhampur",
      secondarySection: "Berhampur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-berhampur-constituency-result-3009757"
    },
    {
      id: 134,
      constituencyName: "Digapahandi",
      secondarySection: "Digapahandi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-digapahandi-constituency-result-3009758"
    },
    {
      id: 135,
      constituencyName: "Chikiti",
      secondarySection: "Chikiti AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chikiti-constituency-result-3009759"
    },
    {
      id: 136,
      constituencyName: "Mohana",
      secondarySection: "Mohana AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-mohana-constituency-result-3009760"
    },
    {
      id: 137,
      constituencyName: "Paralakhemundi",
      secondarySection: "Paralakhemundi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-paralakhemundi-constituency-result-3009761"
    },
    {
      id: 138,
      constituencyName: "Gunupur",
      secondarySection: "Gunupur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-gunupur-constituency-result-3009762"
    },
    {
      id: 139,
      constituencyName: "Bissam Cuttack",
      secondarySection: "Bissam Cuttack AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-bissam-cuttack-constituency-result-3009763"
    },
    {
      id: 140,
      constituencyName: "Rayagada",
      secondarySection: "Rayagada AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-rayagada-constituency-result-3009764"
    },
    {
      id: 141,
      constituencyName: "Laxmipur",
      secondarySection: "Laxmipur AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-laxmipur-constituency-result-3009765"
    },
    {
      id: 142,
      constituencyName: "Kotpad",
      secondarySection: "Kotpad AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-kotpad-constituency-result-3009766"
    },
    {
      id: 143,
      constituencyName: "Jeypore",
      secondarySection: "Jeypore AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-jeypore-constituency-result-3009767"
    },
    {
      id: 144,
      constituencyName: "Koraput",
      secondarySection: "Koraput AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-koraput-constituency-result-3009768"
    },
    {
      id: 145,
      constituencyName: "Pottangi",
      secondarySection: "Pottangi AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-pottangi-constituency-result-3009769"
    },
    {
      id: 146,
      constituencyName: "Malkangiri",
      secondarySection: "Malkangiri AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-malkangiri-constituency-result-3009770"
    },
    {
      id: 147,
      constituencyName: "Chitrakonda",
      secondarySection: "Chitrakonda AC (Odisha)",
      publishedUrl:
        "https://www.deccanherald.com/elections/odisha/odisha-assembly-elections-2024-chitrakonda-constituency-result-3009771"
    }
  ],
  SIKKIM: [
    {
      id: 1,
      constituencyName: "Yoksam-Tashiding",
      secondarySection: "Yoksam-Tashiding AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-yoksam-tashiding-constituency-result-3009369"
    },
    {
      id: 2,
      constituencyName: "Yangthang",
      secondarySection: "Yangthang AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-yangthang-constituency-result-3009772"
    },
    {
      id: 3,
      constituencyName: "Maneybung-Dentam",
      secondarySection: "Maneybung-Dentam AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-maneybung-dentam-constituency-result-3009773"
    },
    {
      id: 4,
      constituencyName: "Gyalshing-Barnyak",
      secondarySection: "Gyalshing-Barnyak AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-gyalshing-barnyak-constituency-result-3009774"
    },
    {
      id: 5,
      constituencyName: "Rinchenpong",
      secondarySection: "Rinchenpong AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-rinchenpong-constituency-result-3009775"
    },
    {
      id: 6,
      constituencyName: "Daramdin",
      secondarySection: "Daramdin AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-daramdin-constituency-result-3009776"
    },
    {
      id: 7,
      constituencyName: "Soreng-Chakung",
      secondarySection: "Soreng-Chakung AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-soreng-chakung-constituency-result-3009777"
    },
    {
      id: 8,
      constituencyName: "Salghari-Zoom",
      secondarySection: "Salghari-Zoom AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-salghari-zoom-constituency-result-3009778"
    },
    {
      id: 9,
      constituencyName: "Barfung",
      secondarySection: "Barfung AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-barfung-constituency-result-3009779"
    },
    {
      id: 10,
      constituencyName: "Poklok-Kamrang",
      secondarySection: "Poklok-Kamrang AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-poklok-kamrang-constituency-result-3009780"
    },
    {
      id: 11,
      constituencyName: "Namchi-Singhithang",
      secondarySection: "Namchi-Singhithang AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-namchi-singhithang-constituency-result-3009781"
    },
    {
      id: 12,
      constituencyName: "Melli",
      secondarySection: "Melli AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-melli-constituency-result-3009782"
    },
    {
      id: 13,
      constituencyName: "Namthang-Rateypani",
      secondarySection: "Namthang-Rateypani AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-namthang-rateypani-constituency-result-3009783"
    },
    {
      id: 14,
      constituencyName: "Temi-Namphing",
      secondarySection: "Temi-Namphing AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-temi-namphing-constituency-result-3009784"
    },
    {
      id: 15,
      constituencyName: "Rangang-Yangang",
      secondarySection: "Rangang-Yangang AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-rangang-yangang-constituency-result-3009785"
    },
    {
      id: 16,
      constituencyName: "Tumen-Lingi",
      secondarySection: "Tumen-Lingi AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-tumen-lingi-constituency-result-3009786"
    },
    {
      id: 17,
      constituencyName: "Khamdong-Singtam",
      secondarySection: "Khamdong-Singtam AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-khamdong-singtam-constituency-result-3009787"
    },
    {
      id: 18,
      constituencyName: "West Pendam",
      secondarySection: "West Pendam AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-west-pendam-constituency-result-3009788"
    },
    {
      id: 19,
      constituencyName: "Rhenock",
      secondarySection: "Rhenock AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-rhenock-constituency-result-3009789"
    },
    {
      id: 20,
      constituencyName: "Chujachen",
      secondarySection: "Chujachen AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-chujachen-constituency-result-3009790"
    },
    {
      id: 21,
      constituencyName: "Gnathang-Machong",
      secondarySection: "Gnathang-Machong AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-gnathang-machong-constituency-result-3009791"
    },
    {
      id: 22,
      constituencyName: "Namcheybung",
      secondarySection: "Namcheybung AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-namcheybung-constituency-result-3009792"
    },
    {
      id: 23,
      constituencyName: "Shyari",
      secondarySection: "Shyari AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-shyari-constituency-result-3009793"
    },
    {
      id: 24,
      constituencyName: "Martam-Rumtek",
      secondarySection: "Martam-Rumtek AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-martam-rumtek-constituency-result-3009794"
    },
    {
      id: 25,
      constituencyName: "Upper Tadong",
      secondarySection: "Upper Tadong AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-upper-tadong-constituency-result-3009795"
    },
    {
      id: 26,
      constituencyName: "Arithang",
      secondarySection: "Arithang AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-arithang-constituency-result-3009796"
    },
    {
      id: 27,
      constituencyName: "Gangtok",
      secondarySection: "Gangtok AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-gangtok-constituency-result-3009797"
    },
    {
      id: 28,
      constituencyName: "Upper Burtuk",
      secondarySection: "Upper Burtuk AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-upper-burtuk-constituency-result-3009798"
    },
    {
      id: 29,
      constituencyName: "Kabi Lungchuk",
      secondarySection: "Kabi Lungchuk AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-kabi-lungchuk-constituency-result-3009799"
    },
    {
      id: 30,
      constituencyName: "Djongu",
      secondarySection: "Djongu AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-djongu-constituency-result-3009800"
    },
    {
      id: 31,
      constituencyName: "Lachen Mangan",
      secondarySection: "Lachen Mangan AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-lachen-mangan-constituency-result-3009801"
    },
    {
      id: 32,
      constituencyName: "Sangha",
      secondarySection: "Sangha AC (Sikkim)",
      publishedUrl:
        "https://www.deccanherald.com/elections/sikkim/sikkim-assembly-elections-2024-sangha-constituency-result-3009802"
    }
  ]
};

const stateElections2024AllRecords = [];
Object.keys(stateElections2024ConstituencyData).forEach((item) => {
  stateElections2024AllRecords.push(...stateElections2024ConstituencyData[item]);
});

const assemblyElection2024SlugData = [
  // {
  //   state: "HARYANA",
  //   slug: "assembly-elections-2024",
  //   showStateTabs: true
  // }
  {
    state: "MAHARASHTRA",
    slug: "maharashtra-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "JHARKHAND",
    slug: "jharkhand-assembly-elections-2024",
    showStateTabs: false
  },

  {
    state: "MAHARASHTRA",
    slug: "assembly-elections-2024",
    showStateTabs: true
  }
];

const assemblyElection2024SlugData_JK_HR = [
  {
    state: "HARYANA",
    slug: "haryana-assembly-elections-2024",
    showStateTabs: false
  },
  {
    state: "J&K",
    slug: "jammu-and-kashmir-assembly-elections-2024",
    showStateTabs: false
  },
  {}
];
const assemblyElection2024SlugData_Delhi = [
  {
    state: "DELHI",
    slug: "delhi-assembly-elections-2025",
    showStateTabs: false
  },
  {}
];
const assemblyElection2025SlugData_Bihar = [
  {
    state: "BIHAR",
    slug: "bihar-assembly-elections-2025",
    showStateTabs: false
  },
  {}
];
const assemblyElection2024ConstituencyData = {
  BIHAR: [
    {
      id: 639817,
      constituencyName: "Valmiki Nagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
      "https://www.deccanherald.com/elections/bihar/valmiki-nagar-constituency-results-2025-bihar-assembly-election-3781924"
    },
    {
      id: 484421,
      constituencyName: "Ramnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/ramnagar-constituency-results-2025-bihar-assembly-election-3781925"
    },
    {
      id: 912142,
      constituencyName: "Narkatiaganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/narkatiaganj-constituency-results-2025-bihar-assembly-election-3781923"
    },
    {
      id: 163135,
      constituencyName: "Bagaha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bagaha-constituency-results-2025-bihar-assembly-election-3781926"
    },
    {
      id: 204457,
      constituencyName: "Lauriya",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/lauriya-constituency-results-2025-bihar-assembly-election-3781927"
    },
    {
      id: 780580,
      constituencyName: "Nautan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nautan-constituency-results-2025-bihar-assembly-election-3781928"
    },
    {
      id: 249431,
      constituencyName: "Chanpatia",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chanpatia-constituency-results-2025-bihar-assembly-election-3781929"
    },
    {
      id: 660763,
      constituencyName: "Bettiah",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bettiah-constituency-results-2025-bihar-assembly-election-3781930"
    },
    {
      id: 952529,
      constituencyName: "Sikta",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sikta-constituency-results-2025-bihar-assembly-election-3781931"
    },
    {
      id: 494264,
      constituencyName: "Raxaul",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/raxaul-constituency-results-2025-bihar-assembly-election-3781932"
    },
    {
      id: 976548,
      constituencyName: "Sugauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sugauli-constituency-results-2025-bihar-assembly-election-3781597"
    },
    {
      id: 166796,
      constituencyName: "Narkatiya",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/narkatia-constituency-results-2025-bihar-assembly-election-3781599"
    },
    {
      id: 571848,
      constituencyName: "Harsidhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/harsidhi-constituency-results-2025-bihar-assembly-election-3781598"
    },
    {
      id: 621334,
      constituencyName: "Govindganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/govindganj-constituency-results-2025-bihar-assembly-election-3781600"
    },
    {
      id: 961764,
      constituencyName: "Kesaria",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kesaria-constituency-results-2025-bihar-assembly-election-3781601"
    },
    {
      id: 186161,
      constituencyName: "Kalyanpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kalyanpur-constituency-results-2025-bihar-assembly-election-3781933"
    },
    {
      id: 492327,
      constituencyName: "Pipra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/pipra-constituency-results-2025-bihar-assembly-election-3781934"
    },
    {
      id: 959405,
      constituencyName: "Madhuban",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/madhuban-constituency-results-2025-bihar-assembly-election-3781935"
    },
    {
      id: 84630,
      constituencyName: "Motihari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/motihari-constituency-results-2025-bihar-assembly-election-3781936"
    },
    {
      id: 580853,
      constituencyName: "Chiraia",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chiraia-constituency-results-2025-bihar-assembly-election-3781937"
    },
    {
      id: 566498,
      constituencyName: "Dhaka",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/dhaka-constituency-results-2025-bihar-assembly-election-3781938"
    },
    {
      id: 66867,
      constituencyName: "Sheohar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sheohar-constituency-results-2025-bihar-assembly-election-3781939"
    },
    {
      id: 501461,
      constituencyName: "Riga",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/riga-constituency-results-2025-bihar-assembly-election-3781940"
    },
    {
      id: 534892,
      constituencyName: "Bathnaha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bathnaha-constituency-results-2025-bihar-assembly-election-3781941"
    },
    {
      id: 284059,
      constituencyName: "Parihar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/parihar-constituency-results-2025-bihar-assembly-election-3781942"
    },
    {
      id: 17139,
      constituencyName: "Sursand",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sursand-constituency-results-2025-bihar-assembly-election-3781945"
    },
    {
      id: 844977,
      constituencyName: "Bajpatti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bajpatti-constituency-results-2025-bihar-assembly-election-3781944"
    },
    {
      id: 340727,
      constituencyName: "Sitamarhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sitamarhi-constituency-results-2025-bihar-assembly-election-3781943"
    },
    {
      id: 374208,
      constituencyName: "Runnisaidpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/runnisaidpur-constituency-results-2025-bihar-assembly-election-3781946"
    },
    {
      id: 769156,
      constituencyName: "Belsand",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/belsand-constituency-results-2025-bihar-assembly-election-3781947"
    },
    {
      id: 782532,
      constituencyName: "Harlakhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/harlakhi-constituency-results-2025-bihar-assembly-election-3781948"
    },
    {
      id: 997066,
      constituencyName: "Benipatti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/benipatti-constituency-results-2025-bihar-assembly-election-3781949"
    },
    {
      id: 938071,
      constituencyName: "Khajauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/khajauli-constituency-results-2025-bihar-assembly-election-3781950"
    },
    {
      id: 353811,
      constituencyName: "Babubarhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/babubarhi-constituency-results-2025-bihar-assembly-election-3781951"
    },
    {
      id: 182362,
      constituencyName: "Bisfi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bisfi-constituency-results-2025-bihar-assembly-election-3781952"
    },
    {
      id: 24269,
      constituencyName: "Madhubani",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/madhubani-constituency-results-2025-bihar-assembly-election-3781953"
    },
    {
      id: 652915,
      constituencyName: "Rajnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rajnagar-constituency-results-2025-bihar-assembly-election-3781954"
    },
    {
      id: 522871,
      constituencyName: "Jhanjharpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jhanjharpur-constituency-results-2025-bihar-assembly-election-3781955"
    },
    {
      id: 371730,
      constituencyName: "Phulparas",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/phulparas-constituency-results-2025-bihar-assembly-election-3781956"
    },
    {
      id: 526786,
      constituencyName: "Laukaha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/laukaha-constituency-results-2025-bihar-assembly-election-3781957"
    },
    {
      id: 220066,
      constituencyName: "Nirmali",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nirmali-constituency-results-2025-bihar-assembly-election-3781959"
    },
    {
      id: 490401,
      constituencyName: "Pipra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/pipra-constituency-results-2025-bihar-assembly-election-3781934"
    },
    {
      id: 986249,
      constituencyName: "Supaul",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/supaul-constituency-results-2025-bihar-assembly-election-3781960"
    },
    {
      id: 731843,
      constituencyName: "Triveniganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/triveniganj-constituency-results-2025-bihar-assembly-election-3781961"
    },
    {
      id: 418719,
      constituencyName: "Chhatapur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chhatapur-constituency-results-2025-bihar-assembly-election-3781962"
    },
    {
      id: 891933,
      constituencyName: "Narpatganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/narpatganj-constituency-results-2025-bihar-assembly-election-3781963"
    },
    {
      id: 75553,
      constituencyName: "Raniganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/raniganj-constituency-results-2025-bihar-assembly-election-3781964"
    },
    {
      id: 559544,
      constituencyName: "Forbesganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/forbesganj-constituency-results-2025-bihar-assembly-election-3781966"
    },
    {
      id: 889518,
      constituencyName: "Araria",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/araria-constituency-results-2025-bihar-assembly-election-3781965"
    },
    {
      id: 638633,
      constituencyName: "Jokihat",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jokihat-constituency-results-2025-bihar-assembly-election-3781967"
    },
    {
      id: 708843,
      constituencyName: "Sikti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sikti-constituency-results-2025-bihar-assembly-election-3781968"
    },
    {
      id: 692912,
      constituencyName: "Bahadurganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bahadurganj-constituency-results-2025-bihar-assembly-election-3781969"
    },
    {
      id: 886411,
      constituencyName: "Thakurganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/thakurganj-constituency-results-2025-bihar-assembly-election-3781970"
    },
    {
      id: 346061,
      constituencyName: "Kishanganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kishanganj-constituency-results-2025-bihar-assembly-election-3781971"
    },
    {
      id: 929624,
      constituencyName: "Kochadhaman",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kochadhaman-constituency-results-2025-bihar-assembly-election-3781972"
    },
    {
      id: 958757,
      constituencyName: "Amour",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/amour-constituency-results-2025-bihar-assembly-election-3781973"
    },
    {
      id: 683559,
      constituencyName: "Baisi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/baisi-constituency-results-2025-bihar-assembly-election-3781974"
    },
    {
      id: 670568,
      constituencyName: "Kasba",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kasba-constituency-results-2025-bihar-assembly-election-3781975"
    },
    {
      id: 639465,
      constituencyName: "Banmankhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/banmankhi-constituency-results-2025-bihar-assembly-election-3781976"
    },
    {
      id: 762391,
      constituencyName: "Rupauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rupauli-constituency-results-2025-bihar-assembly-election-3781977"
    },
    {
      id: 39224,
      constituencyName: "Dhamdaha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/dhamdaha-constituency-results-2025-bihar-assembly-election-3781978"
    },
    {
      id: 678262,
      constituencyName: "Purnia",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/purnia-constituency-results-2025-bihar-assembly-election-3781979"
    },
    {
      id: 388297,
      constituencyName: "Katihar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
      "https://www.deccanherald.com/elections/bihar/katihar-constituency-results-2025-bihar-assembly-election-3781980"
    },
    {
      id: 11510,
      constituencyName: "Kadwa",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kadwa-constituency-results-2025-bihar-assembly-election-3781981"
    },
    {
      id: 383809,
      constituencyName: "Balrampur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/balrampur-constituency-results-2025-bihar-assembly-election-3781982"
    },
    {
      id: 162331,
      constituencyName: "Pranpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/pranpur-constituency-results-2025-bihar-assembly-election-3781983"
    },
    {
      id: 847663,
      constituencyName: "Manihari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/manihari-constituency-results-2025-bihar-assembly-election-3781984"
    },
    {
      id: 405814,
      constituencyName: "Barari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/barari-constituency-results-2025-bihar-assembly-election-3781986"
    },
    {
      id: 605841,
      constituencyName: "Korha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/korha-constituency-results-2025-bihar-assembly-election-3781985"
    },
    {
      id: 155123,
      constituencyName: "Alamnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/alamnagar-constituency-results-2025-bihar-assembly-election-3781987"
    },
    {
      id: 961528,
      constituencyName: "Bihariganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bihariganj-constituency-results-2025-bihar-assembly-election-3781988"
    },
    {
      id: 886263,
      constituencyName: "Singheshwar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/singheshwar-constituency-results-2025-bihar-assembly-election-3781989"
    },
    {
      id: 23174,
      constituencyName: "Madhepura",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/madhepura-constituency-results-2025-bihar-assembly-election-3781990"
    },
    {
      id: 786711,
      constituencyName: "Sonbarsha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sonbarsha-constituency-results-2025-bihar-assembly-election-3781993"
    },
    {
      id: 909665,
      constituencyName: "Saharsa",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/saharsa-constituency-results-2025-bihar-assembly-election-3781991"
    },
    {
      id: 219547,
      constituencyName: "Simri Bakhtiarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/simri-bakhtiarpur-constituency-results-2025-bihar-assembly-election-3781992"
    },
    {
      id: 108601,
      constituencyName: "Mahishi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mahishi-constituency-results-2025-bihar-assembly-election-3781996"
    },
    {
      id: 981780,
      constituencyName: "Kusheshwar Asthan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kusheshwar-asthan-constituency-results-2025-bihar-assembly-election-3781995"
    },
    {
      id: 225039,
      constituencyName: "Gaura Bauram",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gaura-bauram-constituency-results-2025-bihar-assembly-election-3781994"
    },
    {
      id: 207098,
      constituencyName: "Benipur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/benipur-constituency-results-2025-bihar-assembly-election-3781997"
    },
    {
      id: 77047,
      constituencyName: "Alinagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/alinagar-constituency-results-2025-bihar-assembly-election-3781998"
    },
    {
      id: 269949,
      constituencyName: "Darbhanga Rural",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/darbhanga-rural-constituency-results-2025-bihar-assembly-election-3781999"
    },
    {
      id: 476774,
      constituencyName: "Darbhanga",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/darbhanga-constituency-results-2025-bihar-assembly-election-3782000"
    },
    {
      id: 697831,
      constituencyName: "Hayaghat",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/hayaghat-constituency-results-2025-bihar-assembly-election-3782001"
    },
    {
      id: 654853,
      constituencyName: "Bahadurpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bahadurpur-constituency-results-2025-bihar-assembly-election-3782002"
    },
    {
      id: 689992,
      constituencyName: "Keoti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/keoti-constituency-results-2025-bihar-assembly-election-3782003"
    },
    {
      id: 264154,
      constituencyName: "Jale",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jale-constituency-results-2025-bihar-assembly-election-3782004"
    },
    {
      id: 798482,
      constituencyName: "Gaighat",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gaighat-constituency-results-2025-bihar-assembly-election-3782005"
    },
    {
      id: 121707,
      constituencyName: "Aurai",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/aurai-constituency-results-2025-bihar-assembly-election-3782006"
    },
    {
      id: 503458,
      constituencyName: "Minapur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/minapur-constituency-results-2025-bihar-assembly-election-3782007"
    },
    {
      id: 320042,
      constituencyName: "Bochahan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bochahan-constituency-results-2025-bihar-assembly-election-3782008"
    },
    {
      id: 351686,
      constituencyName: "Sakra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
      "https://www.deccanherald.com/elections/bihar/sakra-constituency-results-2025-bihar-assembly-election-3782009"
    },
    {
      id: 126632,
      constituencyName: "Kurhani",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kurhani-constituency-results-2025-bihar-assembly-election-3782010"
    },
    {
      id: 701978,
      constituencyName: "Muzaffarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/muzaffarpur-constituency-results-2025-bihar-assembly-election-3782011"
    },
    {
      id: 573770,
      constituencyName: "Kanti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kanti-constituency-results-2025-bihar-assembly-election-3782012"
    },
    {
      id: 695891,
      constituencyName: "Baruraj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/baruraj-constituency-results-2025-bihar-assembly-election-3782013"
    },
    {
      id: 809723,
      constituencyName: "Paroo",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/paroo-constituency-results-2025-bihar-assembly-election-3782014"
    },
    {
      id: 381157,
      constituencyName: "Sahebganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sahebganj-constituency-results-2025-bihar-assembly-election-3782015"
    },
    {
      id: 444961,
      constituencyName: "Baikunthpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/baikunthpur-constituency-results-2025-bihar-assembly-election-3782016"
    },
    {
      id: 596268,
      constituencyName: "Barauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/barauli-constituency-results-2025-bihar-assembly-election-3782017"
    },
    {
      id: 854103,
      constituencyName: "Gopalganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/gopalganj-constituency-results-2025-bihar-assembly-election-3782018"
    },
    {
      id: 972050,
      constituencyName: "Kuchaikote",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/kuchaikote-constituency-results-2025-bihar-assembly-election-3782019"
    },
    {
      id: 522514,
      constituencyName: "Bhore",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bhore-constituency-results-2025-bihar-assembly-election-3782020"
    },
    {
      id: 745686,
      constituencyName: "Hathua",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/hathua-constituency-results-2025-bihar-assembly-election-3782021"
    },
    {
      id: 957688,
      constituencyName: "Siwan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/siwan-constituency-results-2025-bihar-assembly-election-3782022"
    },
    {
      id: 741792,
      constituencyName: "Ziradei",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/ziradei-constituency-results-2025-bihar-assembly-election-3782023"
    },
    {
      id: 863401,
      constituencyName: "Darauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/darauli-constituency-results-2025-bihar-assembly-election-3782024"
    },
    {
      id: 9490,
      constituencyName: "Raghunathpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/raghunathpur-constituency-results-2025-bihar-assembly-election-3782025"
    },
    {
      id: 575145,
      constituencyName: "Daraunda",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/daraunda-constituency-results-2025-bihar-assembly-election-3782026"
    },
    {
      id: 794618,
      constituencyName: "Barharia",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/barharia-constituency-results-2025-bihar-assembly-election-3782027"
    },
    {
      id: 85511,
      constituencyName: "Goriakothi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/goriakothi-constituency-results-2025-bihar-assembly-election-3782028"
    },
    {
      id: 435866,
      constituencyName: "Maharajganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/maharajganj-constituency-results-2025-bihar-assembly-election-3782029"
    },
    {
      id: 289425,
      constituencyName: "Ekma",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/ekma-constituency-results-2025-bihar-assembly-election-3782030"
    },
    {
      id: 175371,
      constituencyName: "Manjhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/manjhi-constituency-results-2025-bihar-assembly-election-3782031"
    },
    {
      id: 70143,
      constituencyName: "Baniapur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/baniapur-constituency-results-2025-bihar-assembly-election-3782032"
    },
    {
      id: 717966,
      constituencyName: "Taraiya",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/taraiya-constituency-results-2025-bihar-assembly-election-3782033"
    },
    {
      id: 243228,
      constituencyName: "Marhaura",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/marhaura-constituency-results-2025-bihar-assembly-election-3782034"
    },
    {
      id: 832240,
      constituencyName: "Chapra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/chapra-constituency-results-2025-bihar-assembly-election-3782035"
    },
    {
      id: 825237,
      constituencyName: "Garkha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/garkha-constituency-results-2025-bihar-assembly-election-3782036"
    },
    {
      id: 617127,
      constituencyName: "Amnour",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/amnour-constituency-results-2025-bihar-assembly-election-3782037"
    },
    {
      id: 186090,
      constituencyName: "Parsa",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/parsa-constituency-results-2025-bihar-assembly-election-3782039"
    },
    {
      id: 591057,
      constituencyName: "Sonpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sonpur-constituency-results-2025-bihar-assembly-election-3782038"
    },
    {
      id: 487743,
      constituencyName: "Hajipur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/hajipur-constituency-results-2025-bihar-assembly-election-3782040"
    },
    {
      id: 501620,
      constituencyName: "Lalganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/lalganj-constituency-results-2025-bihar-assembly-election-3782042"
    },
    {
      id: 827270,
      constituencyName: "Vaishali",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/vaishali-constituency-results-2025-bihar-assembly-election-3782041"
    },
    {
      id: 612421,
      constituencyName: "Mahua",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mahua-constituency-results-2025-bihar-assembly-election-3782043"
    },
    {
      id: 147264,
      constituencyName: "Raja Pakar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/raja-pakar-constituency-results-2025-bihar-assembly-election-3782044"
    },
    {
      id: 491546,
      constituencyName: "Raghopur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/raghopur-constituency-results-2025-bihar-assembly-election-2-3782045"
    },
    {
      id: 725351,
      constituencyName: "Mahnar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mahnar-constituency-results-2025-bihar-assembly-election-3782046"
    },
    {
      id: 792048,
      constituencyName: "Patepur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/patepur-constituency-results-2025-bihar-assembly-election-3782047"
    },
    {
      id: 495444,
      constituencyName: "Kalyanpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kalyanpur-constituency-results-2025-bihar-assembly-election-3781933"
    },
    {
      id: 662373,
      constituencyName: "Warisnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/warisnagar-constituency-results-2025-bihar-assembly-election-3782049"
    },
    {
      id: 626500,
      constituencyName: "Samastipur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/samastipur-constituency-results-2025-bihar-assembly-election-3782051"
    },
    {
      id: 255452,
      constituencyName: "Ujiarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/ujiarpur-constituency-results-2025-bihar-assembly-election-3782050"
    },
    {
      id: 780752,
      constituencyName: "Morwa",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/morwa-constituency-results-2025-bihar-assembly-election-3782052"
    },
    {
      id: 290454,
      constituencyName: "Sarairanjan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sarairanjan-constituency-results-2025-bihar-assembly-election-3782054"
    },
    {
      id: 811560,
      constituencyName: "Mohiuddinnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mohiuddinnagar-constituency-results-2025-bihar-assembly-election-3782053"
    },
    {
      id: 557427,
      constituencyName: "Bibhutipur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bibhutipur-constituency-results-2025-bihar-assembly-election-3782055"
    },
    {
      id: 301201,
      constituencyName: "Rosera",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rosera-constituency-results-2025-bihar-assembly-election-3782056"
    },
    {
      id: 791441,
      constituencyName: "Hasanpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/hasanpur-constituency-results-2025-bihar-assembly-election-3782057"
    },
    {
      id: 743598,
      constituencyName: "Cheria-Bariarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/cheria-bariarpur-constituency-results-2025-bihar-assembly-election-3782058"
    },
    {
      id: 745871,
      constituencyName: "Bachhwara",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bachhwara-constituency-results-2025-bihar-assembly-election-3782060"
    },
    {
      id: 949853,
      constituencyName: "Teghra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/teghra-constituency-results-2025-bihar-assembly-election-3782059"
    },
    {
      id: 852822,
      constituencyName: "Matihani",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/matihani-constituency-results-2025-bihar-assembly-election-3782061"
    },
    {
      id: 129250,
      constituencyName: "Sahebpur Kamal",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/sahebpur-kamal-constituency-results-2025-bihar-assembly-election-3782062"
    },
    {
      id: 781652,
      constituencyName: "Begusarai",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/begusarai-constituency-results-2025-bihar-assembly-election-3782063"
    },
    {
      id: 349706,
      constituencyName: "Bakhri",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bakhri-constituency-results-2025-bihar-assembly-election-3782064"
    },
    {
      id: 242995,
      constituencyName: "Alauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/alauli-constituency-results-2025-bihar-assembly-election-3782065"
    },
    {
      id: 769544,
      constituencyName: "Khagaria",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/khagaria-constituency-results-2025-bihar-assembly-election-3782066"
    },
    {
      id: 669437,
      constituencyName: "Beldaur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/beldaur-constituency-results-2025-bihar-assembly-election-3782067"
    },
    {
      id: 178103,
      constituencyName: "Parbatta",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/parbatta-constituency-results-2025-bihar-assembly-election-3782068"
    },
    {
      id: 838393,
      constituencyName: "Bihpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bihpur-constituency-results-2025-bihar-assembly-election-3782069"
    },
    {
      id: 267858,
      constituencyName: "Gopalpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gopalpur-constituency-results-2025-bihar-assembly-election-3782070"
    },
    {
      id: 222473,
      constituencyName: "Pirpainti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/pirpainti-constituency-results-2025-bihar-assembly-election-3782071"
    },
    {
      id: 742231,
      constituencyName: "Kahalgaon",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/kahalgaon-constituency-results-2025-bihar-assembly-election-3782072"
    },
    {
      id: 477886,
      constituencyName: "Bhagalpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bhagalpur-constituency-results-2025-bihar-assembly-election-3782073"
    },
    {
      id: 299191,
      constituencyName: "Sultanganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/sultanganj-constituency-results-2025-bihar-assembly-election-3782074"
    },
    {
      id: 81151,
      constituencyName: "Nathnagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/nathnagar-constituency-results-2025-bihar-assembly-election-3782075"
    },
    {
      id: 308579,
      constituencyName: "Amarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/amarpur-constituency-results-2025-bihar-assembly-election-3782076"
    },
    {
      id: 518508,
      constituencyName: "Dhoraiya",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/dhoraiya-constituency-results-2025-bihar-assembly-election-3782077"
    },
    {
      id: 909561,
      constituencyName: "Banka",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/banka-constituency-results-2025-bihar-assembly-election-3782078"
    },
    {
      id: 542931,
      constituencyName: "Katoria",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/katoria-constituency-results-2025-bihar-assembly-election-3782079"
    },
    {
      id: 166434,
      constituencyName: "Belhar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/belhar-constituency-results-2025-bihar-assembly-election-3782080"
    },
    {
      id: 526895,
      constituencyName: "Tarapur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/tarapur-constituency-results-2025-bihar-assembly-election-3782081"
    },
    {
      id: 667261,
      constituencyName: "Munger",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/munger-constituency-results-2025-bihar-assembly-election-3782082"
    },
    {
      id: 907728,
      constituencyName: "Jamalpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jamalpur-constituency-results-2025-bihar-assembly-election-3782083"
    },
    {
      id: 476189,
      constituencyName: "Suryagarha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/suryagarha-constituency-results-2025-bihar-assembly-election-3782084"
    },
    {
      id: 811713,
      constituencyName: "Lakhisarai",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/lakhisarai-constituency-results-2025-bihar-assembly-election-3782085"
    },
    {
      id: 932597,
      constituencyName: "Sheikhpura",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sheikhpura-constituency-results-2025-bihar-assembly-election-3782086"
    },
    {
      id: 887499,
      constituencyName: "Barbigha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/barbigha-constituency-results-2025-bihar-assembly-election-3782087"
    },
    {
      id: 305820,
      constituencyName: "Asthawan",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/asthawan-constituency-results-2025-bihar-assembly-election-3782088"
    },
    {
      id: 465049,
      constituencyName: "Biharsharif",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/biharsharif-constituency-results-2025-bihar-assembly-election-3782089"
    },
    {
      id: 435574,
      constituencyName: "Rajgir",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rajgir-constituency-results-2025-bihar-assembly-election-3782090"
    },
    {
      id: 90827,
      constituencyName: "Islampur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/islampur-constituency-results-2025-bihar-assembly-election-3782091"
    },
    {
      id: 309099,
      constituencyName: "Hilsa",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/hilsa-constituency-results-2025-bihar-assembly-election-3782092"
    },
    {
      id: 515604,
      constituencyName: "Nalanda",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nalanda-constituency-results-2025-bihar-assembly-election-3782093"
    },
    {
      id: 549994,
      constituencyName: "Harnaut",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/harnaut-constituency-results-2025-bihar-assembly-election-3782094"
    },
    {
      id: 191584,
      constituencyName: "Mokama",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mokama-constituency-results-2025-bihar-assembly-election-3782095"
    },
    {
      id: 353019,
      constituencyName: "Barh",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/barh-constituency-results-2025-bihar-assembly-election-3782096"
    },
    {
      id: 109909,
      constituencyName: "Bakhtiarpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bakhtiarpur-constituency-results-2025-bihar-assembly-election-3782097"
    },
    {
      id: 541111,
      constituencyName: "Digha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/digha-constituency-results-2025-bihar-assembly-election-3782098"
    },
    {
      id: 607115,
      constituencyName: "Bankipur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/bankipur-constituency-results-2025-bihar-assembly-election-3782099"
    },
    {
      id: 357044,
      constituencyName: "Kumhrar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/kumhrar-constituency-results-2025-bihar-assembly-election-3782100"
    },
    {
      id: 426735,
      constituencyName: "Patna Sahib",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/patna-sahib-constituency-results-2025-bihar-assembly-election-3782101"
    },
    {
      id: 641919,
      constituencyName: "Fatuha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/fatuha-constituency-results-2025-bihar-assembly-election-3782102"
    },
    {
      id: 659287,
      constituencyName: "Danapur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/danapur-constituency-results-2025-bihar-assembly-election-3782103"
    },
    {
      id: 930990,
      constituencyName: "Maner",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/maner-constituency-results-2025-bihar-assembly-election-3782104"
    },
    {
      id: 991846,
      constituencyName: "Phulwari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/phulwari-constituency-results-2025-bihar-assembly-election-3782105"
    },
    {
      id: 875694,
      constituencyName: "Masaurhi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/masaurhi-constituency-results-2025-bihar-assembly-election-3782106"
    },
    {
      id: 170393,
      constituencyName: "Paliganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/paliganj-constituency-results-2025-bihar-assembly-election-3782107"
    },
    {
      id: 849841,
      constituencyName: "Bikram",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bikram-constituency-results-2025-bihar-assembly-election-3782108"
    },
    {
      id: 662611,
      constituencyName: "Sandesh",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sandesh-constituency-results-2025-bihar-assembly-election-3782109"
    },
    {
      id: 445055,
      constituencyName: "Barhara",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/barhara-constituency-results-2025-bihar-assembly-election-3782110"
    },
    {
      id: 464898,
      constituencyName: "Arrah",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/arrah-constituency-results-2025-bihar-assembly-election-3782111"
    },
    {
      id: 885985,
      constituencyName: "Agiaon",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/agiaon-constituency-results-2025-bihar-assembly-election-3782112"
    },
    {
      id: 818578,
      constituencyName: "Tarari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/tarari-constituency-results-2025-bihar-assembly-election-3782113"
    },
    {
      id: 460612,
      constituencyName: "Jagdishpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jagdishpur-constituency-results-2025-bihar-assembly-election-3782114"
    },
    {
      id: 682822,
      constituencyName: "Shahpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/shahpur-constituency-results-2025-bihar-assembly-election-3782115"
    },
    {
      id: 82718,
      constituencyName: "Brahampur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/brahampur-constituency-results-2025-bihar-assembly-election-3782116"
    },
    {
      id: 244919,
      constituencyName: "Buxar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/buxar-constituency-results-2025-bihar-assembly-election-3782117"
    },
    {
      id: 341673,
      constituencyName: "Dumraon",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/dumraon-constituency-results-2025-bihar-assembly-election-3782118"
    },
    {
      id: 187934,
      constituencyName: "Rajpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rajpur-constituency-results-2025-bihar-assembly-election-3782119"
    },
    {
      id: 437389,
      constituencyName: "Ramgarh",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/ramgarh-constituency-results-2025-bihar-assembly-election-3782120"
    },
    {
      id: 959325,
      constituencyName: "Mohania",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/mohania-constituency-results-2025-bihar-assembly-election-3782121"
    },
    {
      id: 935324,
      constituencyName: "Bhabua",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bhabua-constituency-results-2025-bihar-assembly-election-3782122"
    },
    {
      id: 6501,
      constituencyName: "Chainpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chainpur-constituency-results-2025-bihar-assembly-election-3782123"
    },
    {
      id: 57154,
      constituencyName: "Chenari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chenari-constituency-results-2025-bihar-assembly-election-3782124"
    },
    {
      id: 317856,
      constituencyName: "Sasaram",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/sasaram-constituency-results-2025-bihar-assembly-election-3782125"
    },
    {
      id: 658714,
      constituencyName: "Kargahar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kargahar-constituency-results-2025-bihar-assembly-election-3782126"
    },
    {
      id: 341492,
      constituencyName: "Dinara",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/dinara-constituency-results-2025-bihar-assembly-election-3782127"
    },
    {
      id: 922905,
      constituencyName: "Nokha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nokha-constituency-results-2025-bihar-assembly-election-3782128"
    },
    {
      id: 456784,
      constituencyName: "Dehri",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/dehri-constituency-results-2025-bihar-assembly-election-3782129"
    },
    {
      id: 858141,
      constituencyName: "Karakat",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/karakat-constituency-results-2025-bihar-assembly-election-3782130"
    },
    {
      id: 346043,
      constituencyName: "Arwal",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/arwal-constituency-results-2025-bihar-assembly-election-3782131"
    },
    {
      id: 148319,
      constituencyName: "Kurtha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kurtha-constituency-results-2025-bihar-assembly-election-3782132"
    },
    {
      id: 787912,
      constituencyName: "Jehanabad",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jehanabad-constituency-results-2025-bihar-assembly-election-3782133"
    },
    {
      id: 551108,
      constituencyName: "Ghosi",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/ghosi-constituency-results-2025-bihar-assembly-election-3782134"
    },
    {
      id: 438279,
      constituencyName: "Makhdumpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/makhdumpur-constituency-results-2025-bihar-assembly-election-3782135"
    },
    {
      id: 352961,
      constituencyName: "Goh",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl: "https://www.deccanherald.com/elections/bihar/goh-constituency-results-2025-bihar-assembly-election-3782136"
    },
    {
      id: 701054,
      constituencyName: "Obra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/obra-constituency-results-2025-bihar-assembly-election-3782137"
    },
    {
      id: 924635,
      constituencyName: "Nabinagar",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nabinagar-constituency-results-2025-bihar-assembly-election-3782138"
    },
    {
      id: 497256,
      constituencyName: "Kutumba",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/kutumba-constituency-results-2025-bihar-assembly-election-3782139"
    },
    {
      id: 10180,
      constituencyName: "Aurangabad",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/aurangabad-constituency-results-2025-bihar-assembly-election-3782140"
    },
    {
      id: 135393,
      constituencyName: "Rafiganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rafiganj-constituency-results-2025-bihar-assembly-election-3782142"
    },
    {
      id: 253225,
      constituencyName: "Gurua",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gurua-constituency-results-2025-bihar-assembly-election-3782141"
    },
    {
      id: 110946,
      constituencyName: "Sherghati",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sherghati-constituency-results-2025-bihar-assembly-election-3782143"
    },
    {
      id: 959671,
      constituencyName: "Imamganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/imamganj-constituency-results-2025-bihar-assembly-election-3782144"
    },
    {
      id: 491379,
      constituencyName: "Barachatti",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/barachatti-constituency-results-2025-bihar-assembly-election-3782145"
    },
    {
      id: 544735,
      constituencyName: "Bodh Gaya",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/bodh-gaya-constituency-results-2025-bihar-assembly-election-3782146"
    },
    {
      id: 423356,
      constituencyName: "Gaya Town",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gaya-town-constituency-results-2025-bihar-assembly-election-3782147"
    },
    {
      id: 766624,
      constituencyName: "Tikari",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/tikari-constituency-results-2025-bihar-assembly-election-3782148"
    },
    {
      id: 906583,
      constituencyName: "Belaganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/belaganj-constituency-results-2025-bihar-assembly-election-3782149"
    },
    {
      id: 45733,
      constituencyName: "Atri",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/atri-constituency-results-2025-bihar-assembly-election-3782150"
    },
    {
      id: 182253,
      constituencyName: "Wazirganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/wazirganj-constituency-results-2025-bihar-assembly-election-3782151"
    },
    {
      id: 392571,
      constituencyName: "Rajauli",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/rajauli-constituency-results-2025-bihar-assembly-election-3782152"
    },
    {
      id: 991598,
      constituencyName: "Hisua",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/hisua-constituency-results-2025-bihar-assembly-election-3782153"
    },
    {
      id: 477744,
      constituencyName: "Nawada",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/nawada-constituency-results-2025-bihar-assembly-election-3782154"
    },
    {
      id: 166482,
      constituencyName: "Gobindpur",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/gobindpur-constituency-results-2025-bihar-assembly-election-3782155"
    },
    {
      id: 852232,
      constituencyName: "Warsaliganj",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/warsaliganj-constituency-results-2025-bihar-assembly-election-3782156"
    },
    {
      id: 920689,
      constituencyName: "Sikandra",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/sikandra-constituency-results-2025-bihar-assembly-election-3782157"
    },
    {
      id: 746638,
      constituencyName: "Jamui",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
       "https://www.deccanherald.com/elections/bihar/jamui-constituency-results-2025-bihar-assembly-election-3782158"
    },
    {
      id: 651358,
      constituencyName: "Jhajha",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/jhajha-constituency-results-2025-bihar-assembly-election-3782159"
    },
    {
      id: 269154,
      constituencyName: "Chakai",
      primarySection: "Bihar (Elections)",
      secondarySection: "Bihar (India)",
      publishedUrl:
        "https://www.deccanherald.com/elections/bihar/chakai-constituency-results-2025-bihar-assembly-election-3782160"
    }
  ],
  DELHI: [
    {
      id: "1",
      constituencyName: "Narela",
      secondarySection: "Narela (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-narela-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391174"
    },
    {
      id: "2",
      constituencyName: "Burari",
      secondarySection: "Burari (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-burari-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391295"
    },
    {
      id: "3",
      constituencyName: "Timarpur",
      secondarySection: "Timarpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-timarpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391296"
    },
    {
      id: "4",
      constituencyName: "Adarsh Nagar",
      secondarySection: "Adarsh Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-adarsh nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391297"
    },
    {
      id: "5",
      constituencyName: "Badli",
      secondarySection: "Badli (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-badli-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391298"
    },
    {
      id: "6",
      constituencyName: "Rithala",
      secondarySection: "Rithala (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-rithala-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391299"
    },
    {
      id: "7",
      constituencyName: "Bawana",
      secondarySection: "Bawana (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-bawana-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391300"
    },
    {
      id: "8",
      constituencyName: "Mundka",
      secondarySection: "Mundka (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-mundka-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391301"
    },
    {
      id: "9",
      constituencyName: "Kirari",
      secondarySection: "Kirari (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-kirari-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391302"
    },
    {
      id: "10",
      constituencyName: "Sultanpur Majra",
      secondarySection: "Sultanpur Majra (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-sultanpur majra-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391303"
    },
    {
      id: "11",
      constituencyName: "Nangloi Jat",
      secondarySection: "Nangloi Jat (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-nangloi jat-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391304"
    },
    {
      id: "12",
      constituencyName: "Mangol Puri",
      secondarySection: "Mangol Puri (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-mangol puri-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391305"
    },
    {
      id: "13",
      constituencyName: "Rohini",
      secondarySection: "Rohini (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-rohini-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391306"
    },
    {
      id: "14",
      constituencyName: "Shalimar Bagh",
      secondarySection: "Shalimar Bagh (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-shalimar bagh-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391307"
    },
    {
      id: "15",
      constituencyName: "Shakur Basti",
      secondarySection: "Shakur Basti (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-shakur basti-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391308"
    },
    {
      id: "16",
      constituencyName: "Tri Nagar",
      secondarySection: "Tri Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-tri nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391309"
    },
    {
      id: "17",
      constituencyName: "Wazirpur",
      secondarySection: "Wazirpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-wazirpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391310"
    },
    {
      id: "18",
      constituencyName: "Model Town",
      secondarySection: "Model Town (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-model town-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391311"
    },
    {
      id: "19",
      constituencyName: "Sadar Bazar",
      secondarySection: "Sadar Bazar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-sadar bazar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391312"
    },
    {
      id: "20",
      constituencyName: "Chandni Chowk",
      secondarySection: "Chandni Chowk (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-chandni chowk-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391313"
    },
    {
      id: "21",
      constituencyName: "Matia Mahal",
      secondarySection: "Matia Mahal (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-matia mahal-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391314"
    },
    {
      id: "22",
      constituencyName: "Ballimaran",
      secondarySection: "Ballimaran (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-ballimaran-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391315"
    },
    {
      id: "23",
      constituencyName: "Karol Bagh",
      secondarySection: "Karol Bagh (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-karol bagh-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391316"
    },
    {
      id: "24",
      constituencyName: "Patel Nagar",
      secondarySection: "Patel Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-patel nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391317"
    },
    {
      id: "25",
      constituencyName: "Moti Nagar",
      secondarySection: "Moti Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-moti nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391318"
    },
    {
      id: "26",
      constituencyName: "Madipur",
      secondarySection: "Madipur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-madipur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391319"
    },
    {
      id: "27",
      constituencyName: "Rajouri Garden",
      secondarySection: "Rajouri Garden (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-rajouri garden-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391320"
    },
    {
      id: "28",
      constituencyName: "Hari Nagar",
      secondarySection: "Hari Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-hari nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391321"
    },
    {
      id: "29",
      constituencyName: "Tilak Nagar",
      secondarySection: "Tilak Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-tilak nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391322"
    },
    {
      id: "30",
      constituencyName: "Janakpuri",
      secondarySection: "Janakpuri (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-janakpuri-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391323"
    },
    {
      id: "31",
      constituencyName: "Vikaspuri",
      secondarySection: "Vikaspuri (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-vikaspuri-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391324"
    },
    {
      id: "32",
      constituencyName: "Uttam Nagar",
      secondarySection: "Uttam Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-uttam nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391325"
    },
    {
      id: "33",
      constituencyName: "Dwarka",
      secondarySection: "Dwarka (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-dwarka-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391326"
    },
    {
      id: "34",
      constituencyName: "Matiala",
      secondarySection: "Matiala (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-matiala-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391327"
    },
    {
      id: "35",
      constituencyName: "Najafgarh",
      secondarySection: "Najafgarh (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-najafgarh-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391328"
    },
    {
      id: "36",
      constituencyName: "Bijwasan",
      secondarySection: "Bijwasan (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-bijwasan-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391329"
    },
    {
      id: "37",
      constituencyName: "Palam",
      secondarySection: "Palam (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-palam-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391330"
    },
    {
      id: "38",
      constituencyName: "Delhi Cantt",
      secondarySection: "Delhi Cantt (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-delhi cantt-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391331"
    },
    {
      id: "39",
      constituencyName: "Rajinder Nagar",
      secondarySection: "Rajinder Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-rajinder nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391332"
    },
    {
      id: "40",
      constituencyName: "New Delhi",
      secondarySection: "New Delhi (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-new delhi-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391333"
    },
    {
      id: "41",
      constituencyName: "Jangpura",
      secondarySection: "Jangpura (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-jangpura-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391334"
    },
    {
      id: "42",
      constituencyName: "Kasturba Nagar",
      secondarySection: "Kasturba Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-kasturba nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391335"
    },
    {
      id: "43",
      constituencyName: "Malviya Nagar",
      secondarySection: "Malviya Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-malviya nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391336"
    },
    {
      id: "44",
      constituencyName: "R K Puram",
      secondarySection: "R K Puram (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-r k puram-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391337"
    },
    {
      id: "45",
      constituencyName: "Mehrauli",
      secondarySection: "Mehrauli (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-mehrauli-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391338"
    },
    {
      id: "46",
      constituencyName: "Chhatarpur",
      secondarySection: "Chhatarpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-chhatarpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391339"
    },
    {
      id: "47",
      constituencyName: "Deoli",
      secondarySection: "Deoli (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-deoli-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391340"
    },
    {
      id: "48",
      constituencyName: "Ambedkar Nagar",
      secondarySection: "Ambedkar Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-ambedkar nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391341"
    },
    {
      id: "49",
      constituencyName: "Sangam Vihar",
      secondarySection: "Sangam Vihar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-sangam vihar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391342"
    },
    {
      id: "50",
      constituencyName: "Greater Kailash",
      secondarySection: "Greater Kailash (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-greater kailash-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391343"
    },
    {
      id: "51",
      constituencyName: "Kalkaji",
      secondarySection: "Kalkaji (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-kalkaji-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391344"
    },
    {
      id: "52",
      constituencyName: "Tughlakabad",
      secondarySection: "Tughlakabad (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-tughlakabad-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391345"
    },
    {
      id: "53",
      constituencyName: "Badarpur",
      secondarySection: "Badarpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-badarpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391346"
    },
    {
      id: "54",
      constituencyName: "Okhla",
      secondarySection: "Okhla (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-okhla-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391347"
    },
    {
      id: "55",
      constituencyName: "Trilokpuri",
      secondarySection: "Trilokpuri (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-trilokpuri-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391348"
    },
    {
      id: "56",
      constituencyName: "Kondli",
      secondarySection: "Kondli (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-kondli-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391349"
    },
    {
      id: "57",
      constituencyName: "Patparganj",
      secondarySection: "Patparganj (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-patparganj-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391350"
    },
    {
      id: "58",
      constituencyName: "Laxmi Nagar",
      secondarySection: "Laxmi Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-laxmi nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391351"
    },
    {
      id: "59",
      constituencyName: "Vishwas Nagar",
      secondarySection: "Vishwas Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-vishwas nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391352"
    },
    {
      id: "60",
      constituencyName: "Krishna Nagar",
      secondarySection: "Krishna Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-krishna nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391353"
    },
    {
      id: "61",
      constituencyName: "Gandhi Nagar",
      secondarySection: "Gandhi Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-gandhi nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391354"
    },
    {
      id: "62",
      constituencyName: "Shahdara",
      secondarySection: "Shahdara (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-shahdara-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391355"
    },
    {
      id: "63",
      constituencyName: "Seema Puri",
      secondarySection: "Seema Puri (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-seema puri-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391356"
    },
    {
      id: "64",
      constituencyName: "Rohtas Nagar",
      secondarySection: "Rohtas Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-rohtas nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391357"
    },
    {
      id: "65",
      constituencyName: "Seelampur",
      secondarySection: "Seelampur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-seelampur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391358"
    },
    {
      id: "66",
      constituencyName: "Ghonda",
      secondarySection: "Ghonda (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-ghonda-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391359"
    },
    {
      id: "67",
      constituencyName: "Babarpur",
      secondarySection: "Babarpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-babarpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391364"
    },
    {
      id: "68",
      constituencyName: "Gokalpur",
      secondarySection: "Gokalpur (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-gokalpur-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391365"
    },
    {
      id: "69",
      constituencyName: "Mustafabad",
      secondarySection: "Mustafabad (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-mustafabad-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391366"
    },
    {
      id: "70",
      constituencyName: "Karawal Nagar",
      secondarySection: "Karawal Nagar (Delhi)",
      publishedUrl:
        "https://www.deccanherald.com/elections/delhi/delhi-elections-2025-karawal nagar-assembly-constituency-results-check-winners-and-losers-aap-bjp-congress-3391367"
    }
  ],
  MAHARASHTRA: [
    {
      id: 1,
      constituencyName: "Akkalkuwa",
      secondarySection: "Akkalkuwa (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akkalkuwa-constituency-results/3255082"
    },
    {
      id: 2,
      constituencyName: "Shahada",
      secondarySection: "Shahada (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shahada-constituency-results/3255172"
    },
    {
      id: 3,
      constituencyName: "Nandurbar",
      secondarySection: "Nandurbar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nandurbar-constituency-results/3255173"
    },
    {
      id: 4,
      constituencyName: "Nawapur",
      secondarySection: "Nawapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nawapur-constituency-results/3255174"
    },
    {
      id: 5,
      constituencyName: "Sakri",
      secondarySection: "Sakri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sakri-constituency-results/3255175"
    },
    {
      id: 6,
      constituencyName: "Dhule Rural",
      secondarySection: "Dhule Rural (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dhule-rural-constituency-results/3255176"
    },
    {
      id: 7,
      constituencyName: "Dhule City",
      secondarySection: "Dhule City (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dhule-city-constituency-results/3255177"
    },
    {
      id: 8,
      constituencyName: "Shindkheda",
      secondarySection: "Shindkheda (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shindkheda-constituency-results/3255178"
    },
    {
      id: 9,
      constituencyName: "Shirpur",
      secondarySection: "Shirpur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shirpur-constituency-results/3255179"
    },
    {
      id: 10,
      constituencyName: "Chopda",
      secondarySection: "Chopda (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chopda-constituency-results/3255180"
    },
    {
      id: 11,
      constituencyName: "Raver",
      secondarySection: "Raver (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-raver-constituency-results/3255181"
    },
    {
      id: 12,
      constituencyName: "Bhusawal",
      secondarySection: "Bhusawal (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhusawal-constituency-results/3255182"
    },
    {
      id: 13,
      constituencyName: "Jalgaon City",
      secondarySection: "Jalgaon City (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jalgaon-city-constituency-results/3255183"
    },
    {
      id: 14,
      constituencyName: "Jalgaon Rural",
      secondarySection: "Jalgaon Rural (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jalgaon-rural-constituency-results/3255184"
    },
    {
      id: 15,
      constituencyName: "Amalner",
      secondarySection: "Amalner (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-amalner-constituency-results/3255185"
    },
    {
      id: 16,
      constituencyName: "Erandol",
      secondarySection: "Erandol (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-erandol-constituency-results/3255186"
    },
    {
      id: 17,
      constituencyName: "Chalisgaon",
      secondarySection: "Chalisgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chalisgaon-constituency-results/3255187"
    },
    {
      id: 18,
      constituencyName: "Pachora",
      secondarySection: "Pachora (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pachora-constituency-results/3255188"
    },
    {
      id: 19,
      constituencyName: "Jamner",
      secondarySection: "Jamner (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jamner-constituency-results/3255189"
    },
    {
      id: 20,
      constituencyName: "Muktainagar",
      secondarySection: "Muktainagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-muktainagar-constituency-results/3255190"
    },
    {
      id: 21,
      constituencyName: "Malkapur",
      secondarySection: "Malkapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malkapur-constituency-results/3255191"
    },
    {
      id: 22,
      constituencyName: "Buldhana",
      secondarySection: "Buldhana (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-buldhana-constituency-results/3255192"
    },
    {
      id: 23,
      constituencyName: "Chikhli",
      secondarySection: "Chikhli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chikhli-constituency-results/3255193"
    },
    {
      id: 24,
      constituencyName: "Sindkhed Raja",
      secondarySection: "Sindkhed Raja (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sindkhed-raja-constituency-results/3255194"
    },
    {
      id: 25,
      constituencyName: "Mehkar",
      secondarySection: "Mehkar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mehkar-constituency-results/3255195"
    },
    {
      id: 26,
      constituencyName: "Khamgaon",
      secondarySection: "Khamgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-khamgaon-constituency-results/3255196"
    },
    {
      id: 27,
      constituencyName: "Jalgaon (Jamod)",
      secondarySection: "Jalgaon (Jamod) (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jalgaon-jamod-constituency-results/3255197"
    },
    {
      id: 28,
      constituencyName: "Akot",
      secondarySection: "Akot (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akot-constituency-results/3255198"
    },
    {
      id: 29,
      constituencyName: "Balapur",
      secondarySection: "Balapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-balapur-constituency-results/3255199"
    },
    {
      id: 30,
      constituencyName: "Akola West",
      secondarySection: "Akola West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akola-west-constituency-results/3255200"
    },
    {
      id: 31,
      constituencyName: "Akola East",
      secondarySection: "Akola East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akola-east-constituency-results/3255201"
    },
    {
      id: 32,
      constituencyName: "Murtizapur",
      secondarySection: "Murtizapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-murtizapur-constituency-results/3255202"
    },
    {
      id: 33,
      constituencyName: "Risod",
      secondarySection: "Risod (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-risod-constituency-results/3255203"
    },
    {
      id: 34,
      constituencyName: "Washim",
      secondarySection: "Washim (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-washim-constituency-results/3255204"
    },
    {
      id: 35,
      constituencyName: "Karanja",
      secondarySection: "Karanja (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karanja-constituency-results/3255205"
    },
    {
      id: 36,
      constituencyName: "Dhamamgaon Railway",
      secondarySection: "Dhamamgaon Railway (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dhamamgaon-railway-constituency-results/3255206"
    },
    {
      id: 37,
      constituencyName: "Badnera",
      secondarySection: "Badnera (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-badnera-constituency-results/3255207"
    },
    {
      id: 38,
      constituencyName: "Amravati",
      secondarySection: "Amravati (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-amravati-constituency-results/3255208"
    },
    {
      id: 39,
      constituencyName: "Teosa",
      secondarySection: "Teosa (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-teosa-constituency-results/3255209"
    },
    {
      id: 40,
      constituencyName: "Daryapur",
      secondarySection: "Daryapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-daryapur-constituency-results/3255210"
    },
    {
      id: 41,
      constituencyName: "Melghat",
      secondarySection: "Melghat (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-melghat-constituency-results/3255211"
    },
    {
      id: 42,
      constituencyName: "Achalpur",
      secondarySection: "Achalpur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-achalpur-constituency-results/3255212"
    },
    {
      id: 43,
      constituencyName: "Morshi",
      secondarySection: "Morshi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-morshi-constituency-results/3255213"
    },
    {
      id: 44,
      constituencyName: "Arvi",
      secondarySection: "Arvi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-arvi-constituency-results/3255214"
    },
    {
      id: 45,
      constituencyName: "Deoli",
      secondarySection: "Deoli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-deoli-constituency-results/3255215"
    },
    {
      id: 46,
      constituencyName: "Hinganghat",
      secondarySection: "Hinganghat (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hinganghat-constituency-results/3255216"
    },
    {
      id: 47,
      constituencyName: "Wardha",
      secondarySection: "Wardha (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-wardha-constituency-results/3255217"
    },
    {
      id: 48,
      constituencyName: "Katol",
      secondarySection: "Katol (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-katol-constituency-results/3255218"
    },
    {
      id: 49,
      constituencyName: "Savner",
      secondarySection: "Savner (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-savner-constituency-results/3255219"
    },
    {
      id: 50,
      constituencyName: "Hingna",
      secondarySection: "Hingna (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hingna-constituency-results/3255220"
    },
    {
      id: 51,
      constituencyName: "Umred",
      secondarySection: "Umred (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-umred-constituency-results/3255221"
    },
    {
      id: 52,
      constituencyName: "Nagpur South West",
      secondarySection: "Nagpur South West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-south-west-constituency-results/3255222"
    },
    {
      id: 53,
      constituencyName: "Nagpur South",
      secondarySection: "Nagpur South (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-south-constituency-results/3255223"
    },
    {
      id: 54,
      constituencyName: "Nagpur East",
      secondarySection: "Nagpur East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-east-constituency-results/3255224"
    },
    {
      id: 55,
      constituencyName: "Nagpur Central",
      secondarySection: "Nagpur Central (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-central-constituency-results/3255225"
    },
    {
      id: 56,
      constituencyName: "Nagpur West",
      secondarySection: "Nagpur West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-west-constituency-results/3255226"
    },
    {
      id: 57,
      constituencyName: "Nagpur North",
      secondarySection: "Nagpur North (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nagpur-north-constituency-results/3255227"
    },
    {
      id: 58,
      constituencyName: "Kamthi",
      secondarySection: "Kamthi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kamthi-constituency-results/3255228"
    },
    {
      id: 59,
      constituencyName: "Ramtek",
      secondarySection: "Ramtek (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ramtek-constituency-results/3255229"
    },
    {
      id: 60,
      constituencyName: "Tumsar",
      secondarySection: "Tumsar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-tumsar-constituency-results/3255230"
    },
    {
      id: 61,
      constituencyName: "Bhandara",
      secondarySection: "Bhandara (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhandara-constituency-results/3255231"
    },
    {
      id: 62,
      constituencyName: "Sakoli",
      secondarySection: "Sakoli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sakoli-constituency-results/3255232"
    },
    {
      id: 63,
      constituencyName: "Arjuni-Morgaon",
      secondarySection: "Arjuni-Morgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-arjuni-morgaon-constituency-results/3255233"
    },
    {
      id: 64,
      constituencyName: "Tirora",
      secondarySection: "Tirora (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-tirora-constituency-results/3255234"
    },
    {
      id: 65,
      constituencyName: "Gondia",
      secondarySection: "Gondia (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-gondia-constituency-results/3255235"
    },
    {
      id: 66,
      constituencyName: "Amgaon",
      secondarySection: "Amgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-amgaon-constituency-results/3255236"
    },
    {
      id: 67,
      constituencyName: "Armori",
      secondarySection: "Armori (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-armori-constituency-results/3255237"
    },
    {
      id: 68,
      constituencyName: "Gadchiroli",
      secondarySection: "Gadchiroli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-gadchiroli-constituency-results/3255238"
    },
    {
      id: 69,
      constituencyName: "Aheri",
      secondarySection: "Aheri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-aheri-constituency-results/3255239"
    },
    {
      id: 70,
      constituencyName: "Rajura",
      secondarySection: "Rajura (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-rajura-constituency-results/3255240"
    },
    {
      id: 71,
      constituencyName: "Chandrapur",
      secondarySection: "Chandrapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chandrapur-constituency-results/3255241"
    },
    {
      id: 72,
      constituencyName: "Ballarpur",
      secondarySection: "Ballarpur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ballarpur-constituency-results/3255242"
    },
    {
      id: 73,
      constituencyName: "Brahmapuri",
      secondarySection: "Brahmapuri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-brahmapuri-constituency-results/3255243"
    },
    {
      id: 74,
      constituencyName: "Chimur",
      secondarySection: "Chimur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chimur-constituency-results/3255244"
    },
    {
      id: 75,
      constituencyName: "Warora",
      secondarySection: "Warora (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-warora-constituency-results/3255245"
    },
    {
      id: 76,
      constituencyName: "Wani",
      secondarySection: "Wani (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-wani-constituency-results/3255246"
    },
    {
      id: 77,
      constituencyName: "Ralegaon",
      secondarySection: "Ralegaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ralegaon-constituency-results/3255247"
    },
    {
      id: 78,
      constituencyName: "Yavatmal",
      secondarySection: "Yavatmal (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-yavatmal-constituency-results/3255248"
    },
    {
      id: 79,
      constituencyName: "Digras",
      secondarySection: "Digras (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-digras-constituency-results/3255249"
    },
    {
      id: 80,
      constituencyName: "Arni",
      secondarySection: "Arni (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-arni-constituency-results/3255250"
    },
    {
      id: 81,
      constituencyName: "Pusad",
      secondarySection: "Pusad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pusad-constituency-results/3255251"
    },
    {
      id: 82,
      constituencyName: "Umarkhed",
      secondarySection: "Umarkhed (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-umarkhed-constituency-results/3255252"
    },
    {
      id: 83,
      constituencyName: "Kinwat",
      secondarySection: "Kinwat (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kinwat-constituency-results/3255253"
    },
    {
      id: 84,
      constituencyName: "Hadgaon",
      secondarySection: "Hadgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hadgaon-constituency-results/3255254"
    },
    {
      id: 85,
      constituencyName: "Bhokar",
      secondarySection: "Bhokar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhokar-constituency-results/3255255"
    },
    {
      id: 86,
      constituencyName: "Nanded North",
      secondarySection: "Nanded North (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nanded-north-constituency-results/3255256"
    },
    {
      id: 87,
      constituencyName: "Nanded South",
      secondarySection: "Nanded South (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nanded-south-constituency-results/3255257"
    },
    {
      id: 88,
      constituencyName: "Loha",
      secondarySection: "Loha (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-loha-constituency-results/3255258"
    },
    {
      id: 89,
      constituencyName: "Naigaon",
      secondarySection: "Naigaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-naigaon-constituency-results/3255259"
    },
    {
      id: 90,
      constituencyName: "Deglur",
      secondarySection: "Deglur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-deglur-constituency-results/3255260"
    },
    {
      id: 91,
      constituencyName: "Mukhed",
      secondarySection: "Mukhed (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mukhed-constituency-results/3255261"
    },
    {
      id: 92,
      constituencyName: "Basmath",
      secondarySection: "Basmath (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-basmath-constituency-results/3255262"
    },
    {
      id: 93,
      constituencyName: "Kalamnuri",
      secondarySection: "Kalamnuri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalamnuri-constituency-results/3255263"
    },
    {
      id: 94,
      constituencyName: "Hingoli",
      secondarySection: "Hingoli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hingoli-constituency-results/3255264"
    },
    {
      id: 95,
      constituencyName: "Jintur",
      secondarySection: "Jintur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jintur-constituency-results/3255265"
    },
    {
      id: 96,
      constituencyName: "Parbhani",
      secondarySection: "Parbhani (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-parbhani-constituency-results/3255266"
    },
    {
      id: 97,
      constituencyName: "Gangakhed",
      secondarySection: "Gangakhed (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-gangakhed-constituency-results/3255267"
    },
    {
      id: 98,
      constituencyName: "Pathri",
      secondarySection: "Pathri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pathri-constituency-results/3255268"
    },
    {
      id: 99,
      constituencyName: "Partur",
      secondarySection: "Partur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-partur-constituency-results/3255269"
    },
    {
      id: 100,
      constituencyName: "Gansavangi",
      secondarySection: "Gansavangi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-gansavangi-constituency-results/3255270"
    },
    {
      id: 101,
      constituencyName: "Jalna",
      secondarySection: "Jalna (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jalna-constituency-results/3255271"
    },
    {
      id: 102,
      constituencyName: "Badnapur",
      secondarySection: "Badnapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-badnapur-constituency-results/3255272"
    },
    {
      id: 103,
      constituencyName: "Bhokardan",
      secondarySection: "Bhokardan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhokardan-constituency-results/3255273"
    },
    {
      id: 104,
      constituencyName: "Sillod",
      secondarySection: "Sillod (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sillod-constituency-results/3255274"
    },
    {
      id: 105,
      constituencyName: "Kannad",
      secondarySection: "Kannad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kannad-constituency-results/3255275"
    },
    {
      id: 106,
      constituencyName: "Phulambri",
      secondarySection: "Phulambri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-phulambri-constituency-results/3255276"
    },
    {
      id: 107,
      constituencyName: "Aurangabad Central",
      secondarySection: "Aurangabad Central (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-aurangabad-central-constituency-results/3255277"
    },
    {
      id: 108,
      constituencyName: "Aurangabad West",
      secondarySection: "Aurangabad West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-aurangabad-west-constituency-results/3255278"
    },
    {
      id: 109,
      constituencyName: "Aurangabad East",
      secondarySection: "Aurangabad East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-aurangabad-east-constituency-results/3255279"
    },
    {
      id: 110,
      constituencyName: "Paithan",
      secondarySection: "Paithan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-paithan-constituency-results/3255280"
    },
    {
      id: 111,
      constituencyName: "Gangapur",
      secondarySection: "Gangapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-gangapur-constituency-results/3255281"
    },
    {
      id: 112,
      constituencyName: "Vaijapur",
      secondarySection: "Vaijapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vaijapur-constituency-results/3255282"
    },
    {
      id: 113,
      constituencyName: "Nandgaon",
      secondarySection: "Nandgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nandgaon-constituency-results/3255283"
    },
    {
      id: 114,
      constituencyName: "Malegaon Central",
      secondarySection: "Malegaon Central (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malegaon-central-constituency-results/3255284"
    },
    {
      id: 115,
      constituencyName: "Malegaon Outer",
      secondarySection: "Malegaon Outer (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malegaon-outer-constituency-results/3255285"
    },
    {
      id: 116,
      constituencyName: "Baglan",
      secondarySection: "Baglan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-baglan-constituency-results/3255286"
    },
    {
      id: 117,
      constituencyName: "Kalwan",
      secondarySection: "Kalwan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalwan-constituency-results/3255287"
    },
    {
      id: 118,
      constituencyName: "Chandvad",
      secondarySection: "Chandvad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chandvad-constituency-results/3255288"
    },
    {
      id: 119,
      constituencyName: "Yevla",
      secondarySection: "Yevla (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-yevla-constituency-results/3255289"
    },
    {
      id: 120,
      constituencyName: "Sinnar",
      secondarySection: "Sinnar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sinnar-constituency-results/3255290"
    },
    {
      id: 121,
      constituencyName: "Niphad",
      secondarySection: "Niphad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-niphad-constituency-results/3255291"
    },
    {
      id: 122,
      constituencyName: "Dindori",
      secondarySection: "Dindori (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dindori-constituency-results/3255292"
    },
    {
      id: 123,
      constituencyName: "Nashik East",
      secondarySection: "Nashik East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nashik-east-constituency-results/3255293"
    },
    {
      id: 124,
      constituencyName: "Nashik Central",
      secondarySection: "Nashik Central (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nashik-central-constituency-results/3255294"
    },
    {
      id: 125,
      constituencyName: "Nashik West",
      secondarySection: "Nashik West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nashik-west-constituency-results/3255295"
    },
    {
      id: 126,
      constituencyName: "Deolali",
      secondarySection: "Deolali (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-deolali-constituency-results/3255296"
    },
    {
      id: 127,
      constituencyName: "Igatpuri",
      secondarySection: "Igatpuri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-igatpuri-constituency-results/3255297"
    },
    {
      id: 128,
      constituencyName: "Dahanu",
      secondarySection: "Dahanu (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dahanu-constituency-results/3255298"
    },
    {
      id: 129,
      constituencyName: "Vikramgad",
      secondarySection: "Vikramgad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vikramgad-constituency-results/3255299"
    },
    {
      id: 130,
      constituencyName: "Palghar",
      secondarySection: "Palghar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-palghar-constituency-results/3255300"
    },
    {
      id: 131,
      constituencyName: "Boisar",
      secondarySection: "Boisar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-boisar-constituency-results/3255301"
    },
    {
      id: 132,
      constituencyName: "Nalasopara",
      secondarySection: "Nalasopara (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nalasopara-constituency-results/3255302"
    },
    {
      id: 133,
      constituencyName: "Vasai",
      secondarySection: "Vasai (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vasai-constituency-results/3255303"
    },
    {
      id: 134,
      constituencyName: "Bhiwandi Rural",
      secondarySection: "Bhiwandi Rural (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhiwandi-rural-constituency-results/3255304"
    },
    {
      id: 135,
      constituencyName: "Shahapur",
      secondarySection: "Shahapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shahapur-constituency-results/3255305"
    },
    {
      id: 136,
      constituencyName: "Bhiwandi West",
      secondarySection: "Bhiwandi West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhiwandi-west-constituency-results/3255306"
    },
    {
      id: 137,
      constituencyName: "Bhiwandi East",
      secondarySection: "Bhiwandi East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhiwandi-east-constituency-results/3255307"
    },
    {
      id: 138,
      constituencyName: "Kalyan West",
      secondarySection: "Kalyan West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalyan-west-constituency-results/3255308"
    },
    {
      id: 139,
      constituencyName: "Murbad",
      secondarySection: "Murbad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-murbad-constituency-results/3255309"
    },
    {
      id: 140,
      constituencyName: "Ambarnath",
      secondarySection: "Ambarnath (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ambarnath-constituency-results/3255310"
    },
    {
      id: 141,
      constituencyName: "Ulhasnagar",
      secondarySection: "Ulhasnagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ulhasnagar-constituency-results/3255311"
    },
    {
      id: 142,
      constituencyName: "Kalyan East",
      secondarySection: "Kalyan East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalyan-east-constituency-results/3255312"
    },
    {
      id: 143,
      constituencyName: "Dombivali",
      secondarySection: "Dombivali (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dombivali-constituency-results/3255313"
    },
    {
      id: 144,
      constituencyName: "Kalyan Rural",
      secondarySection: "Kalyan Rural (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalyan-rural-constituency-results/3255314"
    },
    {
      id: 145,
      constituencyName: "Meera Bhayandar",
      secondarySection: "Meera Bhayandar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-meera-bhayandar-constituency-results/3255315"
    },
    {
      id: 146,
      constituencyName: "Ovala - Majiwada",
      secondarySection: "Ovala - Majiwada (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ovala-majiwada-constituency-results/3255316"
    },
    {
      id: 147,
      constituencyName: "Kopri-Pachpakhadi",
      secondarySection: "Kopri-Pachpakhadi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kopri-pachpakhadi-constituency-results/3255317"
    },
    {
      id: 148,
      constituencyName: "Thane",
      secondarySection: "Thane (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-thane-constituency-results/3255318"
    },
    {
      id: 149,
      constituencyName: "Mumbra-Kalwa",
      secondarySection: "Mumbra-Kalwa (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mumbra-kalwa-constituency-results/3255319"
    },
    {
      id: 150,
      constituencyName: "Airoli",
      secondarySection: "Airoli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-airoli-constituency-results/3255320"
    },
    {
      id: 151,
      constituencyName: "Belapur",
      secondarySection: "Belapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-belapur-constituency-results/3255321"
    },
    {
      id: 152,
      constituencyName: "Borivali",
      secondarySection: "Borivali (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-borivali-constituency-results/3255322"
    },
    {
      id: 153,
      constituencyName: "Dahisar",
      secondarySection: "Dahisar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dahisar-constituency-results/3255323"
    },
    {
      id: 154,
      constituencyName: "Magathane",
      secondarySection: "Magathane (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-magathane-constituency-results/3255324"
    },
    {
      id: 155,
      constituencyName: "Mulund",
      secondarySection: "Mulund (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mulund-constituency-results/3255325"
    },
    {
      id: 156,
      constituencyName: "Vikhroli",
      secondarySection: "Vikhroli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vikhroli-constituency-results/3255326"
    },
    {
      id: 157,
      constituencyName: "Bhandup West",
      secondarySection: "Bhandup West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhandup-west-constituency-results/3255327"
    },
    {
      id: 158,
      constituencyName: "Jogeshwari East",
      secondarySection: "Jogeshwari East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jogeshwari-east-constituency-results/3255328"
    },
    {
      id: 159,
      constituencyName: "Dindoshi",
      secondarySection: "Dindoshi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dindoshi-constituency-results/3255329"
    },
    {
      id: 160,
      constituencyName: "Kandivali East",
      secondarySection: "Kandivali East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kandivali-east-constituency-results/3255330"
    },
    {
      id: 161,
      constituencyName: "Charkop",
      secondarySection: "Charkop (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-charkop-constituency-results/3255331"
    },
    {
      id: 162,
      constituencyName: "Malad West",
      secondarySection: "Malad West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malad-west-constituency-results/3255332"
    },
    {
      id: 163,
      constituencyName: "Goregaon",
      secondarySection: "Goregaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-goregaon-constituency-results/3255333"
    },
    {
      id: 164,
      constituencyName: "Versova",
      secondarySection: "Versova (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-versova-constituency-results/3255334"
    },
    {
      id: 165,
      constituencyName: "Andheri West",
      secondarySection: "Andheri West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-andheri-west-constituency-results/3255335"
    },
    {
      id: 166,
      constituencyName: "Andheri East",
      secondarySection: "Andheri East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-andheri-east-constituency-results/3255336"
    },
    {
      id: 167,
      constituencyName: "Vile Parle",
      secondarySection: "Vile Parle (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vile-parle-constituency-results/3255337"
    },
    {
      id: 168,
      constituencyName: "Chandivali",
      secondarySection: "Chandivali (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chandivali-constituency-results/3255338"
    },
    {
      id: 169,
      constituencyName: "Ghatkopar West",
      secondarySection: "Ghatkopar West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ghatkopar-west-constituency-results/3255339"
    },
    {
      id: 170,
      constituencyName: "Ghatkopar East",
      secondarySection: "Ghatkopar East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ghatkopar-east-constituency-results/3255340"
    },
    {
      id: 171,
      constituencyName: "Mankhurd Shivaji Nagar",
      secondarySection: "Mankhurd Shivaji Nagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mankhurd-shivaji-nagar-constituency-results/3255341"
    },
    {
      id: 172,
      constituencyName: "Anushakti Nagar",
      secondarySection: "Anushakti Nagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-anushakti-nagar-constituency-results/3255342"
    },
    {
      id: 173,
      constituencyName: "Chembur",
      secondarySection: "Chembur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chembur-constituency-results/3255343"
    },
    {
      id: 174,
      constituencyName: "Kurla",
      secondarySection: "Kurla (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kurla-constituency-results/3255344"
    },
    {
      id: 175,
      constituencyName: "Kalina",
      secondarySection: "Kalina (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kalina-constituency-results/3255345"
    },
    {
      id: 176,
      constituencyName: "Vandre East",
      secondarySection: "Vandre East (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vandre-east-constituency-results/3255346"
    },
    {
      id: 177,
      constituencyName: "Vandre West",
      secondarySection: "Vandre West (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vandre-west-constituency-results/3255347"
    },
    {
      id: 178,
      constituencyName: "Dharavi",
      secondarySection: "Dharavi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dharavi-constituency-results/3255348"
    },
    {
      id: 179,
      constituencyName: "Sion Koliwada",
      secondarySection: "Sion Koliwada (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sion-koliwada-constituency-results/3255349"
    },
    {
      id: 180,
      constituencyName: "Wadala",
      secondarySection: "Wadala (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-wadala-constituency-results/3255350"
    },
    {
      id: 181,
      constituencyName: "Mahim",
      secondarySection: "Mahim (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mahim-constituency-results/3255351"
    },
    {
      id: 182,
      constituencyName: "Worli",
      secondarySection: "Worli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-worli-constituency-results/3255352"
    },
    {
      id: 183,
      constituencyName: "Shivadi",
      secondarySection: "Shivadi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shivadi-constituency-results/3255353"
    },
    {
      id: 184,
      constituencyName: "Byculla",
      secondarySection: "Byculla (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-byculla-constituency-results/3255354"
    },
    {
      id: 185,
      constituencyName: "Malabar Hill",
      secondarySection: "Malabar Hill (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malabar-hill-constituency-results/3255355"
    },
    {
      id: 186,
      constituencyName: "Mumbadevi",
      secondarySection: "Mumbadevi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mumbadevi-constituency-results/3255356"
    },
    {
      id: 187,
      constituencyName: "Colaba",
      secondarySection: "Colaba (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-colaba-constituency-results/3255357"
    },
    {
      id: 188,
      constituencyName: "Panvel",
      secondarySection: "Panvel (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-panvel-constituency-results/3255359"
    },
    {
      id: 189,
      constituencyName: "Karjat",
      secondarySection: "Karjat (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karjat-constituency-results/3255360"
    },
    {
      id: 190,
      constituencyName: "Uran",
      secondarySection: "Uran (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-uran-constituency-results/3255363"
    },
    {
      id: 191,
      constituencyName: "Pen",
      secondarySection: "Pen (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pen-constituency-results/3255364"
    },
    {
      id: 192,
      constituencyName: "Alibag",
      secondarySection: "Alibag (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-alibag-constituency-results/3255365"
    },
    {
      id: 193,
      constituencyName: "Shrivardhan",
      secondarySection: "Shrivardhan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shrivardhan-constituency-results/3255366"
    },
    {
      id: 194,
      constituencyName: "Mahad",
      secondarySection: "Mahad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mahad-constituency-results/3255367"
    },
    {
      id: 195,
      constituencyName: "Junnar",
      secondarySection: "Junnar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-junnar-constituency-results/3255368"
    },
    {
      id: 196,
      constituencyName: "Ambegaon",
      secondarySection: "Ambegaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ambegaon-constituency-results/3255369"
    },
    {
      id: 197,
      constituencyName: "Khed Alandi",
      secondarySection: "Khed Alandi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-khed-alandi-constituency-results/3255370"
    },
    {
      id: 198,
      constituencyName: "Shirur",
      secondarySection: "Shirur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shirur-constituency-results/3255371"
    },
    {
      id: 199,
      constituencyName: "Daund",
      secondarySection: "Daund (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-daund-constituency-results/3255372"
    },
    {
      id: 200,
      constituencyName: "Indapur",
      secondarySection: "Indapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-indapur-constituency-results/3255373"
    },
    {
      id: 201,
      constituencyName: "Baramati",
      secondarySection: "Baramati (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-baramati-constituency-results/3255374"
    },
    {
      id: 202,
      constituencyName: "Purandar",
      secondarySection: "Purandar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-purandar-constituency-results/3255375"
    },
    {
      id: 203,
      constituencyName: "Bhor",
      secondarySection: "Bhor (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhor-constituency-results/3255376"
    },
    {
      id: 204,
      constituencyName: "Maval",
      secondarySection: "Maval (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-maval-constituency-results/3255377"
    },
    {
      id: 205,
      constituencyName: "Chinchwad",
      secondarySection: "Chinchwad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chinchwad-constituency-results/3255378"
    },
    {
      id: 206,
      constituencyName: "Pimpri",
      secondarySection: "Pimpri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pimpri-constituency-results/3255379"
    },
    {
      id: 207,
      constituencyName: "Bhosari",
      secondarySection: "Bhosari (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-bhosari-constituency-results/3255380"
    },
    {
      id: 208,
      constituencyName: "Vadgaon Sheri",
      secondarySection: "Vadgaon Sheri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-vadgaon-sheri-constituency-results/3255381"
    },
    {
      id: 209,
      constituencyName: "Shivajinagar",
      secondarySection: "Shivajinagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shivajinagar-constituency-results/3255382"
    },
    {
      id: 210,
      constituencyName: "Kothrud",
      secondarySection: "Kothrud (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kothrud-constituency-results/3255383"
    },
    {
      id: 211,
      constituencyName: "Khadakwasala",
      secondarySection: "Khadakwasala (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-khadakwasala-constituency-results/3255384"
    },
    {
      id: 212,
      constituencyName: "Parvati",
      secondarySection: "Parvati (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-parvati-constituency-results/3255385"
    },
    {
      id: 213,
      constituencyName: "Hadapsar",
      secondarySection: "Hadapsar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hadapsar-constituency-results/3255386"
    },
    {
      id: 214,
      constituencyName: "Pune Cantonment",
      secondarySection: "Pune Cantonment (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pune-cantonment-constituency-results/3255387"
    },
    {
      id: 215,
      constituencyName: "Kasbapeth",
      secondarySection: "Kasbapeth (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kasbapeth-constituency-results/3255388"
    },
    {
      id: 216,
      constituencyName: "Akole",
      secondarySection: "Akole (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akole-constituency-results/3255389"
    },
    {
      id: 217,
      constituencyName: "Sangamner",
      secondarySection: "Sangamner (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sangamner-constituency-results/3255390"
    },
    {
      id: 218,
      constituencyName: "Shirdi",
      secondarySection: "Shirdi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shirdi-constituency-results/3255391"
    },
    {
      id: 219,
      constituencyName: "Kopargaon",
      secondarySection: "Kopargaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kopargaon-constituency-results/3255392"
    },
    {
      id: 220,
      constituencyName: "Shrirampur",
      secondarySection: "Shrirampur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shrirampur-constituency-results/3255393"
    },
    {
      id: 221,
      constituencyName: "Nevasa",
      secondarySection: "Nevasa (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nevasa-constituency-results/3255394"
    },
    {
      id: 222,
      constituencyName: "Shevgaon",
      secondarySection: "Shevgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shevgaon-constituency-results/3255395"
    },
    {
      id: 223,
      constituencyName: "Rahuri",
      secondarySection: "Rahuri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-rahuri-constituency-results/3255396"
    },
    {
      id: 224,
      constituencyName: "Parner",
      secondarySection: "Parner (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-parner-constituency-results/3255397"
    },
    {
      id: 225,
      constituencyName: "Ahmednagar City",
      secondarySection: "Ahmednagar City (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ahmednagar-city-constituency-results/3255398"
    },
    {
      id: 226,
      constituencyName: "Shrigonda",
      secondarySection: "Shrigonda (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shrigonda-constituency-results/3255399"
    },
    {
      id: 227,
      constituencyName: "Karjat Jamkhed",
      secondarySection: "Karjat Jamkhed (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karjat-jamkhed-constituency-results/3255400"
    },
    {
      id: 228,
      constituencyName: "Georai",
      secondarySection: "Georai (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-georai-constituency-results/3255401"
    },
    {
      id: 229,
      constituencyName: "Majalgaon",
      secondarySection: "Majalgaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-majalgaon-constituency-results/3255402"
    },
    {
      id: 230,
      constituencyName: "Beed",
      secondarySection: "Beed (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-beed-constituency-results/3255403"
    },
    {
      id: 231,
      constituencyName: "Ashti",
      secondarySection: "Ashti (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ashti-constituency-results/3255404"
    },
    {
      id: 232,
      constituencyName: "Kaij",
      secondarySection: "Kaij (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kaij-constituency-results/3255405"
    },
    {
      id: 233,
      constituencyName: "Parli",
      secondarySection: "Parli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-parli-constituency-results/3255406"
    },
    {
      id: 234,
      constituencyName: "Latur Rural",
      secondarySection: "Latur Rural (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-latur-rural-constituency-results/3255407"
    },
    {
      id: 235,
      constituencyName: "Latur City",
      secondarySection: "Latur City (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-latur-city-constituency-results/3255408"
    },
    {
      id: 236,
      constituencyName: "Ahmadpur",
      secondarySection: "Ahmadpur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ahmadpur-constituency-results/3255409"
    },
    {
      id: 237,
      constituencyName: "Udgir",
      secondarySection: "Udgir (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-udgir-constituency-results/3255410"
    },
    {
      id: 238,
      constituencyName: "Nilanga",
      secondarySection: "Nilanga (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-nilanga-constituency-results/3255411"
    },
    {
      id: 239,
      constituencyName: "Ausa",
      secondarySection: "Ausa (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ausa-constituency-results/3255412"
    },
    {
      id: 240,
      constituencyName: "Umarga",
      secondarySection: "Umarga (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-umarga-constituency-results/3255413"
    },
    {
      id: 241,
      constituencyName: "Tuljapur",
      secondarySection: "Tuljapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-tuljapur-constituency-results/3255414"
    },
    {
      id: 242,
      constituencyName: "Osmanabad",
      secondarySection: "Osmanabad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-osmanabad-constituency-results/3255415"
    },
    {
      id: 243,
      constituencyName: "Paranda",
      secondarySection: "Paranda (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-paranda-constituency-results/3255416"
    },
    {
      id: 244,
      constituencyName: "Karmala",
      secondarySection: "Karmala (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karmala-constituency-results/3255417"
    },
    {
      id: 245,
      constituencyName: "Madha",
      secondarySection: "Madha (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-madha-constituency-results/3255418"
    },
    {
      id: 246,
      constituencyName: "Barshi",
      secondarySection: "Barshi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-barshi-constituency-results/3255419"
    },
    {
      id: 247,
      constituencyName: "Mohol",
      secondarySection: "Mohol (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-mohol-constituency-results/3255420"
    },
    {
      id: 248,
      constituencyName: "Solapur City North",
      secondarySection: "Solapur City North (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-solapur-city-north-constituency-results/3255421"
    },
    {
      id: 249,
      constituencyName: "Solapur City Central",
      secondarySection: "Solapur City Central (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-solapur-city-central-constituency-results/3255422"
    },
    {
      id: 250,
      constituencyName: "Akkalkot",
      secondarySection: "Akkalkot (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-akkalkot-constituency-results/3255423"
    },
    {
      id: 251,
      constituencyName: "Solapur South",
      secondarySection: "Solapur South (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-solapur-south-constituency-results/3255424"
    },
    {
      id: 252,
      constituencyName: "Pandharpur",
      secondarySection: "Pandharpur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-pandharpur-constituency-results/3255425"
    },
    {
      id: 253,
      constituencyName: "Sangola",
      secondarySection: "Sangola (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sangola-constituency-results/3255426"
    },
    {
      id: 254,
      constituencyName: "Malshiras",
      secondarySection: "Malshiras (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-malshiras-constituency-results/3255427"
    },
    {
      id: 255,
      constituencyName: "Phaltan",
      secondarySection: "Phaltan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-phaltan-constituency-results/3255428"
    },
    {
      id: 256,
      constituencyName: "Wai",
      secondarySection: "Wai (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-wai-constituency-results/3255429"
    },
    {
      id: 257,
      constituencyName: "Koregaon",
      secondarySection: "Koregaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-koregaon-constituency-results/3255430"
    },
    {
      id: 258,
      constituencyName: "Man",
      secondarySection: "Man (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-man-constituency-results/3255431"
    },
    {
      id: 259,
      constituencyName: "Karad North",
      secondarySection: "Karad North (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karad-north-constituency-results/3255432"
    },
    {
      id: 260,
      constituencyName: "Karad South",
      secondarySection: "Karad South (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karad-south-constituency-results/3255433"
    },
    {
      id: 261,
      constituencyName: "Patan",
      secondarySection: "Patan (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-patan-constituency-results/3255434"
    },
    {
      id: 262,
      constituencyName: "Satara",
      secondarySection: "Satara (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-satara-constituency-results/3255435"
    },
    {
      id: 263,
      constituencyName: "Dapoli",
      secondarySection: "Dapoli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-dapoli-constituency-results/3255436"
    },
    {
      id: 264,
      constituencyName: "Guhagar",
      secondarySection: "Guhagar (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-guhagar-constituency-results/3255437"
    },
    {
      id: 265,
      constituencyName: "Chiplun",
      secondarySection: "Chiplun (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chiplun-constituency-results/3255438"
    },
    {
      id: 266,
      constituencyName: "Ratnagiri",
      secondarySection: "Ratnagiri (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ratnagiri-constituency-results/3255439"
    },
    {
      id: 267,
      constituencyName: "Rajapur",
      secondarySection: "Rajapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-rajapur-constituency-results/3255440"
    },
    {
      id: 268,
      constituencyName: "Kankavli",
      secondarySection: "Kankavli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kankavli-constituency-results/3255441"
    },
    {
      id: 269,
      constituencyName: "Kudal",
      secondarySection: "Kudal (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kudal-constituency-results/3255442"
    },
    {
      id: 270,
      constituencyName: "Sawantwadi",
      secondarySection: "Sawantwadi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sawantwadi-constituency-results/3255443"
    },
    {
      id: 271,
      constituencyName: "Chandgad",
      secondarySection: "Chandgad (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-chandgad-constituency-results/3255444"
    },
    {
      id: 272,
      constituencyName: "Radhanagari",
      secondarySection: "Radhanagari (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-radhanagari-constituency-results/3255445"
    },
    {
      id: 273,
      constituencyName: "Kagal",
      secondarySection: "Kagal (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kagal-constituency-results/3255446"
    },
    {
      id: 274,
      constituencyName: "Kolhapur South",
      secondarySection: "Kolhapur South (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kolhapur-south-constituency-results/3255447"
    },
    {
      id: 275,
      constituencyName: "Karvir",
      secondarySection: "Karvir (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-karvir-constituency-results/3255448"
    },
    {
      id: 276,
      constituencyName: "Kolhapur North",
      secondarySection: "Kolhapur North (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-kolhapur-north-constituency-results/3255449"
    },
    {
      id: 277,
      constituencyName: "Shahuwadi",
      secondarySection: "Shahuwadi (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shahuwadi-constituency-results/3255450"
    },
    {
      id: 278,
      constituencyName: "Hatkanangle",
      secondarySection: "Hatkanangle (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-hatkanangle-constituency-results/3255451"
    },
    {
      id: 279,
      constituencyName: "Ichalkaranji",
      secondarySection: "Ichalkaranji (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-ichalkaranji-constituency-results/3255452"
    },
    {
      id: 280,
      constituencyName: "Shirol",
      secondarySection: "Shirol (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shirol-constituency-results/3255453"
    },
    {
      id: 281,
      constituencyName: "Miraj",
      secondarySection: "Miraj (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-miraj-constituency-results/3255454"
    },
    {
      id: 282,
      constituencyName: "Sangli",
      secondarySection: "Sangli (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-sangli-constituency-results/3255455"
    },
    {
      id: 283,
      constituencyName: "Islampur",
      secondarySection: "Islampur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-islampur-constituency-results/3255456"
    },
    {
      id: 284,
      constituencyName: "Shirala",
      secondarySection: "Shirala (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-shirala-constituency-results/3255457"
    },
    {
      id: 285,
      constituencyName: "Palus-Kadegaon",
      secondarySection: "Palus-Kadegaon (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-palus-kadegaon-constituency-results/3255458"
    },
    {
      id: 286,
      constituencyName: "Khanapur",
      secondarySection: "Khanapur (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-khanapur-constituency-results/3255459"
    },
    {
      id: 287,
      constituencyName: "Tasgaon-Kavathe Mahankal",
      secondarySection: "Tasgaon-Kavathe Mahankal (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-tasgaon-kavathe-mahankal-constituency-results/3255460"
    },
    {
      id: 288,
      constituencyName: "Jat",
      secondarySection: "Jat (Maharashtra)",
      publishedUrl:
        "https://www.deccanherald.com/elections/maharashtra/maharashtra-assembly-elections-2024-jat-constituency-results/3255461"
    }
  ],
  JHARKHAND: [
    {
      id: 1,
      constituencyName: "Rajmahal",
      secondarySection: "Rajmahal (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-rajmahal-constituency-results/3255081"
    },
    {
      id: 2,
      constituencyName: "Borio",
      secondarySection: "Borio (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-borio-constituency-results/3255089"
    },
    {
      id: 3,
      constituencyName: "Barhait",
      secondarySection: "Barhait (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-barhait-constituency-results/3255090"
    },
    {
      id: 4,
      constituencyName: "Littipara",
      secondarySection: "Littipara (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-littipara-constituency-results/3255091"
    },
    {
      id: 5,
      constituencyName: "Pakur",
      secondarySection: "Pakur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-pakur-constituency-results/3255092"
    },
    {
      id: 6,
      constituencyName: "Maheshpur",
      secondarySection: "Maheshpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-maheshpur-constituency-results/3255093"
    },
    {
      id: 7,
      constituencyName: "Shikaripara",
      secondarySection: "Shikaripara (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-shikaripara-constituency-results/3255094"
    },
    {
      id: 8,
      constituencyName: "Nala",
      secondarySection: "Nala (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-nala-constituency-results/3255095"
    },
    {
      id: 9,
      constituencyName: "Jamtara",
      secondarySection: "Jamtara (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jamtara-constituency-results/3255096"
    },
    {
      id: 10,
      constituencyName: "Dumka",
      secondarySection: "Dumka (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-dumka-constituency-results/3255097"
    },
    {
      id: 11,
      constituencyName: "Jama",
      secondarySection: "Jama (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jama-constituency-results/3255098"
    },
    {
      id: 12,
      constituencyName: "Jarmundi",
      secondarySection: "Jarmundi (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jarmundi-constituency-results/3255099"
    },
    {
      id: 13,
      constituencyName: "Madhupur",
      secondarySection: "Madhupur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-madhupur-constituency-results/3255100"
    },
    {
      id: 14,
      constituencyName: "Sarath",
      secondarySection: "Sarath (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-sarath-constituency-results/3255101"
    },
    {
      id: 15,
      constituencyName: "Deoghar",
      secondarySection: "Deoghar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-deoghar-constituency-results/3255102"
    },
    {
      id: 16,
      constituencyName: "Poreyahat",
      secondarySection: "Poreyahat (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-poreyahat-constituency-results/3255103"
    },
    {
      id: 17,
      constituencyName: "Godda",
      secondarySection: "Godda (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-godda-constituency-results/3255104"
    },
    {
      id: 18,
      constituencyName: "Mahagama",
      secondarySection: "Mahagama (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-mahagama-constituency-results/3255105"
    },
    {
      id: 19,
      constituencyName: "Kodarma",
      secondarySection: "Kodarma (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-kodarma-constituency-results/3255106"
    },
    {
      id: 20,
      constituencyName: "Barkatha",
      secondarySection: "Barkatha (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-barkatha-constituency-results/3255107"
    },
    {
      id: 21,
      constituencyName: "Barhi",
      secondarySection: "Barhi (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-barhi-constituency-results/3255108"
    },
    {
      id: 22,
      constituencyName: "Barkagaon",
      secondarySection: "Barkagaon (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-barkagaon-constituency-results/3255109"
    },
    {
      id: 23,
      constituencyName: "Ramgarh",
      secondarySection: "Ramgarh (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-ramgarh-constituency-results/3255110"
    },
    {
      id: 24,
      constituencyName: "Mandu",
      secondarySection: "Mandu (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-mandu-constituency-results/3255111"
    },
    {
      id: 25,
      constituencyName: "Hazaribagh",
      secondarySection: "Hazaribagh (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-hazaribagh-constituency-results/3255112"
    },
    {
      id: 26,
      constituencyName: "Simaria",
      secondarySection: "Simaria (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-simaria-constituency-results/3255113"
    },
    {
      id: 27,
      constituencyName: "Chatra",
      secondarySection: "Chatra (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-chatra-constituency-results/3255114"
    },
    {
      id: 28,
      constituencyName: "Dhanwar",
      secondarySection: "Dhanwar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-dhanwar-constituency-results/3255115"
    },
    {
      id: 29,
      constituencyName: "Bagodar",
      secondarySection: "Bagodar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bagodar-constituency-results/3255116"
    },
    {
      id: 30,
      constituencyName: "Jamua",
      secondarySection: "Jamua (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jamua-constituency-results/3255117"
    },
    {
      id: 31,
      constituencyName: "Gandey",
      secondarySection: "Gandey (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-gandey-constituency-results/3255118"
    },
    {
      id: 32,
      constituencyName: "Giridih",
      secondarySection: "Giridih (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-giridih-constituency-results/3255119"
    },
    {
      id: 33,
      constituencyName: "Dumri",
      secondarySection: "Dumri (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-dumri-constituency-results/3255120"
    },
    {
      id: 34,
      constituencyName: "Gomia",
      secondarySection: "Gomia (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-gomia-constituency-results/3255121"
    },
    {
      id: 35,
      constituencyName: "Bermo",
      secondarySection: "Bermo (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bermo-constituency-results/3255122"
    },
    {
      id: 36,
      constituencyName: "Bokaro",
      secondarySection: "Bokaro (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bokaro-constituency-results/3255123"
    },
    {
      id: 37,
      constituencyName: "Chandankyari",
      secondarySection: "Chandankyari (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-chandankyari-constituency-results/3255124"
    },
    {
      id: 38,
      constituencyName: "Sindri",
      secondarySection: "Sindri (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-sindri-constituency-results/3255125"
    },
    {
      id: 39,
      constituencyName: "Nirsa",
      secondarySection: "Nirsa (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-nirsa-constituency-results/3255126"
    },
    {
      id: 40,
      constituencyName: "Dhanbad",
      secondarySection: "Dhanbad (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-dhanbad-constituency-results/3255127"
    },
    {
      id: 41,
      constituencyName: "Jharia",
      secondarySection: "Jharia (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jharia-constituency-results/3255128"
    },
    {
      id: 42,
      constituencyName: "Tundi",
      secondarySection: "Tundi (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-tundi-constituency-results/3255129"
    },
    {
      id: 43,
      constituencyName: "Baghmara",
      secondarySection: "Baghmara (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-baghmara-constituency-results/3255130"
    },
    {
      id: 44,
      constituencyName: "Baharagora",
      secondarySection: "Baharagora (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-baharagora-constituency-results/3255133"
    },
    {
      id: 45,
      constituencyName: "Ghatsila",
      secondarySection: "Ghatsila (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-ghatsila-constituency-results/3255134"
    },
    {
      id: 46,
      constituencyName: "Potka",
      secondarySection: "Potka (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-potka-constituency-results/3255135"
    },
    {
      id: 47,
      constituencyName: "Jugsalai",
      secondarySection: "Jugsalai (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jugsalai-constituency-results/3255136"
    },
    {
      id: 48,
      constituencyName: "Jamshedpur East",
      secondarySection: "Jamshedpur East (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jamshedpur-east-constituency-results/3255137"
    },
    {
      id: 49,
      constituencyName: "Jamshedpur West",
      secondarySection: "Jamshedpur West (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jamshedpur-west-constituency-results/3255138"
    },
    {
      id: 50,
      constituencyName: "Ichagarh",
      secondarySection: "Ichagarh (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-ichagarh-constituency-results/3255139"
    },
    {
      id: 51,
      constituencyName: "Saraikella",
      secondarySection: "Saraikella (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-saraikella-constituency-results/3255140"
    },
    {
      id: 52,
      constituencyName: "Chaibasa",
      secondarySection: "Chaibasa (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-chaibasa-constituency-results/3255141"
    },
    {
      id: 53,
      constituencyName: "Majhganon",
      secondarySection: "Majhganon (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-majhganon-constituency-results/3255143"
    },
    {
      id: 54,
      constituencyName: "Jagannathpur",
      secondarySection: "Jagannathpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-jagannathpur-constituency-results/3255144"
    },
    {
      id: 55,
      constituencyName: "Manoharpur",
      secondarySection: "Manoharpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-manoharpur-constituency-results/3255145"
    },
    {
      id: 56,
      constituencyName: "Chakradharpur",
      secondarySection: "Chakradharpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-chakradharpur-constituency-results/3255146"
    },
    {
      id: 57,
      constituencyName: "Kharasawan",
      secondarySection: "Kharasawan (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-kharasawan-constituency-results/3255147"
    },
    {
      id: 58,
      constituencyName: "Tamar",
      secondarySection: "Tamar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-tamar-constituency-results/3255148"
    },
    {
      id: 59,
      constituencyName: "Torpa",
      secondarySection: "Torpa (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-torpa-constituency-results/3255149"
    },
    {
      id: 60,
      constituencyName: "Khunti",
      secondarySection: "Khunti (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-khunti-constituency-results/3255150"
    },
    {
      id: 61,
      constituencyName: "Silli",
      secondarySection: "Silli (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-silli-constituency-results/3255151"
    },
    {
      id: 62,
      constituencyName: "Khijri",
      secondarySection: "Khijri (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-khijri-constituency-results/3255152"
    },
    {
      id: 63,
      constituencyName: "Ranchi",
      secondarySection: "Ranchi (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-ranchi-constituency-results/3255153"
    },
    {
      id: 64,
      constituencyName: "Hatia",
      secondarySection: "Hatia (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-hatia-constituency-results/3255154"
    },
    {
      id: 65,
      constituencyName: "Kanke",
      secondarySection: "Kanke (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-kanke-constituency-results/3255155"
    },
    {
      id: 66,
      constituencyName: "Mandar",
      secondarySection: "Mandar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-mandar-constituency-results/3255156"
    },
    {
      id: 67,
      constituencyName: "Sisai",
      secondarySection: "Sisai (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-sisai-constituency-results/3255157"
    },
    {
      id: 68,
      constituencyName: "Gumla",
      secondarySection: "Gumla (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-gumla-constituency-results/3255158"
    },
    {
      id: 69,
      constituencyName: "Bishunpur",
      secondarySection: "Bishunpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bishunpur-constituency-results/3255159"
    },
    {
      id: 70,
      constituencyName: "Simdega",
      secondarySection: "Simdega (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-simdega-constituency-results/3255160"
    },
    {
      id: 71,
      constituencyName: "Kolebira",
      secondarySection: "Kolebira (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-kolebira-constituency-results/3255161"
    },
    {
      id: 72,
      constituencyName: "Lohardaga",
      secondarySection: "Lohardaga (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-lohardaga-constituency-results/3255162"
    },
    {
      id: 73,
      constituencyName: "Manika",
      secondarySection: "Manika (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-manika-constituency-results/3255163"
    },
    {
      id: 74,
      constituencyName: "Latehar",
      secondarySection: "Latehar (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-latehar-constituency-results/3255164"
    },
    {
      id: 75,
      constituencyName: "Panki",
      secondarySection: "Panki (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-panki-constituency-results/3255165"
    },
    {
      id: 76,
      constituencyName: "Daltonganj",
      secondarySection: "Daltonganj (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-daltonganj-constituency-results/3255166"
    },
    {
      id: 77,
      constituencyName: "Bishrampur",
      secondarySection: "Bishrampur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bishrampur-constituency-results/3255167"
    },
    {
      id: 78,
      constituencyName: "Chattarpur",
      secondarySection: "Chattarpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-chattarpur-constituency-results/3255168"
    },
    {
      id: 79,
      constituencyName: "Hussainabad",
      secondarySection: "Hussainabad (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-hussainabad-constituency-results/3255169"
    },
    {
      id: 80,
      constituencyName: "Garhwa",
      secondarySection: "Garhwa (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-garhwa-constituency-results/3255170"
    },
    {
      id: 81,
      constituencyName: "Bhawanathpur",
      secondarySection: "Bhawanathpur (Jharkhand)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jharkhand/jharkhand-assembly-elections-2024-bhawanathpur-constituency-results/3255171"
    }
  ],
  HARYANA: [
    {
      id: 1,
      constituencyName: "Kalka",
      secondarySection: "Kalka (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kalka-constituency-result-3214573"
    },
    {
      id: 2,
      constituencyName: "Panchkula",
      secondarySection: "Panchkula (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-panchkula-constituency-result-3214574"
    },
    {
      id: 3,
      constituencyName: "Naraingarh",
      secondarySection: "Naraingarh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-naraingarh-constituency-result-3214575"
    },
    {
      id: 4,
      constituencyName: "Ambala Cantt.",
      secondarySection: "Ambala Cantt. (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ambala-cantt-constituency-result-3214576"
    },
    {
      id: 5,
      constituencyName: "Ambala City",
      secondarySection: "Ambala City (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ambala-city-constituency-result-3214577"
    },
    {
      id: 6,
      constituencyName: "Mulana (SC)",
      secondarySection: "Mulana (SC)(HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-mulana-sc-constituency-result-3214578"
    },
    {
      id: 7,
      constituencyName: "Sadhaura (SC)",
      secondarySection: "Sadhaura (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-sadhaura-sc-constituency-result-3214579"
    },
    {
      id: 8,
      constituencyName: "Jagadhri",
      secondarySection: "Jagadhri (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-jagadhri-constituency-result-3214580"
    },
    {
      id: 9,
      constituencyName: "Yamunanagar",
      secondarySection: "Yamunanagar (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-yamunanagar-constituency-result-3214581"
    },
    {
      id: 10,
      constituencyName: "Radaur",
      secondarySection: "Radaur (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-radaur-constituency-result-3214582"
    },
    {
      id: 11,
      constituencyName: "Ladwa",
      secondarySection: "Ladwa (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ladwa-constituency-result-3214583"
    },
    {
      id: 12,
      constituencyName: "Shahbad",
      secondarySection: "Shahbad (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-shahbad-constituency-result-3214584"
    },
    {
      id: 13,
      constituencyName: "Thanesar",
      secondarySection: "Thanesar (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-thanesar-constituency-result-3214585"
    },
    {
      id: 14,
      constituencyName: "Pehowa",
      secondarySection: "Pehowa (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-pehowa-constituency-result-3214586"
    },
    {
      id: 15,
      constituencyName: "Guhla (SC)",
      secondarySection: "Guhla (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-guhla-sc-constituency-result-3214587"
    },
    {
      id: 16,
      constituencyName: "Kalayat",
      secondarySection: "Kalayat (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kalayat-constituency-result-3214588"
    },
    {
      id: 17,
      constituencyName: "Kaithal",
      secondarySection: "Kaithal (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kaithal-constituency-result-3214589"
    },
    {
      id: 18,
      constituencyName: "Pundri",
      secondarySection: "Pundri (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-pundri-constituency-result-3214590"
    },
    {
      id: 19,
      constituencyName: "Nilokheri (SC)",
      secondarySection: "Nilokheri (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-nilokheri-sc-constituency-result-3214591"
    },
    {
      id: 20,
      constituencyName: "Indri",
      secondarySection: "Indri (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-indri-constituency-result-3214592"
    },
    {
      id: 21,
      constituencyName: "Karnal",
      secondarySection: "Karnal (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-karnal-constituency-result-3214593"
    },
    {
      id: 22,
      constituencyName: "Gharaunda",
      secondarySection: "Gharaunda (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-gharaunda-constituency-result-3214594"
    },
    {
      id: 23,
      constituencyName: "Assandh",
      secondarySection: "Assandh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-assandh-constituency-result-3214595"
    },
    {
      id: 24,
      constituencyName: "Panipat Rural",
      secondarySection: "Panipat Rural (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-panipat-rural-constituency-result-3214596"
    },
    {
      id: 25,
      constituencyName: "Panipat City",
      secondarySection: "Panipat City (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-panipat-city-constituency-result-3214597"
    },
    {
      id: 26,
      constituencyName: "Israna (SC)",
      secondarySection: "Israna (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-israna-sc-constituency-result-3214598"
    },
    {
      id: 27,
      constituencyName: "Samalkha",
      secondarySection: "Samalkha (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-samalkha-constituency-result-3214599"
    },
    {
      id: 28,
      constituencyName: "Ganaur",
      secondarySection: "Ganaur (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ganaur-constituency-result-3214600"
    },
    {
      id: 29,
      constituencyName: "Rai",
      secondarySection: "Rai (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-rai-constituency-result-3214601"
    },
    {
      id: 30,
      constituencyName: "Kharkhauda (SC)",
      secondarySection: "Kharkhauda (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kharkhauda-sc-constituency-result-3214602"
    },
    {
      id: 31,
      constituencyName: "Sonipat",
      secondarySection: "Sonipat (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-sonipat-constituency-result-3214603"
    },
    {
      id: 32,
      constituencyName: "Gohana",
      secondarySection: "Gohana (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-gohana-constituency-result-3214604"
    },
    {
      id: 33,
      constituencyName: "Baroda",
      secondarySection: "Baroda (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-baroda-constituency-result-3214605"
    },
    {
      id: 34,
      constituencyName: "Julana",
      secondarySection: "Julana (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-julana-constituency-result-3214606"
    },
    {
      id: 35,
      constituencyName: "Safidon",
      secondarySection: "Safidon (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-safidon-constituency-result-3214607"
    },
    {
      id: 36,
      constituencyName: "Jind",
      secondarySection: "Jind (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-jind-constituency-result-3214608"
    },
    {
      id: 37,
      constituencyName: "Uchana Kalan",
      secondarySection: "Uchana Kalan (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-uchana-kalan-constituency-result-3214609"
    },
    {
      id: 38,
      constituencyName: "Narwana (SC)",
      secondarySection: "Narwana (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-narwana-sc-constituency-result-3214610"
    },
    {
      id: 39,
      constituencyName: "Tohana",
      secondarySection: "Tohana (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-tohana-constituency-result-3214611"
    },
    {
      id: 40,
      constituencyName: "Fatehabad",
      secondarySection: "Fatehabad (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-fatehabad-constituency-result-3214612"
    },
    {
      id: 41,
      constituencyName: "Ratia (SC)",
      secondarySection: "Ratia (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ratia-sc-constituency-result-3214613"
    },
    {
      id: 42,
      constituencyName: "Kalawali (SC)",
      secondarySection: "Kalawali (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kalawali-sc-constituency-result-3214614"
    },
    {
      id: 43,
      constituencyName: "Dabwali",
      secondarySection: "Dabwali (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-dabwali-constituency-result-3214615"
    },
    {
      id: 44,
      constituencyName: "Rania",
      secondarySection: "Rania (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-rania-constituency-result-3214616"
    },
    {
      id: 45,
      constituencyName: "Sirsa",
      secondarySection: "Sirsa (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-sirsa-constituency-result-3214617"
    },
    {
      id: 46,
      constituencyName: "Ellenabad",
      secondarySection: "Ellenabad (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ellenabad-constituency-result-3214618"
    },
    {
      id: 47,
      constituencyName: "Adampur",
      secondarySection: "Adampur (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-adampur-constituency-result-3214619"
    },
    {
      id: 48,
      constituencyName: "Uklana (SC)",
      secondarySection: "Uklana (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-uklana-sc-constituency-result-3214620"
    },
    {
      id: 49,
      constituencyName: "Narnaund",
      secondarySection: "Narnaund (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-narnaund-constituency-result-3214621"
    },
    {
      id: 50,
      constituencyName: "Hansi",
      secondarySection: "Hansi (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-hansi-constituency-result-3214622"
    },
    {
      id: 51,
      constituencyName: "Barwala",
      secondarySection: "Barwala (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-barwala-constituency-result-3214623"
    },
    {
      id: 52,
      constituencyName: "Hisar",
      secondarySection: "Hisar (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-hisar-constituency-result-3214624"
    },
    {
      id: 53,
      constituencyName: "Nalwa",
      secondarySection: "Nalwa (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-nalwa-constituency-result-3214625"
    },
    {
      id: 54,
      constituencyName: "Loharu",
      secondarySection: "Loharu (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-loharu-constituency-result-3214626"
    },
    {
      id: 55,
      constituencyName: "Badhra",
      secondarySection: "Badhra (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-badhra-constituency-result-3214627"
    },
    {
      id: 56,
      constituencyName: "Dadri",
      secondarySection: "Dadri (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-dadri-constituency-result-3214628"
    },
    {
      id: 57,
      constituencyName: "Bhiwani",
      secondarySection: "Bhiwani (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-bhiwani-constituency-result-3214629"
    },
    {
      id: 58,
      constituencyName: "Tosham",
      secondarySection: "Tosham (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-tosham-constituency-result-3214630"
    },
    {
      id: 59,
      constituencyName: "Bawani Khera (SC)",
      secondarySection: "Bawani Khera (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-bawani-khera-sc-constituency-result-3214631"
    },
    {
      id: 60,
      constituencyName: "Meham",
      secondarySection: "Meham (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-meham-constituency-result-3214632"
    },
    {
      id: 61,
      constituencyName: "Garhi Sampla-Kiloi",
      secondarySection: "Garhi Sampla-Kiloi (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-garhi-sampla-kiloi-constituency-result-3214633"
    },
    {
      id: 62,
      constituencyName: "Rohtak",
      secondarySection: "Rohtak (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-rohtak-constituency-result-3214634"
    },
    {
      id: 63,
      constituencyName: "Kalanaur (SC)",
      secondarySection: "Kalanaur (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kalanaur-sc-constituency-result-3214635"
    },
    {
      id: 64,
      constituencyName: "Bahadurgarh",
      secondarySection: "Bahadurgarh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-bahadurgarh-constituency-result-3214636"
    },
    {
      id: 65,
      constituencyName: "Badli",
      secondarySection: "Badli (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-badli-constituency-result-3214637"
    },
    {
      id: 66,
      constituencyName: "Jhajjar (SC)",
      secondarySection: "Jhajjar (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-jhajjar-sc-constituency-result-3214638"
    },
    {
      id: 67,
      constituencyName: "Beri",
      secondarySection: "Beri (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-beri-constituency-result-3214639"
    },
    {
      id: 68,
      constituencyName: "Ateli",
      secondarySection: "Ateli (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ateli-constituency-result-3214640"
    },
    {
      id: 69,
      constituencyName: "Mahendragarh",
      secondarySection: "Mahendragarh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-mahendragarh-constituency-result-3214641"
    },
    {
      id: 70,
      constituencyName: "Narnaul",
      secondarySection: "Narnaul (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-narnaul-constituency-result-3214642"
    },
    {
      id: 71,
      constituencyName: "Nangal Chaudhry",
      secondarySection: "Nangal Chaudhry (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-nangal-chaudhry-constituency-result-3214643"
    },
    {
      id: 72,
      constituencyName: "Bawal (SC)",
      secondarySection: "Bawal (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-bawal-sc-constituency-result-3214644"
    },
    {
      id: 73,
      constituencyName: "Kosli",
      secondarySection: "Kosli (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-kosli-constituency-result-3214645"
    },
    {
      id: 74,
      constituencyName: "Rewari",
      secondarySection: "Rewari (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-rewari-constituency-result-3214646"
    },
    {
      id: 75,
      constituencyName: "Pataudi (SC)",
      secondarySection: "Pataudi (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-pataudi-sc-constituency-result-3214647"
    },
    {
      id: 76,
      constituencyName: "Badshahpur",
      secondarySection: "Badshahpur (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-badshahpur-constituency-result-3214648"
    },
    {
      id: 77,
      constituencyName: "Gurgaon",
      secondarySection: "Gurgaon (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-gurgaon-constituency-result-3214649"
    },
    {
      id: 78,
      constituencyName: "Sohna",
      secondarySection: "Sohna (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-sohna-constituency-result-3214650"
    },
    {
      id: 79,
      constituencyName: "Nuh",
      secondarySection: "Nuh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-nuh-constituency-result-3214651"
    },
    {
      id: 80,
      constituencyName: "Ferozepur Jhirka",
      secondarySection: "Ferozepur Jhirka (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ferozepur-jhirka-constituency-result-3214652"
    },
    {
      id: 81,
      constituencyName: "Punahana",
      secondarySection: "Punahana (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-punahana-constituency-result-3214653"
    },
    {
      id: 82,
      constituencyName: "Hathin",
      secondarySection: "Hathin (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-hathin-constituency-result-3214654"
    },
    {
      id: 83,
      constituencyName: "Hodal (SC)",
      secondarySection: "Hodal (SC) (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-hodal-sc-constituency-result-3214655"
    },
    {
      id: 84,
      constituencyName: "Palwal",
      secondarySection: "Palwal (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-palwal-constituency-result-3214656"
    },
    {
      id: 85,
      constituencyName: "Prithla",
      secondarySection: "Prithla (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-prithla-constituency-result-3214657"
    },
    {
      id: 86,
      constituencyName: "Faridabad Nit",
      secondarySection: "Faridabad Nit (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-faridabad-nit-constituency-result-3214658"
    },
    {
      id: 87,
      constituencyName: "Badkhal",
      secondarySection: "Badkhal (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-badkhal-constituency-result-3214659"
    },
    {
      id: 88,
      constituencyName: "Ballabhgarh",
      secondarySection: "Ballabhgarh (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-ballabhgarh-constituency-result-3214660"
    },
    {
      id: 89,
      constituencyName: "Faridabad",
      secondarySection: "Faridabad (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-faridabad-constituency-result-3214661"
    },
    {
      id: 90,
      constituencyName: "Tigaon",
      secondarySection: "Tigaon (HARYANA)",
      publishedUrl:
        "https://www.deccanherald.com/elections/haryana/haryana-assembly-elections-2024-tigaon-constituency-result-3214555"
    }
  ],
  "J&K": [
    {
      id: 91,
      constituencyName: "Karnah",
      secondarySection: "Karnah (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-karnah-constituency-result-3214666"
    },
    {
      id: 92,
      constituencyName: "Trehgam",
      secondarySection: "Trehgam (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-trehgam-constituency-result-3214667"
    },
    {
      id: 93,
      constituencyName: "Kupwara",
      secondarySection: "Kupwara (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kupwara-constituency-result-3214668"
    },
    {
      id: 94,
      constituencyName: "Lolab",
      secondarySection: "Lolab (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-lolab-constituency-result-3214669"
    },
    {
      id: 95,
      constituencyName: "Handwara",
      secondarySection: "Handwara (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-handwara-constituency-result-3214670"
    },
    {
      id: 96,
      constituencyName: "Langate",
      secondarySection: "Langate (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-langate-constituency-result-3214671"
    },
    {
      id: 97,
      constituencyName: "Sopore",
      secondarySection: "Sopore (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-sopore-constituency-result-3214672"
    },
    {
      id: 98,
      constituencyName: "Rafiabad",
      secondarySection: "Rafiabad (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-rafiabad-constituency-result-3214673"
    },
    {
      id: 99,
      constituencyName: "Uri",
      secondarySection: "Uri (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-uri-constituency-result-3214674"
    },
    {
      id: 100,
      constituencyName: "Baramulla",
      secondarySection: "Baramulla (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-baramulla-constituency-result-3214675"
    },
    {
      id: 101,
      constituencyName: "Gulmarg",
      secondarySection: "Gulmarg (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-gulmarg-constituency-result-3214676"
    },
    {
      id: 102,
      constituencyName: "Wagoora – Kreeri",
      secondarySection: "Wagoora – Kreeri (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-wagoora-kreeri-constituency-result-3214677"
    },
    {
      id: 103,
      constituencyName: "Pattan",
      secondarySection: "Pattan (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-pattan-constituency-result-3214678"
    },
    {
      id: 104,
      constituencyName: "Sonawari",
      secondarySection: "Sonawari (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-sonawari-constituency-result-3214679"
    },
    {
      id: 105,
      constituencyName: "Bandipora",
      secondarySection: "Bandipora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-bandipora-constituency-result-3214680"
    },
    {
      id: 106,
      constituencyName: "Gurez (ST)",
      secondarySection: "Gurez (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-gurez-st-constituency-result-3214681"
    },
    {
      id: 107,
      constituencyName: "Kangan (ST)",
      secondarySection: "Kangan (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kangan-st-constituency-result-3214682"
    },
    {
      id: 108,
      constituencyName: "Ganderbal",
      secondarySection: "Ganderbal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-ganderbal-constituency-result-3214683"
    },
    {
      id: 109,
      constituencyName: "Hazratbal",
      secondarySection: "Hazratbal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-hazratbal-constituency-result-3214684"
    },
    {
      id: 110,
      constituencyName: "Khanyar",
      secondarySection: "Khanyar (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-khanyar-constituency-result-3214685"
    },
    {
      id: 111,
      constituencyName: "Habbakadal",
      secondarySection: "Habbakadal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-habbakadal-constituency-result-3214686"
    },
    {
      id: 112,
      constituencyName: "Lal Chowk",
      secondarySection: "Lal Chowk (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-lal-chowk-constituency-result-3214687"
    },
    {
      id: 113,
      constituencyName: "Chanapora",
      secondarySection: "Chanapora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-chanapora-constituency-result-3214688"
    },
    {
      id: 114,
      constituencyName: "Zadibal",
      secondarySection: "Zadibal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-zadibal-constituency-result-3214689"
    },
    {
      id: 115,
      constituencyName: "Eidgah",
      secondarySection: "Eidgah (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-eidgah-constituency-result-3214690"
    },
    {
      id: 116,
      constituencyName: "Central Shalteng",
      secondarySection: "Central Shalteng (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-central-shalteng-constituency-result-3214691"
    },
    {
      id: 117,
      constituencyName: "Budgam",
      secondarySection: "Budgam (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-budgam-constituency-result-3214692"
    },
    {
      id: 118,
      constituencyName: "Beerwah",
      secondarySection: "Beerwah (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-beerwah-constituency-result-3214693"
    },
    {
      id: 119,
      constituencyName: "Khansahib",
      secondarySection: "Khansahib (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-khansahib-constituency-result-3214694"
    },
    {
      id: 120,
      constituencyName: "Chrar-i-Sharief",
      secondarySection: "Chrar-i-Sharief (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-chrar-i-sharief-constituency-result-3214695"
    },
    {
      id: 121,
      constituencyName: "Chadoora",
      secondarySection: "Chadoora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-chadoora-constituency-result-3214696"
    },
    {
      id: 122,
      constituencyName: "Pampore",
      secondarySection: "Pampore (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-pampore-constituency-result-3214697"
    },
    {
      id: 123,
      constituencyName: "Tral",
      secondarySection: "Tral (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-tral-constituency-result-3214698"
    },
    {
      id: 124,
      constituencyName: "Pulwama",
      secondarySection: "Pulwama (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-pulwama-constituency-result-3214699"
    },
    {
      id: 125,
      constituencyName: "Rajpora",
      secondarySection: "Rajpora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-rajpora-constituency-result-3214700"
    },
    {
      id: 126,
      constituencyName: "Zainapora",
      secondarySection: "Zainapora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-zainapora-constituency-result-3214701"
    },
    {
      id: 127,
      constituencyName: "Shopian",
      secondarySection: "Shopian (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-shopian-constituency-result-3214702"
    },
    {
      id: 128,
      constituencyName: "D.H. Pora",
      secondarySection: "D.H. Pora (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-dh-pora-constituency-result-3214703"
    },
    {
      id: 129,
      constituencyName: "Kulgam",
      secondarySection: "Kulgam (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kulgam-constituency-result-3214704"
    },
    {
      id: 130,
      constituencyName: "Devsar",
      secondarySection: "Devsar (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-devsar-constituency-result-3214705"
    },
    {
      id: 131,
      constituencyName: "Dooru",
      secondarySection: "Dooru (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-dooru-constituency-result-3214706"
    },
    {
      id: 132,
      constituencyName: "Kokernag (ST)",
      secondarySection: "Kokernag (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kokernag-st-constituency-result-3214707"
    },
    {
      id: 133,
      constituencyName: "Anantnag West",
      secondarySection: "Anantnag West (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-anantnag-west-constituency-result-3214708"
    },
    {
      id: 134,
      constituencyName: "Anantnag",
      secondarySection: "Anantnag (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-anantnag-constituency-result-3214709"
    },
    {
      id: 135,
      constituencyName: "Srigufwara - Bijbehara",
      secondarySection: "Srigufwara - Bijbehara (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-srigufwara-bijbehara-constituency-result-3214710"
    },
    {
      id: 136,
      constituencyName: "Shangus - Anantnag East",
      secondarySection: "Shangus - Anantnag East (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-shangus-anantnag-east-constituency-result-3214711"
    },
    {
      id: 137,
      constituencyName: "Pahalgam",
      secondarySection: "Pahalgam (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-pahalgam-constituency-result-3214712"
    },
    {
      id: 138,
      constituencyName: "Inderwal",
      secondarySection: "Inderwal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-inderwal-constituency-result-3214713"
    },
    {
      id: 139,
      constituencyName: "Kishtwar",
      secondarySection: "Kishtwar (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kishtwar-constituency-result-3214714"
    },
    {
      id: 140,
      constituencyName: "Padder-Nagseni",
      secondarySection: "Padder-Nagseni (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-padder-nagseni-constituency-result-3214715"
    },
    {
      id: 141,
      constituencyName: "Bhadarwah",
      secondarySection: "Bhadarwah (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-bhadarwah-constituency-result-3214716"
    },
    {
      id: 142,
      constituencyName: "Doda",
      secondarySection: "Doda (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-doda-constituency-result-3214717"
    },
    {
      id: 143,
      constituencyName: "Doda West",
      secondarySection: "Doda West (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-doda-west-constituency-result-3214718"
    },
    {
      id: 144,
      constituencyName: "Ramban",
      secondarySection: "Ramban (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-ramban-constituency-result-3214719"
    },
    {
      id: 145,
      constituencyName: "Banihal",
      secondarySection: "Banihal (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-banihal-constituency-result-3214720"
    },
    {
      id: 146,
      constituencyName: "Gulabgarh (ST)",
      secondarySection: "Gulabgarh (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-gulabgarh-st-constituency-result-3214721"
    },
    {
      id: 147,
      constituencyName: "Reasi",
      secondarySection: "Reasi (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-reasi-constituency-result-3214722"
    },
    {
      id: 148,
      constituencyName: "Shri Mata Vaishno Devi",
      secondarySection: "Shri Mata Vaishno Devi (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-shri-mata-vaishno-devi-constituency-result-3214723"
    },
    {
      id: 149,
      constituencyName: "Udhampur West",
      secondarySection: "Udhampur West (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-udhampur-west-constituency-result-3214724"
    },
    {
      id: 150,
      constituencyName: "Udhampur East",
      secondarySection: "Udhampur East (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-udhampur-east-constituency-result-3214725"
    },
    {
      id: 151,
      constituencyName: "Chenani",
      secondarySection: "Chenani (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-chenani-constituency-result-3214726"
    },
    {
      id: 152,
      constituencyName: "Ramnagar (SC)",
      secondarySection: "Ramnagar (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-ramnagar-sc-constituency-result-3214727"
    },
    {
      id: 153,
      constituencyName: "Bani",
      secondarySection: "Bani (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-bani-constituency-result-3214728"
    },
    {
      id: 154,
      constituencyName: "Billawar",
      secondarySection: "Billawar (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-billawar-constituency-result-3214729"
    },
    {
      id: 155,
      constituencyName: "Basohli",
      secondarySection: "Basohli (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-basohli-constituency-result-3214730"
    },
    {
      id: 156,
      constituencyName: "Jasrota",
      secondarySection: "Jasrota (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-jasrota-constituency-result-3214731"
    },
    {
      id: 157,
      constituencyName: "Kathua (SC)",
      secondarySection: "Kathua (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kathua-sc-constituency-result-3214732"
    },
    {
      id: 158,
      constituencyName: "Hiranagar",
      secondarySection: "Hiranagar (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-hiranagar-constituency-result-3214733"
    },
    {
      id: 159,
      constituencyName: "Ramgarh (SC)",
      secondarySection: "Ramgarh (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-ramgarh-sc-constituency-result-3214734"
    },
    {
      id: 160,
      constituencyName: "Samba",
      secondarySection: "Samba (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-samba-constituency-result-3214735"
    },
    {
      id: 161,
      constituencyName: "Vijaypur",
      secondarySection: "Vijaypur (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-vijaypur-constituency-result-3214736"
    },
    {
      id: 162,
      constituencyName: "Bishnah (SC)",
      secondarySection: "Bishnah (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-bishnah-sc-constituency-result-3214737"
    },
    {
      id: 163,
      constituencyName: "Suchetgarh (SC)",
      secondarySection: "Suchetgarh (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-suchetgarh-sc-constituency-result-3214738"
    },
    {
      id: 164,
      constituencyName: "R.S. Pura - Jammu South",
      secondarySection: "R.S. Pura - Jammu South (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-rs-pura-jammu-south-constituency-result-3214739"
    },
    {
      id: 165,
      constituencyName: "Bahu",
      secondarySection: "Bahu (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-bahu-constituency-result-3214740"
    },
    {
      id: 166,
      constituencyName: "Jammu East",
      secondarySection: "Jammu East (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-jammu-east-constituency-result-3214741"
    },
    {
      id: 167,
      constituencyName: "Nagrota",
      secondarySection: "Nagrota (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-nagrota-constituency-result-3214742"
    },
    {
      id: 168,
      constituencyName: "Jammu West",
      secondarySection: "Jammu West  (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-jammu-west-constituency-result-3214743"
    },
    {
      id: 169,
      constituencyName: "Jammu North",
      secondarySection: "Jammu North (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-jammu-north-constituency-result-3214744"
    },
    {
      id: 170,
      constituencyName: "Marh (SC)",
      secondarySection: "Marh (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-marh-sc-constituency-result-3214745"
    },
    {
      id: 171,
      constituencyName: "Akhnoor (SC)",
      secondarySection: "Akhnoor (SC) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-akhnoor-sc-constituency-result-3214746"
    },
    {
      id: 172,
      constituencyName: "Chhamb",
      secondarySection: "Chhamb (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-chhamb-constituency-result-3214747"
    },
    {
      id: 173,
      constituencyName: "Kalakote - Sunderbani",
      secondarySection: "Kalakote - Sunderbani (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-kalakote-sunderbani-constituency-result-3214748"
    },
    {
      id: 174,
      constituencyName: "Nowshera",
      secondarySection: "Nowshera (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-nowshera-constituency-result-3214749"
    },
    {
      id: 175,
      constituencyName: "Rajouri (ST)",
      secondarySection: "Rajouri (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-rajouri-st-constituency-result-3214750"
    },
    {
      id: 176,
      constituencyName: "Budhal (ST)",
      secondarySection: "Budhal (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-budhal-st-constituency-result-3214751"
    },
    {
      id: 177,
      constituencyName: "Thannamandi (ST)",
      secondarySection: "Thannamandi (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-thannamandi-st-constituency-result-3214752"
    },
    {
      id: 178,
      constituencyName: "Surankote (ST)",
      secondarySection: "Surankote (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-surankote-st-constituency-result-3214753"
    },
    {
      id: 179,
      constituencyName: "Poonch Haveli",
      secondarySection: "Poonch Haveli (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-poonch-haveli-constituency-result-3214754"
    },
    {
      id: 180,
      constituencyName: "Mendhar (ST)",
      secondarySection: "Mendhar (ST) (J&K)",
      publishedUrl:
        "https://www.deccanherald.com/elections/jammu-and-kashmir/jammu-and-kashmir-assembly-elections-2024-mendhar-st-constituency-result-3214755"
    }
  ]
};
const assemblyElection2024Records = [];
Object.keys(assemblyElection2024ConstituencyData).forEach((item) => {
  assemblyElection2024Records.push(...assemblyElection2024ConstituencyData[item]);
});

export {
  lokSabhaElectionData2024,
  lokSabhaElectionData2024AllRecords,
  lokSabhaElectionData2024StateSlugData,
  stateElections2024SlugData,
  stateElections2024ConstituencyData,
  stateElections2024AllRecords,
  assemblyElection2024Records,
  assemblyElection2024ConstituencyData,
  assemblyElection2024SlugData,
  assemblyElection2024SlugData_JK_HR,
  assemblyElection2024SlugData_Delhi,
  assemblyElection2025SlugData_Bihar
};
